{
  "app": {
    "language": "Language",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "brandLogoAlt": "BCS HR Software",
    "footerAdmin": "BCS Learning — Admin",
    "footerTenant": "BCS Learning — {tenant}",
    "footerTenantFallback": "BCS Learning",
    "superadmin": {
      "title": "Superadmin"
    },
    "tenant": {
      "title": "Your workspace"
    }
  },
  "nav": {
    "catalog": "Catalogue",
    "myEnrollments": "My enrolments",
    "myQuestionnaires": "My questionnaires",
    "myQualifications": "My qualifications",
    "dashboard": "Dashboard",
    "tenants": "Tenants",
    "platformAssets": "Media library",
    "platformLocales": "Languages",
    "superadmins": "Superadmins",
    "settings": "Settings",
    "users": "Users",
    "orgUnits": "Org units",
    "localeOverrides": "Texts",
    "mailOutbox": "Mail outbox",
    "sendMessage": "Send message",
    "mailTemplates": "Mail texts",
    "workflows": "Workflows",
    "platformWorkflows": "Platform workflows",
    "approvals": "Approvals",
    "approvalsOverview": "All approvals",
    "badgePending": "{count} pending",
    "mainNavigation": "Main navigation",
    "logout": "Log out",
    "changeLanguage": "Change language",
    "themeDark": "Dark mode",
    "themeLight": "Light mode",
    "openAdminConsole": "Open admin console",
    "openApp": "Go to app",
    "cancellationReasons": "Cancellation reasons",
    "questionnaires": "Questionnaires",
    "locations": "Training locations",
    "externalPeople": "External people",
    "externalCompanies": "External companies",
    "approvalFlows": "Approval flows",
    "roles": "Roles & permissions",
    "attendance": "Attendance",
    "auditLog": "Audit log",
    "accessGroups": "Access groups",
    "ltiProviders": "LTI connections",
    "groupUsersOrg": "Users & organisation",
    "groupCatalogs": "Catalogs",
    "groupLearning": "Learning offering",
    "groupMessaging": "Email & messages",
    "tests": "Tests",
    "grading": "Grading",
    "results": "Results",
    "qualifications": "Qualifications",
    "externalRequestTypes": "External training (setup)",
    "themes": "Categories",
    "media": "Media library",
    "groupResources": "Resources",
    "documentTemplates": "Document templates"
  },
  "myEnrollments": {
    "title": "My enrolments",
    "description": "An overview of the activities you are enrolled in and their status.",
    "empty": "You don't have any enrolments yet.",
    "emptyCta": "Browse the catalogue",
    "error": "We couldn't load your enrolments.",
    "retry": "Try again",
    "untitled": "Untitled activity",
    "controlsLabel": "Sort and filter",
    "sortLabel": "Sort",
    "sort": {
      "dateAsc": "Start date (ascending)",
      "dateDesc": "Start date (descending)"
    },
    "filter": {
      "showHistory": "Show history"
    },
    "groupActive": "Active",
    "groupHistory": "History",
    "noActive": "You have no active enrolments.",
    "noHistory": "You don't have any completed or cancelled enrolments yet.",
    "partOf": "Part of {title}",
    "certificate": {
      "filename": "certificate",
      "download": "Download certificate",
      "inProgress": "Certificate is being made",
      "downloadFailed": "The certificate could not be downloaded. Please try again later.",
      "revoked": "Revoked"
    }
  },
  "myLearningPath": {
    "notFound": "We could not find this learning path.",
    "error": "We could not load your learning path.",
    "retry": "Try again",
    "progressTitle": "Progress",
    "progress": "{done} of {total} required parts completed",
    "noRequired": "This learning path has no required parts.",
    "sequentialHint": "You go through the parts in order. A part opens as soon as the previous one is completed.",
    "partsTitle": "Parts",
    "noParts": "This learning path has no parts yet.",
    "reference": "Reference",
    "completedOn": "Completed on {date}",
    "state": {
      "to_schedule": "To be scheduled",
      "locked": "Locked",
      "not_started": "Not started",
      "in_progress": "In progress",
      "completed": "Completed",
      "previously_completed": "Previously achieved",
      "exempted": "Exempted",
      "not_passed": "Not passed",
      "expired": "Expired",
      "cancelled": "Cancelled"
    },
    "detail": {
      "completedOn": "Completed on {date}",
      "previouslyCompletedOn": "Completed on {date}, previously achieved",
      "lockedBy": "Opens as soon as you have completed {title}.",
      "toSchedule": "For this part you choose a session with a date. You will be able to do that here soon.",
      "notPassed": "You completed this part, but did not pass.",
      "expired": "You had achieved this part, but it is no longer valid."
    }
  },
  "catalog": {
    "structural": {
      "locked": {
        "enrollments": "Can no longer be changed: this training already has enrolments.",
        "attempts": "Can no longer be changed: this e-learning has already been started.",
        "completions": "Can no longer be changed: this training already has completions."
      },
      "warnTitle": "This training has already been published",
      "warnBody": "You are changing something that determines what an enrolment or completion means. There are no enrolments yet, so it is still possible. Once someone enrols, it is fixed.",
      "warnConfirm": "Save anyway",
      "field": {
        "composition": "The composition",
        "type": "The type",
        "source_kind": "The source",
        "source_url": "The link",
        "source_package_id": "The e-learning package",
        "source_lti_provider_id": "The LTI provider",
        "tracking_mode": "Activity or reference",
        "completion_rule": "The completion rule",
        "completion_threshold": "The percentage of the completion rule",
        "sources": "The material in another language",
        "items": "The parts, or which ones are required"
      }
    },
    "detail": {
      "back": "Back to catalogue",
      "backToMyEnrollments": "Back to my enrolments",
      "duration": "Duration",
      "durationMinutes": "{count} min",
      "category": "Category",
      "contentManagers": "Managers",
      "occurrences": "Scheduled sessions",
      "noOccurrences": "There are no scheduled sessions yet.",
      "items": "Components",
      "noItems": "There are no components yet.",
      "notFound": "Activity not found",
      "ctaSoon": "Available soon",
      "studyLoad": "Study load",
      "description": "Description",
      "details": "Details",
      "language": "Language",
      "themes": "Categories",
      "tags": "Tags",
      "tracking": "Tracked",
      "trackingYes": "Yes — counts as to do and done",
      "trackingNo": "No — reference material",
      "planned_one": "{count} session scheduled",
      "planned_other": "{count} sessions scheduled",
      "spotsTotal_one": "{count} place available",
      "spotsTotal_other": "{count} places available",
      "chooseBelow": "choose a session below to enrol",
      "approvalHint": "After you enrol, the system asks your manager for approval; you will receive a confirmation by email.",
      "directHint": "You will receive a confirmation by email straight away.",
      "approval": "Approval",
      "approvalRequired": "Required",
      "approvalNotRequired": "Not required",
      "spotsOf": "{left} of {total} places available",
      "fullWaitlist": "Full — waiting list",
      "days_one": "{count} day",
      "days_other": "{count} days",
      "dayN": "Day {n}",
      "enrollUntil": "Enrol until {date}",
      "itemsOrdered": "Parts (in order)",
      "itemsOrderedHint": "Each part opens once the previous one is completed.",
      "itemsFreeHint": "No fixed order — work through the parts as it suits you.",
      "openInLanguage": "Open in another language",
      "ownLanguage": "My own language"
    },
    "error": {
      "title": "Something went wrong",
      "retry": "Try again"
    },
    "launch": {
      "start": "Start",
      "resume": "Continue",
      "review": "View again",
      "open": "Open",
      "error": "Could not open this.",
      "restart": "Start over",
      "restartTitle": "Start over?",
      "restartBody": "You will begin this training again from the start. Your progress inside the training is cleared; your result is kept."
    },
    "enroll": {
      "action": "Enrol",
      "full": "Full",
      "closed": "Enrolment closed",
      "success": "You're enrolled.",
      "requested": "Your request has been submitted. You'll hear as soon as there's a decision.",
      "waitlisted": "You are on the waiting list. You are not enrolled yet — you'll hear as soon as a place becomes available.",
      "error": "Enrolment failed.",
      "elsewhere": "You're already enrolled on {date}",
      "waitlistedElsewhere": "You're already on the waiting list for {date}",
      "spotsLeft": "{count} spots left",
      "awaitingApproval": "Awaiting approval",
      "joinWaitlist": "Join the waiting list",
      "onWaitlist": "On the waiting list",
      "offerPending": "A spot is available — accept your offer",
      "offerAcceptBy": "A spot is available — accept before {date}",
      "acceptOffer": "Accept",
      "declineOffer": "Decline"
    },
    "cancel": {
      "button": "Cancel enrollment",
      "requestButton": "Request cancellation",
      "pending": "Cancellation pending",
      "confirmTitle": "Cancel enrollment?",
      "confirmBody": "Are you sure you want to cancel your enrollment? This cannot be undone.",
      "reasonLabel": "Reason (optional)",
      "confirm": "Yes, cancel",
      "keep": "Keep",
      "cancelled": "Cancelled — reason: {reason}",
      "reasonSelectLabel": "Reason",
      "reasonSelectPlaceholder": "— Choose a reason —",
      "cancelledReason": "Reason: {reason}",
      "cancelledNote": "Cancelled — reason:"
    },
    "cancellationMode": {
      "self": "Self-service",
      "needs_approval": "Needs approval",
      "not_allowed": "Not allowed"
    },
    "waitlistPromotionMode": {
      "auto_enter": "Promote automatically",
      "invite": "Offer the spot"
    },
    "enrollmentLimit": {
      "one": "1 (default)",
      "multiple": "Multiple"
    },
    "deliveryMode": {
      "klassikaal": "Classroom",
      "virtual_classroom": "Virtual classroom",
      "blended": "Blended"
    },
    "enrollmentStatus": {
      "enrolled": "Enrolled",
      "pending": "Pending",
      "offered": "Spot offered",
      "waitlisted": "Waitlisted",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "expired": "Expired",
      "finalized": "Processed"
    },
    "heading": "Catalog management",
    "intro": "Manage all learning activities.",
    "new": "New activity",
    "settingsLink": "Settings",
    "empty": "No learning activities yet — create one.",
    "backToList": "Back to catalogue",
    "filter": {
      "search": "Search by title or summary…",
      "status": "Status",
      "all": "All",
      "searchPlaceholder": "Search the catalogue",
      "themes": "Category",
      "type": "Type",
      "composition": "Format",
      "tracking": "Kind",
      "category": "Category",
      "sort": "Sort",
      "reset": "Clear filters",
      "activeLabel": "Active filters",
      "removeFilter": "Remove filter: {filter}",
      "completionRule": "Completion rule",
      "completionRuleMissing": "No rule set",
      "heading": "Filters",
      "language": "Language",
      "clear": "Clear",
      "onlyWith": "Only with {name}"
    },
    "presentation": {
      "activiteit": "Activity",
      "naslag": "Reference"
    },
    "type": {
      "e_learning": "E-learning",
      "assessment": "Assessment",
      "meeting": "Meeting",
      "content": "Content/media",
      "social": "Social",
      "workplace": "On-the-job",
      "external": "External training"
    },
    "composition": {
      "single": "Activity",
      "learning_path": "Learning path",
      "bundle": "Bundle"
    },
    "source": {
      "manual": "Manual",
      "file": "File",
      "link": "Link",
      "scorm_xapi": "E-learning package (SCORM)",
      "lti": "LTI",
      "session": "Session / attendance"
    },
    "status": {
      "concept": "Draft",
      "published": "Published",
      "hidden": "Hidden",
      "archived": "Archived"
    },
    "unavailable": {
      "ltiProviderInactive": "Not in the catalogue: connection switched off"
    },
    "columns": {
      "title": "Title",
      "composition": "Composition",
      "type": "Type",
      "soort": "Kind",
      "status": "Status",
      "actions": "Actions",
      "completionRule": "Completion",
      "themes": "Categories"
    },
    "actions": {
      "edit": "Edit",
      "changeStatus": "Change status…",
      "duplicate": "Duplicate",
      "delete": "Delete",
      "planning": "Planning",
      "export": "Export ({count})"
    },
    "bulk": {
      "label": "Bulk actions",
      "selected": "{count} selected",
      "selectAllMatching": "Select all {count} matching this filter",
      "allMatchingSelected": "All {count} matching this filter",
      "limitToSelection": "Limit to the selected rows"
    },
    "confirm": {
      "archiveTitle": "Archive activity(ies)?",
      "archiveBody": "This archives {count} activity(ies); they leave the catalog but stay in records.",
      "deleteTitle": "Delete draft?",
      "deleteBody": "\"{title}\" will be permanently deleted. This cannot be undone.",
      "bulkTitle": "Change status?",
      "allMatchingBody": "This sets {count} activity/activities to \"{status}\" — including the ones not currently on screen."
    },
    "feedback": {
      "statusChanged": "{count} activity(ies) → {status}.",
      "duplicated": "\"{title}\" duplicated as a draft.",
      "deleted": "\"{title}\" deleted.",
      "bulkDuplicated": "{count} copy(ies) created.",
      "archivedPartlyHidden": "{count} activity/activities processed; {hidden} of them are Hidden because occurrences were still running."
    },
    "fields": {
      "title": "Title",
      "summary": "Summary",
      "description": "Description",
      "category": "Category",
      "durationMinutes": "Duration (minutes)",
      "image": "Image",
      "imagePreviewAlt": "Preview of the chosen image",
      "imageHelp": "Choose an image from the media library, fetch one from an address or Pexels, or upload one from your computer. Without its own image, the item shows the default image of the environment.",
      "removeImage": "Remove image",
      "sourceUrl": "Web address",
      "sourceUrlHelp": "Where the participant ends up.",
      "neededToPublish": "Needed to publish; a draft can do without.",
      "sourceFile": "The file",
      "sourceFileHelp": "The document the participant opens. Only people who may see the training can download it.",
      "sourceFileSaveFirst": "Save this training as a draft first; you can add the file afterwards. Publishing needs a file.",
      "ltiProvider": "LTI provider",
      "ltiProviderHelp": "Which vendor runs this training.",
      "ltiProviderNew": "Add a new provider",
      "ltiLaunchUrl": "Course address",
      "ltiLaunchUrlHelp": "The address of this specific course at the vendor. Leave it empty and we use the provider's default address — which is only right if that vendor has a single course. Publishing needs one of the two.",
      "ltiPickCourse": "Pick a course at the vendor",
      "ltiPickCourseSaveFirst": "You can pick the course at the vendor once this training has been saved. Picking takes you away from this screen, so save it as a draft first — otherwise you lose what you are filling in now.",
      "ltiPickCourseConfirmTitle": "This training already has results",
      "ltiPickCourseConfirmBody_one": "{count} result has been recorded for the course currently linked here. It stays: whoever completed the training keeps that. From now on, new participants follow the course you are about to pick.",
      "ltiPickCourseConfirmBody_other": "{count} results have been recorded for the course currently linked here. They stay: whoever completed the training keeps that. From now on, new participants follow the course you are about to pick.",
      "ltiPickCourseConfirmAction": "Pick course",
      "sourceFileReplaceConfirmTitle": "People have already completed with the current file",
      "sourceFileReplaceConfirmBody_one": "{count} person has already completed this activity with the previous file; that completion stays. Anyone who opens the activity from now on gets the new file.",
      "sourceFileReplaceConfirmBody_other": "{count} people have already completed this activity with the previous file; their completions stay. Anyone who opens the activity from now on gets the new file.",
      "sourceFileReplaceConfirmAction": "Replace file",
      "ltiProviderNoAccess": "You are not allowed to view this environment's integrations. Ask an administrator to pick the provider.",
      "ltiProviderInactive": "{name} (switched off)",
      "package": "The e-learning file",
      "packageHint": "One zip file, as you receive it from the supplier. Needed to publish.",
      "packageHintWithMax": "One zip file, as you receive it from the supplier, up to {max} MB. Needed to publish.",
      "packageChoose": "Choose a file",
      "packageReplace": "Upload another file",
      "packageTry": "Try it out",
      "packageTryHint": "Opens the course in a new tab, exactly as a participant sees it. Nothing is recorded: no progress, no result, no completion.",
      "packageTryBlocked": "Your browser blocked the new tab. Allow pop-ups for this page and try again.",
      "packageTryFailed": "The course could not be opened. Please try again.",
      "packagePresent": "A file is attached",
      "packageUploading": "Uploading",
      "packageProgress": "Uploading — {percent}%",
      "packageInspecting": "Checking the file…",
      "packageAccepted": "One course found: {title}",
      "packageAcceptedUntitled": "One course found. The file does not carry a title of its own.",
      "packageNotes": "What was adjusted or left out of this file:",
      "packageRejected": "This file cannot be used as it is:",
      "packageNeedsChoice": "This file contains more than one e-learning:",
      "completionRule": "When is this completed?",
      "completionRuleHint": "There is deliberately no default: set for yourself when this training counts as done. As long as this is empty, nobody completes it.",
      "completionRuleProgressUnavailable": "Completing on the percentage someone has worked through is not possible here: this file does not keep track of how far someone has got.",
      "completionRuleNone": "Not chosen yet",
      "completionRuleFixed": "This source leaves nothing to choose: completed here means {rule}.",
      "completionThreshold": "Percentage",
      "completionThresholdHint": "A number between 1 and 100.",
      "progressResetDays": "Validity of the completion",
      "progressResetDaysHint": "Empty = never expires.",
      "progressResetDaysHelp": "After how many days a completion expires and the learner has to take the course again. The clock starts when they finish.",
      "choose": "Choose…",
      "summaryHint": "At most three lines, up to 200 characters.",
      "summaryHelp": "A short text for the card and the top of the article.",
      "contentManagers": "Content managers",
      "contentManagersPlaceholder": "Search for a person",
      "contentManagersHint": "May maintain this activity: the basic details and the source/material. The Content manager role grants the rights.",
      "contentManagerNoRole": "{name} does not hold the Content manager role and cannot edit this activity.",
      "educators": "Educator(s)",
      "educatorsPlaceholder": "Choose an educator",
      "educatorsHint": "Decides which trainers you can choose when planning. Empty means no restriction.",
      "educatorInternal": "Internal",
      "translationHint": "If you leave a text in this language empty, the reader sees it in the language of the environment.",
      "languageInUse_one": "{language} is still used by 1 scheduled session ({dates}). Without a title this language is removed, which is only possible once you choose another language there first.",
      "languageInUse_other": "{language} is still used by {count} scheduled sessions ({dates}). Without a title this language is removed, which is only possible once you choose another language there first."
    },
    "version": {
      "breaking": "The course has changed substantially",
      "breakingHint": "Participations in progress are closed and start over. Needed when parts have been removed or reordered — otherwise someone returns to a place that no longer exists.",
      "closedAttempts": "Version switched. {count} participation(s) in progress were closed; those people start over.",
      "compatibilityLegend": "What does this version mean for participations in progress?",
      "compatible": "The course is largely the same",
      "compatibleHint": "Anyone partway through continues where they were. Pick this only if the structure of the course has not changed.",
      "heading": "New version",
      "intro": "This e-learning is already published with a package. A new file replaces the version for everyone, so first tell us what the change means for people who are partway through.",
      "noAttemptsClosed": "Version switched. There were no participations in progress.",
      "restartConfirm": "Start over",
      "restartOpen": "Make participations start over",
      "restartReason": "Reason",
      "restartWarning": "This closes every participation in progress on the current version. Progress and bookmarks are lost; completed results remain.",
      "switch": "Switch version",
      "viewResults": "View results"
    },
    "elearningResults": {
      "actions": "Actions",
      "back": "Back to the activity",
      "correctError": "The correction could not be saved.",
      "correctFor": "Correct the result for {name}",
      "correctedNote": "Corrected on {date}",
      "effective": "Currently applies",
      "empty": "Nobody has started this e-learning.",
      "failed": "Not passed",
      "heading": "Results",
      "intro": "Who started this e-learning, how far they are, and what stands as their result. A manual correction sits next to what the course reported — both stay visible.",
      "lastActivity": "Last active",
      "loadError": "The results could not be loaded.",
      "next": "Next",
      "pageOf": "Page {page} of {total}",
      "pagination": "Pagination",
      "passed": "Passed",
      "person": "Person",
      "prev": "Previous",
      "reason": "Reason",
      "reasonHint": "Goes into the log and is the answer to “why does this score stand?”.",
      "reported": "Reported",
      "resetConfirm": "Reset progress",
      "resetError": "The progress could not be reset.",
      "resetFor": "Reset progress for {name}",
      "resetKeepsCompletion": "{name}'s completion stays: it was achieved in another language.",
      "resetLanguage": "Language",
      "resetLanguageHint": "Only the progress in this language is reset. Preselected: the language {name} last worked in.",
      "resetPreviewError": "Could not load what the reset would do. Please try again.",
      "resetReason": "Reason",
      "resetReasonHint": "Goes into {name}'s log and is the answer they can be given later.",
      "resetWarn": "{name}'s progress in this e-learning will be closed. Access remains; {name} can start again afterwards.",
      "resetWarnLanguage": "{name}'s progress in {language} will be closed; other languages stay as they are. Access remains; {name} can start again afterwards.",
      "resetWarnLanguageWithCompletion": "{name} completed this e-learning in {language}. That completion will be withdrawn — it stays on record as withdrawn, but no longer counts from now on. Other languages stay as they are; access remains.",
      "resetWarnWithCompletion": "{name} has completed this e-learning. That completion will be withdrawn — it stays on record as withdrawn, but no longer counts from now on. Access remains; {name} can start again afterwards.",
      "save": "Save correction",
      "scoreHint": "Leave empty if you are only changing the verdict.",
      "scorePercent": "Score (%)",
      "scoreRange": "Enter a number from 0 to 100.",
      "status": "Status",
      "statuses": {
        "closed": "Closed",
        "completed": "Completed",
        "in_progress": "In progress"
      },
      "superseded": {
        "admin_reset": "Reset by an administrator",
        "breaking_version": "Closed by a new, substantially changed version",
        "forced_restart": "Closed by a forced restart",
        "learner_restart": "Started over by the participant",
        "progress_reset": "Expired — the completion was no longer valid"
      },
      "unknownUser": "Unknown user",
      "verdict": "Verdict",
      "verdictNone": "No verdict"
    },
    "wizard": {
      "newTitle": "New learning activity",
      "editTitle": "Edit learning activity",
      "needType": "Choose a type.",
      "needTitle": "Title is required.",
      "needSummary": "Enter a summary.",
      "needDescription": "Enter a description.",
      "occurrencesFollowTitle": "Also rename the sessions with the old title ({n})",
      "occurrencesFollowTitleHelp": "Sessions now called \"{title}\" get the new title. Sessions with a topic of their own stay as they are.",
      "source": "Source / material",
      "sourceNone": "— none —",
      "tracking": "Tracking",
      "ready": "Ready to publish.",
      "publish": "Publish",
      "saveConcept": "Save as draft",
      "save": "Save",
      "next": "Next",
      "published": "\"{title}\" published.",
      "savedConcept": "\"{title}\" saved as a draft.",
      "publishAt": "Publish on (optional)",
      "publishAtHint": "Empty: you publish yourself.",
      "publishAtHelp": "With a moment the activity stays a draft and is published automatically at that time, with the same checks as publishing now.",
      "publishAtPast": "Choose a moment in the future.",
      "schedule": "Schedule",
      "scheduled": "“{title}” is scheduled: publication on {date}.",
      "grantsFailed": "“{title}” was created, but one or more qualifications could not be linked. Link them again below.",
      "saved": "\"{title}\" saved.",
      "saveInvalid": "Saving did not work: one or more fields are not right. The steps with an exclamation mark say what is wrong.",
      "statusInListHint": "Publishing, hiding and archiving are done in the list via \"Change status\".",
      "step": {
        "type": "Type",
        "bron": "Source / material",
        "resultaten": "Results",
        "basis": "Basics",
        "details": "Details",
        "controle": "Review & publish",
        "compositie": "Composition",
        "zichtbaarheid": "Visibility",
        "inschrijven": "Enrollment",
        "onderdelen": "Components"
      },
      "section": {
        "classificatie": "Classification",
        "people": "People involved",
        "fields": "Characteristics",
        "what": "What it is",
        "texts": "Texts",
        "time": "Time",
        "material": "Material",
        "completion": "Completion",
        "anonymous": "Without signing in",
        "enrolling": "Enrolling",
        "waitlist": "Waiting list",
        "deadlines": "Deadlines and cancelling",
        "certificate": "Certificate"
      },
      "finished": {
        "question": "Do you want to schedule now, or go back to the list?",
        "planNow": "Continue to planning",
        "backToList": "Back to the list"
      },
      "sourceHint": "The source sets what can be tracked; only sources that fit the type are selectable.",
      "trackingHint": "Activity = to-do/done (can count toward PE); Reference = view only.",
      "compositionHint": "Activity = a single learning activity · Path = ordered (can unlock a certificate) · Bundle = an unordered group.",
      "needOnderdeel": "A path/bundle needs at least one component.",
      "basicsOnlyNotice": "You are a content manager of this activity: you change the basic details and the source/material. Visibility, enrolment, results and planning are managed by someone with administration rights for the whole environment.",
      "required": {
        "heading": "Required to publish",
        "legend": "Fields marked * are required.",
        "done": "(done)",
        "missing": "(still missing)",
        "onePart": "At least one part"
      },
      "fieldShowToLearner": "Show {name} to the participant"
    },
    "plannen": {
      "problem": {
        "needsDay": "There is no day yet. Add at least one day.",
        "needsDate_one": "Day {days} has no date yet. Enter a date for every day.",
        "needsDate_other": "Days {days} have no date yet. Enter a date for every day.",
        "needsStartTime": "Day 1 has no start time yet. Enter a start time for the first day."
      },
      "problemFor": "Session {n}: {problem}",
      "uitvoering": "Session {n}",
      "removeUitvoering": "Remove session",
      "minParticipants": "Min. participants",
      "maxParticipants": "Max. participants",
      "minParticipantsHelp": "Below this number the session normally does not go ahead. The planning warns you when the minimum is not reached; you confirm or cancel yourself.",
      "maxParticipantsHelp": "This many places are available. When the session is full, new sign-ups go on the waiting list, if it is on. Empty = no maximum.",
      "deadline": "Enrollment deadline",
      "deadlineHelp": "Participants can enrol up to and including this day. It is calculated from the first day; if you enter a date yourself, that date stays.",
      "description": "Additional description",
      "descriptionHint": "At most 5000 characters.",
      "descriptionHelp": "Extra information about this session for participants, such as what to bring or how to find the room. It appears with this session in the catalogue; in a calendar invitation it appears without formatting.",
      "occurrenceTitle": "Session title",
      "occurrenceTitleHint": "Leave empty or equal to the activity when there is no topic of its own.",
      "occurrenceTitleHelp": "The topic of this session, when the activity is an umbrella name. Participants see it below the title of the activity.",
      "day": "Day {n}",
      "removeDay": "Remove day",
      "date": "Date",
      "dateMissing": "Enter a date.",
      "startTimeMissing": "Enter a start time.",
      "from": "From",
      "to": "To",
      "location": "Training location",
      "locationPlaceholder": "Choose or type…",
      "locationEntity": "Training location (from list)",
      "locationNone": "No training location",
      "locationCapacityWarning": "Max. participants ({max}) exceeds this location's capacity ({capacity}). Choose a larger location or lower the maximum.",
      "deliveryMode": "Delivery mode",
      "deliveryModeNone": "No selection",
      "trainer": "Trainer",
      "trainerNone": "No trainer",
      "trainerExternalGroup": "External people",
      "trainerInternalGroup": "Internal staff",
      "lunch": "Lunch",
      "diner": "Dinner",
      "overnight": "Overnight",
      "addDay": "+ Add day",
      "maxEnrollments": "Number of enrollments",
      "maxEnrollmentsHint": "How many times someone may be actively enrolled at once for this activity (across all sessions).",
      "maxWaitlistRegistrations": "Number of waitlist registrations",
      "maxWaitlistRegistrationsHint": "How many waiting-list spots someone may hold at once for this activity. Once a spot is resolved, the waitlist spot frees up again.",
      "waitlistEnabled": "Waiting list",
      "waitlistEnabledHint": "When a session is full, learners can join the waiting list. When a spot opens up, it is assigned using the method you choose. Follow the environment: the default from the catalogue settings applies, even if it changes later.",
      "waitlistFollowDefaultOn": "Follow the environment (currently on)",
      "waitlistFollowDefaultOff": "Follow the environment (currently off)",
      "promotionMode": "When a spot opens up",
      "offerWindowHours": "Acceptance window (hours)",
      "offerWindowHoursHint": "How many hours an offered spot stays reserved before the offer expires. Leave empty for the system default (48 hours).",
      "offerWindowHoursPlaceholder": "48",
      "waitlistCap": "Waiting list cap",
      "waitlistCapHint": "Maximum number of people on the waiting list per session. Leave empty = unlimited.",
      "waitlistCapPlaceholder": "Unlimited",
      "waitlistCapUnlimited": "Unlimited",
      "occurrenceWaitlist": "Waiting list (this session)",
      "occurrenceWaitlistHelp": "Follow activity: the waiting-list setting of the activity applies. On or Off differs for this session only.",
      "occurrenceWaitlistInherit": "Follow activity",
      "occurrenceWaitlistOn": "On",
      "occurrenceWaitlistOff": "Off",
      "manageWaitlist": "Manage waitlist",
      "cancellationDeadline": "Cancellation deadline",
      "cancellationDeadlineHelp": "Participants can cancel themselves up to and including this day. It is calculated from the first day; if you enter a date yourself, that date stays.",
      "enrollmentDeadlineDays": "Enrolment closes (days before the first day)",
      "deadlineDaysHint": "Empty = the tenant default. 0 = up to the first day itself.",
      "deadlineDaysHelp": "The number of calendar days before the first day. The server works out the date per occurrence from this; you can override it per occurrence.",
      "deadlineCalculated": "Calculated from the first day",
      "deadlineOverridden": "Set by hand",
      "deadlineNone": "No deadline",
      "deadlineBackToCalculated": "Back to calculated",
      "noDate": "No date",
      "expandDay": "Edit",
      "collapseDay": "Collapse",
      "deadlineDaysBefore_one": "{count} day before the first day",
      "deadlineDaysBefore_other": "{count} days before the first day",
      "deadlineSameDay": "Until the first day itself",
      "deadlineInherited": "{days} (tenant default)",
      "cancellationApprovalFlow": "Approval flow for cancelling",
      "cancellationApprovalFlowHelp": "Who decides a cancellation request, when the cancellation terms ask for approval. Approved means cancelled; rejected keeps the participant enrolled.",
      "opleider": "Educator",
      "opleiderHelp": "An educator limits the trainer list to that company's trainers. It is only a filter; it is not saved.",
      "opleiderNone": "— None / own trainer —",
      "capacity": "Capacity",
      "enrolledBadge": "Has enrolments",
      "enrolledReadOnly": "This occurrence has enrolments and is read-only here. Change the date, trainer, training location or participants on the planning page.",
      "managePlanningLink": "Manage on the planning page",
      "approvalFlow": "Approval",
      "approvalFlowNone": "No approval — enrol directly",
      "approvalFlowHint": "Pick an approval flow, or leave it at no approval. Waitlist, capacity and the enrolment window still apply.",
      "cancellationPolicy": "Cancellation terms",
      "cancellationPolicyHelp": "Until when and on which terms a participant cancels. You choose a set from the settings; an occurrence can choose another.",
      "cancellationPolicyDefault": "{name} (default)",
      "cancellationApprovalFlowNone": "No flow",
      "occurrenceCancellationPolicy": "Cancellation terms",
      "occurrenceCancellationPolicyHelp": "A different set than the activity's, for this occurrence only. The cancellation deadline then follows the deadline of that set.",
      "occurrenceCancellationPolicyInherit": "As the activity ({name})",
      "occurrenceCancellationPolicyInheritPlain": "As the activity"
    },
    "inschrijven": {
      "intro": "These are the default enrollment settings for this activity. You plan the sessions afterwards on the planning page, and each session can deviate from these settings."
    },
    "waitlist": {
      "heading": "Waitlist",
      "intro": "The order decides who gets a freed spot first. Use the buttons to reorder the people waiting.",
      "back": "Back to the occurrences",
      "empty": "No one is on the waitlist for this occurrence.",
      "loadError": "The waitlist could not be loaded. Please try again.",
      "moveError": "The order could not be changed. Please try again.",
      "unknownUser": "Unknown user",
      "joinedAt": "Joined on {date}",
      "toTop": "To top",
      "moveUp": "Move {name} up one place",
      "moveDown": "Move {name} down one place",
      "moveTop": "Move {name} to the top"
    },
    "panel": {
      "title": "What you're building"
    },
    "classificatie": {
      "themes": "Categories",
      "noThemes": "No categories managed yet — add them later in category management.",
      "themesPlaceholder": "Search and choose categories",
      "tags": "Tags",
      "tagPlaceholder": "Type a tag…",
      "addTag": "New tag: “{tag}”",
      "duration": "Duration",
      "language": "Language",
      "choose": "— choose —",
      "formCategory": "Learning form",
      "formCategoryHelp": "A label for the learner, chosen from the list of this environment. Prefilled from the type.",
      "formCategoryOption": {
        "formal_digital": "Formal – digital",
        "formal_classroom": "Formal – classroom",
        "formal_supporting": "Formal – supporting",
        "social_learning": "Social learning",
        "workplace_experience": "Workplace & experience",
        "self_directed": "Self-directed learning"
      },
      "languagePerOccurrence": "You choose the language per session, on the planning. The activity is then offered in the languages of its sessions."
    },
    "duration": {
      "kort": "Short (< 30 min)",
      "uur": "About an hour",
      "dagdeel": "Half a day",
      "meerdaags": "Multi-day"
    },
    "language": {
      "nl": "Dutch",
      "en": "English",
      "de": "German",
      "fr": "French"
    },
    "visibility": {
      "everyone": "Everyone",
      "lead": "Who may see this learning activity?",
      "ruleset": "A saved access group",
      "closedUntilGroup": "Note: as long as no access group is attached here, nobody sees this learning activity — except those who may edit it. Choose \"Everyone\" if you want it open instead.",
      "chooseGroup": "Access group",
      "noGroupChosen": "No group chosen yet",
      "groupOption": "{name} ({count} people)",
      "noGroupsYet": "There are no access groups yet. Create one under Access groups — that is where you define who belongs, and you can then choose that group here and elsewhere."
    },
    "onderdelen": {
      "pathLead": "Compose the ordered components (order determines unlocking).",
      "bundleLead": "Group the components (unordered).",
      "sequentieel": "Enforced order (strictly sequential)",
      "required": "Required (counts towards unlocking)",
      "remove": "remove",
      "empty": "No components yet.",
      "addExisting": "+ Add an existing activity…",
      "searchLabel": "Search for an activity to add as a component",
      "moveUp": "Move up",
      "moveDown": "Move down"
    },
    "title": "Catalogue",
    "description": "Search and filter all learning activities, and open one to enrol.",
    "results_one": "{count} activity",
    "results_other": "{count} activities",
    "loadMore": "Load more",
    "sort": {
      "newest": "Newest first",
      "title_asc": "Title A–Z",
      "title_desc": "Title Z–A"
    },
    "emptyState": {
      "title": "Nothing found",
      "body": "Adjust your filters or search.",
      "reset": "Clear filters"
    },
    "occurrenceStatus": {
      "concept": "Draft",
      "planned": "Planned",
      "confirmed": "Confirmed",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "planning": {
      "heading": "Planning",
      "intro": "Manage the occurrences of this learning activity.",
      "backToWizard": "Back to the activity",
      "openLink": "Open planning",
      "loadError": "The planning could not be loaded. Please try again.",
      "drift": {
        "title": "Deadlines differ from the number of days",
        "body": "For {n} occurrence(s) the calculated deadline no longer matches the number of days of the activity or the tenant.",
        "withEnrolments": "{n} of them already have people enrolled; they stay as they are unless you explicitly include them.",
        "recalculate": "Recalculate (without enrolments)",
        "recalculateAll": "Recalculate including enrolments"
      },
      "statusError": "The status could not be changed. Please try again.",
      "empty": "This activity has no occurrences yet.",
      "filterStatus": "Status",
      "statsLabel": "Statistics",
      "stats": {
        "completed": "Times run",
        "totalEnrolled": "Total enrolled",
        "concept": "Draft",
        "planned": "Planned",
        "confirmed": "Confirmed",
        "cancelled": "Cancelled"
      },
      "columns": {
        "title": "Topic",
        "datetime": "Date & time",
        "trainer": "Trainer",
        "location": "Training location",
        "bezetting": "Occupancy",
        "status": "Status",
        "deadline": "Enrollment deadline",
        "actions": "Actions"
      },
      "transition": {
        "planned": "Open",
        "confirmed": "Confirm",
        "completed": "Complete",
        "cancelled": "Cancel"
      },
      "detailLink": "Participants",
      "confirmCancelTitle": "Cancel occurrence",
      "confirmCancelBody": "Are you sure you want to cancel this occurrence? All participants and everyone on the waitlist will be cancelled and notified automatically. This cannot be undone.",
      "confirmCancelConfirm": "Cancel occurrence",
      "confirmCancelKeep": "Keep occurrence",
      "cancelReasonLabel": "Reason (optional)",
      "addOccurrence": "Add occurrence",
      "editRow": "Edit",
      "belowMinimum": "Below minimum",
      "belowMinimumHint": "There are fewer enrolments than the minimum of {min}. You can confirm the occurrence (run it anyway), cancel it, or move the date.",
      "editor": {
        "addTitle": "Add occurrence",
        "editTitle": "Reschedule occurrence",
        "intro": "Fill in the occurrence details. Existing enrolments are preserved.",
        "loadError": "The occurrences could not be loaded. Please try again.",
        "saveError": "The occurrence could not be saved. Please try again.",
        "backToPlanning": "← Back to planning",
        "sectionBasis": "Basics",
        "sectionCapacity": "Capacity and enrolment",
        "sectionDays": "Days",
        "summary": "Summary",
        "summaryFirstDay": "First day",
        "summaryDays": "Number of days",
        "summaryCapacity": "Participants",
        "notFound": "This occurrence no longer exists.",
        "conceptNotice": "This session is still a draft: participants cannot see it or enrol. Check the days and then open it.",
        "saveAndOpen": "Save and open",
        "openError": "The session was saved but could not be opened. Open it from the planning.",
        "sectionLanguage": "Language",
        "language": "Language of this session",
        "languageHint": "Choose from the languages in which the activity has its texts.",
        "languageHelp": "The activity appears in the catalogue in the languages of its sessions.",
        "sectionFields": "Characteristics",
        "fieldsHint": "Only fill in what is different for this session. Empty means: as on the activity.",
        "fieldFromActivity": "On the activity: {value}",
        "fieldInherit": "As on the activity",
        "sectionCertificate": "Certificate"
      },
      "duplicateRow": "Duplicate",
      "bulkEdit": "Edit all",
      "duplicate": {
        "title": "Duplicate session",
        "intro": "The copy takes over the days, times, locations, trainers and settings and moves along with the new start date. Participants are never copied.",
        "opensNow": "The copy is open for enrolment straight away.",
        "startsAsConcept": "The original has {days} days, so the copy starts as a draft: participants cannot see it yet. Check the other days and then open it from the planning.",
        "currentStart": "First day of the original: {date}",
        "startDate": "New start date",
        "startDateHelp": "All days keep the same distance between them.",
        "confirm": "Duplicate",
        "error": "The session could not be duplicated. Please try again."
      },
      "bulk": {
        "title": "Edit sessions in bulk",
        "intro": "All sessions of this activity in one table. Change what you need and save everything in one go.",
        "backToPlanning": "← Back to planning",
        "loadError": "The sessions could not be loaded. Please try again.",
        "empty": "This activity has no sessions to edit yet.",
        "saveError": "The changes could not be saved. Nothing was changed.",
        "saved": "The changes have been saved.",
        "dirty": "There are changes that have not been saved yet.",
        "tableLabel": "Sessions and their days",
        "col": {
          "select": "Select",
          "day": "Day"
        },
        "field": "{field} ({row})",
        "rowLabel": "{occurrence}, day {day}",
        "selectRow": "Select {row}",
        "selectOccurrence": "Select {occurrence} with all its days",
        "collapse": "Collapse {occurrence}",
        "expand": "Expand {occurrence}",
        "lockedEnrollments": "Has enrolments: days, times and locations are fixed. Rescheduling is done on the session's own page.",
        "lockedFinished": "Closed or cancelled: can no longer be edited.",
        "trainers": "Trainer(s): {names}",
        "collision": "Same date and start time as another session of this activity.",
        "collisionSummary": "For {count} days the date and start time match another session of this activity. That is allowed, but check that it is intended.",
        "saveCollisionTitle": "Same date and start time",
        "saveCollisionBody": "There are days ({count}) with the same date and start time as another session of this activity. Do you want to save anyway?",
        "saveCollisionConfirm": "Save anyway",
        "saveCollisionBack": "Back to the table",
        "apply": {
          "title": "Apply to selected rows",
          "selected": "Selected: {days} days, {occurrences} sessions",
          "location": "Training location for the selected days",
          "locationPlaceholder": "Choose a location",
          "locationButton": "Apply location",
          "trainers": "Trainer(s) for the selected sessions",
          "trainersHelp": "Replaces the trainers of the selected sessions.",
          "trainersButton": "Apply trainer(s)",
          "nothingSelected": "Select rows in the table first.",
          "done": "Applied to {count} rows. Not saved yet."
        }
      },
      "cancelReasonHint": "Participants read this reason with their enrolment and in the cancellation email. Bold, italics, lists and links are allowed; at most 1000 characters.",
      "cancelledOn": "Cancelled on {date}",
      "conceptHint": "Not visible to participants"
    },
    "occurrenceDetail": {
      "heading": "Occurrence detail",
      "intro": "Manage the participants and waitlist of this occurrence.",
      "backToPlanning": "← Back to planning",
      "metaLabel": "Occurrence details",
      "meta": {
        "title": "Topic",
        "datetime": "Date & time",
        "trainer": "Trainer",
        "location": "Training location",
        "capacity": "Capacity (min–max)",
        "deadline": "Enrolment deadline",
        "status": "Status",
        "bezetting": "Occupancy"
      },
      "participantsHeading": "Participants",
      "participantsEmpty": "No participants have enrolled for this occurrence yet.",
      "columns": {
        "name": "Name",
        "department": "Department",
        "status": "Status",
        "actions": "Actions",
        "enrolledBy": "Enrolled by"
      },
      "unknownUser": "Unknown user",
      "cancelAction": "Cancel",
      "transfer": {
        "action": "Move",
        "title": "Move participant",
        "body": "Move {name} to another occurrence of this learning activity.",
        "targetLabel": "New occurrence",
        "targetPlaceholder": "Choose an occurrence",
        "hint": "The seat on the current occurrence is released and goes to the first person waiting. If the new occurrence is full, the participant joins its waitlist.",
        "willWaitlist": "full, becomes waitlist",
        "noDate": "no date",
        "noTargets": "This learning activity has no other planned or confirmed occurrence to move to.",
        "confirm": "Move",
        "error": "The participant could not be moved. Please try again."
      },
      "cancelError": "The enrolment could not be cancelled. Please try again.",
      "confirmCancelTitle": "Cancel enrolment",
      "confirmCancelBody": "Are you sure you want to cancel {name}'s enrolment? The seat is freed and the waitlist promotes automatically.",
      "confirmCancelConfirm": "Cancel enrolment",
      "completion": {
        "heading": "Certificate & evaluation",
        "soon": "Issuing a certificate and collecting an evaluation for this occurrence are coming soon."
      },
      "loadError": "The occurrence could not be loaded. Please try again.",
      "onBehalf": {
        "action": "Enrol participants",
        "title": "Enrol participants",
        "body": "Choose who you want to enrol. You first see what will happen for each person; only then do you enrol them.",
        "peopleLabel": "People",
        "peoplePlaceholder": "Search by name or email",
        "check": "Check",
        "back": "Back",
        "confirm": "Enrol",
        "close": "Close",
        "previewHeading": "What will happen",
        "doneHeading": "What happened",
        "nothingToDo": "None of these people can be enrolled right now.",
        "error": "Enrolment failed. Please try again.",
        "overridesHeading": "Continue anyway?",
        "overridesIntro": "A rule stands in the way for one or more people. You can set it aside; this is recorded on the enrolment, with your name.",
        "adminOnly": "Only an administrator can set this rule aside.",
        "applied": "Set aside: {gates}",
        "unknownPerson": "Unknown person",
        "override": {
          "capacity": "Enrol above the maximum number of participants",
          "deadline": "Enrol after the enrolment deadline",
          "approval": "Enrol without approval"
        },
        "gate": {
          "capacity": "maximum",
          "deadline": "enrolment deadline",
          "approval": "approval"
        },
        "preview": {
          "enrolled": "Will be enrolled",
          "pending": "Will then await approval",
          "waitlisted": "Will be put on the waiting list",
          "blocked": "Cannot be enrolled",
          "not_found": "Not found or outside your scope"
        },
        "done": {
          "enrolled": "Enrolled",
          "pending": "Awaiting approval",
          "waitlisted": "On the waiting list",
          "blocked": "Not enrolled",
          "not_found": "Not found or outside your scope"
        },
        "reason": {
          "deadline_passed": "The enrolment deadline has passed.",
          "full": "The session is full and has no waiting list.",
          "waitlist_full": "The session and its waiting list are full.",
          "already_enrolled_here": "Is already on this session.",
          "already_enrolled_elsewhere": "Is already enrolled in another session of this learning activity.",
          "not_visible": "This learning activity is not intended for this person.",
          "suspended": "This person's account is blocked."
        }
      },
      "cancelCosts": {
        "before": "Before the cancellation deadline, cancelling costs {amount}.",
        "after": "After the cancellation deadline, cancelling costs {amount}.",
        "charge": "Charge the costs",
        "waiverReason": "Reason for waiving",
        "waiverReasonRequired": "Give a reason for waiving the costs.",
        "managerHint": "Only an administrator with rights over the whole environment can waive the costs."
      }
    },
    "archiveLive": {
      "title": "Archiving: occurrences are still scheduled",
      "body": "{activities} activity/activities in this selection have {occurrences} occurrence(s) still to take place, with {enrollments} active enrolment(s). The first is on {date}. Choose what should happen to them.",
      "choose": "What happens to the occurrences still running?",
      "keep_running": "Stop offering, but finish what is running",
      "keep_runningHint": "These activities become Hidden instead of Archived: they disappear from the catalogue, but anyone enrolled completes the occurrence. Nothing changes about the enrolments.",
      "cancel_enrollments": "Unenrol everyone and archive",
      "cancel_enrollmentsHint": "The occurrences are cancelled and all participants and waiting-list registrations are withdrawn. Everyone is notified. This cannot be undone.",
      "confirmKeep": "Hide",
      "confirmCancel": "Unenrol and archive"
    },
    "anonymous": {
      "label": "Can be opened without logging in",
      "help": "Anyone with the link can take the course, even without an account. Meant to show what a course is — not to let someone complete it.",
      "warning": "Note: for a course started without logging in, we save no progress and no result — there is no participant to attach it to. And the audience above does not apply to this link: whoever has it, gets in.",
      "linkLabel": "Link to share"
    },
    "completionRule": {
      "completed": "The course reports that it is completed",
      "progress_percentage": "Getting through part of the content",
      "minimum_score": "Reaching a minimum score",
      "opened": "Opening it counts as completing it",
      "attendance": "Present according to the attendance list",
      "declaration": "Someone states that it has been done"
    },
    "completionRuleBulk": {
      "action": "Set completion rule",
      "title": "Set completion rule",
      "scopeSelection": "For the {count} selected courses.",
      "scopeAll": "For all {count} courses matching the filter.",
      "choose": "What do you want to set?",
      "determined": "Fill in what is fixed",
      "determinedHint": "A meeting, a link, a file or a manual record allows only one rule. The system fills that in. Courses that do offer a choice are left untouched.",
      "explicit": "Set this rule",
      "explicitHint": "For e-learning and LTI, where three rules are possible. Courses with another source are left out.",
      "preview": "What will this do?",
      "previewResult": "{count} courses will get a completion rule",
      "skipLine": "{count} × {reason}",
      "confirm": "Set",
      "done": "{updated} updated, {skipped} skipped.",
      "skip": {
        "already_set": "already had one",
        "needs_choice": "you need to choose here",
        "source_forbids": "does not match the source",
        "package_cannot_measure": "the file does not measure this"
      }
    },
    "rules": {
      "evaluationsTitle": "Evaluations",
      "testsTitle": "Tests",
      "evaluationsIntro": "Questionnaires that participants fill in about this activity. A rule applies to all occurrences.",
      "testsIntro": "Tests that a trainer marks. A rule applies to all occurrences. If a test counts toward passing, completion — and so the qualification — only follows once the test has been marked and passed.",
      "add": "Add rule",
      "empty": "No rules yet.",
      "emptyNew": "No rules yet. What you add here is saved as soon as you create the activity.",
      "draftBadge": "Draft",
      "external": "External",
      "pendingNote": "Saved as soon as you create the activity.",
      "needsSource": "Choose a type first, then you can add rules here.",
      "failedAfterCreate": "“{title}” was created, but one or more rules could not be saved. Add them again below.",
      "mandatory": "Counts toward passing",
      "removed": "The rule has been deleted.",
      "archivedInstead": "The rule has been stopped: something was already sent, so it cannot be deleted.",
      "removeTitle": "Delete rule?",
      "removeBody": "The rule and whatever was still queued for participants disappear. If something was already sent, the rule is stopped instead.",
      "saveFirstNeeds": "To add a rule, the activity is first saved as a draft. Please fill in first:",
      "referenceNote": "Reference material is never completed. A qualification or test cannot be attached to it; an evaluation can. If qualifications or tests are already attached, they are removed when you save.",
      "testsNeedSessions": "A test can only be added to a classroom activity, with sessions.",
      "createTest": "Create a new test",
      "createEvaluation": "Create a new evaluation"
    },
    "links": {
      "qualifications": "Qualifications",
      "evaluations": "Evaluations",
      "tests": "Tests"
    },
    "list": {
      "publishPlanned": "Scheduled: {date}",
      "publishFailed": "Publication failed"
    },
    "earlyClose": {
      "title": "This session has not ended yet",
      "notStarted": "This session starts on {date}. No day has taken place yet.",
      "partial": "There are days still to come: {remaining} of the {total} days have not passed yet. Anyone who did not attend every day is left without an outcome.",
      "confirm": "Close anyway",
      "keep": "Do not close"
    },
    "view": {
      "label": "View",
      "cards": "Cards",
      "list": "List"
    },
    "card": {
      "parts_one": "{count} part",
      "parts_other": "{count} parts"
    },
    "sources": {
      "heading": "Material per language",
      "help": "For another language you can add its own package, link or course address. Learners get their own language by default and can choose another.",
      "primaryLanguages": "Languages of this material",
      "languages": "Languages",
      "other": "Material for another language ({n})",
      "add": "Add material for another language",
      "notForThisKind": "A file per language is not yet possible; choose above the languages this file covers."
    },
    "help": {
      "completionRule": "When a participant has finished this training: when the content reports it as completed, at a minimum score, at a percentage worked through, or once they have opened it. Which rules are available depends on the source.",
      "accessGroup": "An access group describes once who may see something, and can be used in several places. You build it under Access › Access groups; here you choose one.",
      "promotionMode": "What happens when a place becomes free: the first person on the waiting list is enrolled straight away, or is offered the place and decides within the reply period.",
      "studyLoad": "The duration is how long the training itself takes. The study load is the total time a participant spends on it, including preparation, homework and tests."
    },
    "occurrences": {
      "results_one": "{count} session",
      "results_other": "{count} sessions",
      "notPlanned": "No date yet",
      "moreDays_one": "+ {count} day",
      "moreDays_other": "+ {count} days"
    },
    "notFound": {
      "title": "This catalogue does not exist",
      "body": "The link is no longer valid, or this catalogue is not meant for you. Ask your administrator if you think you should see it.",
      "back": "To the catalogue"
    },
    "certificate": {
      "label": "Certificate",
      "loading": "Loading certificate templates…",
      "loadError": "The certificate templates could not be loaded.",
      "asActivity": "As the activity",
      "unavailableTemplate": "Template no longer available",
      "none": "No certificate",
      "help": {
        "activity": "Choose the template for the certificate. The certificate is created automatically when someone completes this activity. By default the activity follows the environment choice (Settings → Certificates).",
        "occurrence": "By default a participant gets the certificate the activity chooses. Only choose something else here if this occurrence should differ."
      },
      "archivedWarning": "This template is archived or no longer available. Certificates are still being made with it; choose another template if that is not intended."
    }
  },
  "catalogSettings": {
    "heading": "Catalog settings",
    "intro": "Set the default values for the catalog and enrolments here. New activities and occurrences fall back to these values.",
    "saved": "Settings saved.",
    "waitlist": {
      "legend": "Waiting list",
      "enabledByDefault": "Waiting list on by default",
      "enabledByDefaultHint": "New occurrences turn the waiting list on by default when an occurrence is full.",
      "promotionMode": "Promotion mode",
      "offerWindowHours": "Offer window (hours)",
      "offerWindowHoursHint": "How many hours a promoted waiter gets to accept an offered spot.",
      "cap": "Waiting-list cap",
      "capHint": "Leave empty for an unlimited waiting list.",
      "capPlaceholder": "Unlimited"
    },
    "deadlines": {
      "legend": "Deadlines",
      "hint": "The default number of calendar days before the first day of an occurrence. An activity can choose its own number; empty means no default.",
      "enrollmentDays": "Enrolment closes (days before the first day)"
    },
    "enrollment": {
      "legend": "Enrollment",
      "hint": "How many times someone may take part or join the waiting list at once for an activity. New activities start with these values.",
      "maxEnrollments": "Number of enrollments",
      "maxWaitlistRegistrations": "Number of waitlist registrations",
      "cancellationFlow": "Approval flow for cancelling",
      "cancellationFlowHint": "Who decides a cancellation request for a new activity, when the cancellation terms ask for approval. Separate from the enrolment flow: it may be the same, but is not by default.",
      "cancellationFlowNone": "None"
    },
    "visibility": {
      "legend": "Visibility",
      "mode": "Visibility mode"
    },
    "durationPresets": {
      "legend": "Preferred durations",
      "hint": "The choice list for the duration of a training. Each choice stands for a number of minutes (half a day is 240). A training can always deviate from it.",
      "empty": "Without choices of your own, the standard list applies.",
      "add": "Add preferred duration",
      "restore": "Restore standard list",
      "rowTitle": "Preferred duration {n}",
      "minutes": "Minutes"
    },
    "learningForms": {
      "legend": "Learning forms",
      "hint": "A label for the learner on every training, with a colour. For a training you choose from this list.",
      "add": "Add learning form",
      "rowTitle": "Learning form {n}",
      "color": "Colour",
      "preview": "How the learner sees it",
      "inUse": "In use by an activity: cannot be removed.",
      "colorOption": {
        "primary": "Primary",
        "accent": "Accent",
        "success": "Green",
        "warning": "Orange",
        "error": "Red",
        "info": "Blue",
        "neutral": "Grey"
      }
    },
    "lists": {
      "nameIn": "Name in {language}",
      "up": "Up",
      "down": "Down",
      "remove": "Remove",
      "upFor": "Up: {name}",
      "downFor": "Down: {name}",
      "removeFor": "Remove: {name}"
    },
    "activityFields": {
      "legend": "Characteristics",
      "hint": "Your own fields on every activity: free text, a choice list or yes/no. A choice list or yes/no can be a filter in the catalogue; that is off by default.",
      "rowTitle": "Characteristic {n}",
      "kindLabel": "Kind",
      "kind": {
        "text": "Free text",
        "choice": "Choice list",
        "boolean": "Yes/no"
      },
      "active": "Active",
      "filterable": "Show as a filter in the catalogue",
      "options": "Options",
      "optionTitle": "Option {n}",
      "addOption": "Add option",
      "add": "Add characteristic",
      "inUse_one": "Used on {count} activity.",
      "inUse_other": "Used on {count} activities.",
      "kindLocked": "The kind is fixed once there are values.",
      "removeTitle": "Delete characteristic?",
      "removeBody_one": "\"{name}\" is used on {count} activity. Deleting removes that value when you save. To only hide it, switch it off instead.",
      "removeBody_other": "\"{name}\" is used on {count} activities. Deleting removes those values when you save. To only hide it, switch it off instead.",
      "saved": "The characteristics have been saved.",
      "empty": "No characteristics yet."
    },
    "summary": {
      "waitlistOff": "off",
      "waitlistOnOffer": "on, offer {hours} h",
      "waitlistOnAuto": "on, promotes automatically",
      "waitlistCap": "max. {cap}",
      "daysBefore_one": "{count} day before",
      "daysBefore_other": "{count} days before",
      "noDeadline": "no default",
      "enrollment": "enrolments: {enrollments}, waiting list: {waitlist}",
      "durationPresets_one": "{count} duration",
      "durationPresets_other": "{count} durations",
      "learningForms_one": "{count} learning form",
      "learningForms_other": "{count} learning forms",
      "activityFields_one": "{count} active characteristic",
      "activityFields_other": "{count} active characteristics",
      "activityFieldsNone": "none yet",
      "deadlinesEnrollment": "enrolling: {enrollment}"
    },
    "unsaved": {
      "title": "Save changes?",
      "body": "You changed something under {section} that has not been saved yet.",
      "discard": "Don't save"
    }
  },
  "settingsHub": {
    "heading": "Settings",
    "intro": "Set up your environment here. Pick a section.",
    "readOnly": "You can view these settings but not change them.",
    "tabs": {
      "catalog": "Catalogue",
      "approvals": "Approvals",
      "messages": "Messages",
      "questionnaires": "Questionnaires",
      "retention": "Retention",
      "catalogs": "Catalogues",
      "cancellation": "Cancellation terms",
      "languages": "Content languages",
      "documents": "Certificates"
    },
    "empty": "There is nothing here you are allowed to set up.",
    "breadcrumb": "Breadcrumb",
    "pages": {
      "catalog": "Catalogue settings"
    },
    "themes": {
      "catalog": "Catalogue",
      "processes": "Processes",
      "textsMessages": "Texts and messages",
      "evaluationData": "Evaluation and data",
      "integrations": "Integrations"
    },
    "descriptions": {
      "catalog": "Defaults for a new training: waiting list, enrolment, deadlines, learning formats and attributes.",
      "catalogs": "The catalogues, what is in them and who may open them.",
      "themes": "The categories you sort trainings into.",
      "cancellationReasons": "The reasons to choose from when cancelling.",
      "approvals": "Which approval flow applies by default.",
      "approvalFlows": "Who approves what, and in which order.",
      "workflows": "What happens automatically after an event.",
      "texts": "Your own wording for the texts in the platform.",
      "messages": "How often the digest email is sent.",
      "questionnaires": "Response period, reminders and scale.",
      "retention": "How long learning history and other data are kept.",
      "lti": "External learning environments via LTI.",
      "cancellation": "Until when cancelling is possible, who decides and what it costs.",
      "languages": "Which languages your trainings and their material come in.",
      "documentTemplates": "The templates for certificates, with their versions.",
      "documents": "How the certificate number starts, and whether the BCS templates can be chosen."
    }
  },
  "questionBank": {
    "heading": "Questionnaires",
    "heading_test": "Tests",
    "intro": "Questions, categories and forms are the building blocks of a questionnaire. A question can appear in several categories, a category in several forms, and a form in several rules.",
    "intro_test": "Questions, categories and tests belong together. A question can appear in several categories, a category in several tests, and a test in several rules on a training.",
    "tabs": {
      "questions": "Questions",
      "categories": "Categories",
      "forms": "Forms",
      "forms_test": "Tests",
      "surveys": "Stand-alone questionnaires",
      "assignments": "Evaluation rules",
      "assignments_test": "Test rules"
    },
    "status": {
      "filter": "Show",
      "active": "Active",
      "archived": "Archived",
      "all": "All"
    },
    "type": {
      "open": "Open question",
      "scale": "Scale",
      "multiple_choice": "Multiple choice",
      "yes_no": "Yes/no"
    },
    "typeHint": {
      "scale": "Scale {min}–{max}",
      "multiple_choice_one": "Multiple choice, {count} option",
      "multiple_choice_other": "Multiple choice, {count} options"
    },
    "archivedBadge": "Archived",
    "changeHint": "A change applies to invitations created from now on. Anything already sent stays as it was.",
    "fixErrors": "Saving did not work. Please check the highlighted fields.",
    "saveFailed": "Saving did not work. Please try again.",
    "actionFailed": "That did not work. Please try again.",
    "actions": {
      "edit": "Edit",
      "view": "View",
      "copy": "Copy",
      "archive": "Archive",
      "restore": "Restore",
      "delete": "Delete",
      "editNamed": "Edit {name}",
      "viewNamed": "View {name}",
      "copyNamed": "Copy {name}"
    },
    "text": {
      "tabsLabel": "Language of the texts",
      "tabsHint": "Write the texts per language. {language} is the default language and required; a language without text falls back to the default language.",
      "tabIncomplete": "{language} (incomplete)",
      "tabError": "{language} (error)",
      "hiddenLocale": "{language} (switched off):",
      "hiddenNotice": "Some texts are in a language that is switched off for this environment: {languages}. They are kept but not shown, and they come back as soon as the language is switched on again. You can remove them per field.",
      "removeHidden": "Remove the {language} text from {field}"
    },
    "questions": {
      "count_one": "{count} question",
      "count_other": "{count} questions",
      "new": "New question",
      "empty": "There are no questions in the bank yet.",
      "emptyFiltered": "No questions with this status.",
      "loadError": "The questions could not be loaded.",
      "column": {
        "prompt": "Question",
        "type": "Type",
        "categories": "In categories",
        "forms": "In forms",
        "forms_test": "In tests",
        "actions": "Actions"
      }
    },
    "question": {
      "newTitle": "New question",
      "texts": "Texts",
      "editTitle": "Edit question",
      "viewTitle": "View question",
      "backToList": "Back to the questions",
      "loadError": "This question could not be loaded.",
      "saved": "The question has been saved.",
      "copied": "This is the copy. Adjust it as you like: a copy's shape is open again.",
      "readOnly": "You can view this question, but not change it.",
      "archivedNotice": "This question is archived. It can no longer be added to a category; where it already is, it stays.",
      "locked": {
        "title": "The shape of this question is fixed",
        "body": "It has already been answered, or it is in an invitation that can still be filled in. The type, the range, one or more answers and the existing options therefore stay as they are. You can still change the wording, the help text, whether it is required, and add a new option. Need a different shape? Copy the question."
      },
      "fields": {
        "type": "Type of question",
        "prompt": "Question",
        "helpText": "Help text",
        "helpTextHint": "Shown below the question.",
        "required": "An answer is required",
        "placeholder": "Example text in the field",
        "minChars": "Minimum number of characters",
        "maxChars": "Maximum number of characters",
        "testimonial": "Answers may be used as quotes",
        "testimonialHint": "To be shown on the training page later.",
        "requiredQuoteReason": "A question whose answers may be used as a quote cannot be required.",
        "minValue": "Lowest value",
        "maxValue": "Highest value",
        "scaleDisplay": "Display",
        "scaleLabels": "Text per point",
        "scaleLabelsHint": "Optional. Without a text the participant sees, for example, “3 of 5”.",
        "scaleLabelsTooMany": "You can give a text per point on a scale of at most {max} points.",
        "scalePoint": "Point {point}",
        "options": "Answer options",
        "noOptions": "There are no options yet.",
        "option": "Option {n}",
        "addOption": "Add option",
        "moveOptionUp": "Move option {n} up",
        "moveOptionDown": "Move option {n} down",
        "removeOption": "Remove option {n}",
        "allowsMultiple": "More than one answer allowed",
        "allowsOther": "Offer “Other, namely”",
        "allowsOtherHint": "Next to the other choices, not instead of them."
      },
      "choiceLimits": {
        "hint": "Leave a limit empty if there is none. The minimum is at least one below the number of options ({count}, counting “other, namely”), and the maximum fits within it. A required question always needs at least one answer.",
        "min": "Minimum number to choose",
        "max": "Maximum number to choose",
        "minTooHigh": "The minimum must be at least one lower than the number of options ({count}).",
        "maxTooHigh": "The maximum cannot be higher than the number of options ({count}).",
        "backwards": "The maximum is lower than the minimum.",
        "notAWholeNumber": "Enter a whole number of 1 or more."
      },
      "scaleDisplay": {
        "numbers": "Numbers",
        "stars": "Stars"
      },
      "usage": {
        "title": "Where this question is used",
        "categories": "Categories",
        "forms": "Forms",
        "forms_test": "Tests",
        "assignments": "Running assignments",
        "unused": "This question is not used anywhere yet."
      },
      "delete": {
        "title": "Delete question",
        "body": "The question disappears from the bank. This cannot be undone.",
        "confirm": "Delete"
      }
    },
    "categories": {
      "count_one": "{count} category",
      "count_other": "{count} categories",
      "new": "New category",
      "empty": "There are no categories yet.",
      "emptyFiltered": "No categories with this status.",
      "loadError": "The categories could not be loaded.",
      "column": {
        "title": "Title",
        "questions": "Questions",
        "forms": "In forms",
        "forms_test": "In tests",
        "actions": "Actions"
      }
    },
    "category": {
      "newTitle": "New category",
      "editTitle": "Edit category",
      "viewTitle": "View category",
      "backToList": "Back to the categories",
      "loadError": "This category could not be loaded.",
      "saved": "The category has been saved.",
      "copied": "This is the copy, with the same questions. If a question needs to differ as well, copy it separately.",
      "readOnly": "You can view this category, but not change it.",
      "archivedNotice": "This category is archived. It can no longer be added to a form; where it already is, it stays.",
      "archivedNotice_test": "This category is archived. It will not appear in any new test; where it already is, it stays.",
      "fields": {
        "title": "Title",
        "description": "Description"
      },
      "questions": {
        "title": "Questions in this category",
        "hint": "They appear in the form in this order.",
        "hint_test": "They appear in the test in this order.",
        "empty": "There are no questions in this category yet.",
        "add": "Add question",
        "search": "Search for a question in the bank",
        "noResults": "No questions found.",
        "moveUp": "Move “{question}” up",
        "moveDown": "Move “{question}” down",
        "remove": "Remove “{question}” from the category"
      },
      "usage": {
        "title": "Where this category is used",
        "forms": "Forms",
        "forms_test": "Tests",
        "assignments": "Running assignments",
        "unused": "This category is not in any form yet.",
        "unused_test": "This category is not in any test yet."
      },
      "delete": {
        "title": "Delete category",
        "body": "The category disappears. The questions in it stay in the bank. This cannot be undone.",
        "confirm": "Delete"
      },
      "actions": {
        "saveAndNewQuestion": "Save and create new question"
      }
    },
    "forms": {
      "count_one": "{count} form",
      "count_test_one": "{count} test",
      "count_other": "{count} forms",
      "count_test_other": "{count} tests",
      "new": "New form",
      "new_test": "New test",
      "empty": "There are no forms yet.",
      "empty_test": "There are no tests yet.",
      "emptyFiltered": "No forms with this status.",
      "emptyFiltered_test": "No tests with this status.",
      "loadError": "The forms could not be loaded.",
      "loadError_test": "The tests could not be loaded.",
      "filter": {
        "current": "Draft and published",
        "draft": "Draft",
        "published": "Published",
        "archived": "Archived",
        "all": "All"
      },
      "column": {
        "title": "Title",
        "status": "Status",
        "assignments": "Assignments",
        "actions": "Actions"
      }
    },
    "form": {
      "newTitle": "New form",
      "newTitle_test": "New test",
      "editTitle": "Edit form",
      "editTitle_test": "Edit test",
      "viewTitle": "View form",
      "viewTitle_test": "View test",
      "backToList": "Back to the forms",
      "backToList_test": "Back to the tests",
      "loadError": "This form could not be loaded.",
      "loadError_test": "This test could not be loaded.",
      "saved": "The form has been saved.",
      "saved_test": "The test has been saved.",
      "copied": "This is the copy: a new draft with the same categories. If a category needs to differ, copy it separately.",
      "published": "The form has been published and can now be linked to a training.",
      "published_test": "The test has been published and can now be linked to a training.",
      "publishFailed": "Publishing did not work. Please check the highlighted fields.",
      "readOnly": "You can view this form, but not change it.",
      "readOnly_test": "You can view this test, but not change it.",
      "archivedNotice": "This form is archived and can no longer be linked to a training. Restore it to turn it back into a draft.",
      "archivedNotice_test": "This test is archived and can no longer be linked to a training. Restore it to turn it back into a draft.",
      "status": {
        "draft": "Draft",
        "published": "Published",
        "archived": "Archived"
      },
      "statusPanel": {
        "title": "Status",
        "new": "A new form is saved as a draft.",
        "new_test": "A new test is saved as a draft.",
        "draft": "A draft cannot be linked to a training yet. Publish it when it is finished; everything is checked then.",
        "published": "The form can be linked to trainings. It stays editable as long as it remains publishable.",
        "published_test": "The test can be linked to trainings. It stays editable as long as it remains publishable.",
        "archived": "The form is in the archive. Restoring it turns it back into a draft.",
        "archived_test": "The test is in the archive. Restoring turns it back into a draft."
      },
      "fields": {
        "title": "Title",
        "description": "Description",
        "descriptionHint": "Shown below the title.",
        "headerText": "Header text",
        "headerTextHint": "Shown above the questions, for example a welcome.",
        "footerText": "Footer text",
        "footerTextHint": "Shown below the questions, for example a thank-you.",
        "allowRemarks": "Room for a remark at the end",
        "allowRemarksHint": "The participant can leave a free remark, separate from the questions."
      },
      "categories": {
        "title": "Categories in this form",
        "title_test": "Categories in this test",
        "hint": "They appear in the questionnaire in this order. A question appears only once in a form.",
        "hint_test": "They appear in the test in this order. A question appears only once in a test.",
        "empty": "There are no categories in this form yet.",
        "empty_test": "There are no categories in this test yet.",
        "add": "Add category",
        "search": "Search for a category",
        "noResults": "No categories found.",
        "questionCount_one": "{count} question",
        "questionCount_other": "{count} questions",
        "moveUp": "Move “{category}” up",
        "moveDown": "Move “{category}” down",
        "remove": "Remove “{category}” from the form",
        "remove_test": "Remove “{category}” from the test"
      },
      "actions": {
        "publish": "Publish",
        "saveAndNewCategory": "Save and create new category"
      },
      "delete": {
        "title": "Delete form",
        "title_test": "Delete test",
        "body": "The form disappears. The categories and questions in it stay in the bank. This cannot be undone.",
        "body_test": "The test is removed. The categories and questions in it stay in the bank. This cannot be undone.",
        "confirm": "Delete"
      },
      "assignments": {
        "title": "Assignments",
        "unused": "This form is not linked to any training yet.",
        "unused_test": "This test is not linked to any training yet.",
        "total": "In use",
        "pausable": "Can be paused",
        "pausedViaForm": "Paused through this form",
        "pausedSeparately": "Paused separately, stays paused on resume",
        "held_one": "{count} assignment is paused through this form. Nothing is sent until you resume.",
        "held_other": "{count} assignments are paused through this form. Nothing is sent until you resume.",
        "hint": "Want to improve the form while it is in use? Pause all assignments first, adjust it, then resume them. Links that were already sent keep working.",
        "listTitle": "Per assignment",
        "unknownTraining": "Training without a name",
        "openNamed": "Invitations for {training}",
        "invitations_one": "{count} invitation",
        "invitations_other": "{count} invitations"
      },
      "pause": {
        "open": "Pause all assignments",
        "title": "Pause all assignments",
        "body_one": "The running assignment of this form will be paused. Until you resume, nothing is sent: anyone who finishes in the meantime only gets the invitation when you resume, if you then choose to pick it up. Links that were already sent keep working.",
        "body_other": "The {count} running assignments of this form will be paused. Until you resume, nothing is sent: anyone who finishes in the meantime only gets the invitation when you resume, if you then choose to pick it up. Links that were already sent keep working.",
        "confirm": "Pause",
        "done_one": "{count} assignment is now paused.",
        "done_other": "{count} assignments are now paused."
      },
      "resume": {
        "open": "Resume…",
        "title": "Resume assignments",
        "loadError": "What is waiting could not be loaded.",
        "intro": "Nothing was sent during the pause. This is waiting per training: invitations from before the pause, and from people who finished during it.",
        "nothingHeld": "Nothing is waiting. Resuming turns the assignments back on; anyone who finishes afterwards gets the form as it is then.",
        "table": {
          "caption": "Waiting invitations per training",
          "training": "Training",
          "before": "From before the pause",
          "during": "During the pause",
          "oldest": "Oldest",
          "beyond": "Cancelled by the limit",
          "total": "Total",
          "days_one": "{count} day",
          "days_other": "{count} days",
          "none": "none",
          "unknownTraining": "Training without a name"
        },
        "choice": {
          "legend": "What happens to the waiting invitations?",
          "pickUp": "Pick them up",
          "pickUpHint": "They are sent after all, all with the form as it is now. If their moment has passed, they go now; the response window starts when they are sent.",
          "decline": "Do not pick them up",
          "declineHint": "They are cancelled, and anyone who finished during the pause does not get one.",
          "required": "Choose whether to pick up the waiting invitations."
        },
        "limit": {
          "label": "Age limit in days",
          "hint": "Optional: only invitations younger than this number of days are picked up; older ones are cancelled. Leave empty to pick up everything.",
          "beyond_one": "With this limit, {count} of the {total} waiting invitations is cancelled; the rest is picked up.",
          "beyond_other": "With this limit, {count} of the {total} waiting invitations are cancelled; the rest are picked up.",
          "checkFailed": "The limit could not be checked."
        },
        "confirm": "Resume",
        "done_one": "{count} assignment is running again. Picked up: {refrozen}, cancelled: {withdrawn}.",
        "done_other": "{count} assignments are running again. Picked up: {refrozen}, cancelled: {withdrawn}."
      },
      "backToWizard": "Back to the training",
      "fromWizardHint": "You came from the training you are creating. Publish this form to choose it there; you will then return automatically. What you entered in the training has been kept."
    },
    "gradingLink": "Go to grading"
  },
  "questionnaireSettings": {
    "intro": "The defaults that new invitations and scale questions start with. If you leave a field empty, the platform default applies.",
    "followsPlatform": "You haven't set anything of your own here yet: the platform defaults apply throughout.",
    "window": {
      "legend": "Response period",
      "hint": "How long an invitation can be filled in after it is sent, unless the assignment says otherwise. A change applies to invitations sent from now on.",
      "label": "Number of days",
      "platform_one": "Empty: {count} day, the platform default.",
      "platform_other": "Empty: {count} days, the platform default."
    },
    "reminder": {
      "legend": "Reminders",
      "hint": "How many days an invitation stays open before remind everyone and the automatic reminder include it. This way nobody gets a reminder right after the invitation. A reminder to one person sent by hand ignores this.",
      "zero": "0: no minimum.",
      "label": "Minimum number of days after sending",
      "platform_one": "Empty: {count} day, the platform default.",
      "platform_other": "Empty: {count} days, the platform default."
    },
    "scale": {
      "legend": "Scale range",
      "hint": "The range a new scale question starts with. You can adjust it per question; existing questions keep their own range.",
      "pairRule": "Fill in both values, or leave both empty.",
      "min": "Lowest value",
      "max": "Highest value",
      "platform": "Empty: {value}, the platform default."
    },
    "saved": "The settings have been saved.",
    "saveFailed": "Saving failed."
  },
  "retentionSettings": {
    "intro": "How long the learning history of your environment is kept, per type of record and counted from the date of the record. When the period has passed, the nightly retention run deletes the record — the record, not the person. Leave a field empty to keep the record.",
    "keepHint": "Empty: keep. That is the default.",
    "defaultHint_one": "Default: {count} month. Empty: keep.",
    "defaultHint_other": "Default: {count} months. Empty: keep.",
    "keepPlaceholder": "Keep",
    "types": {
      "enrollment": "Enrolments (months)",
      "attendance": "Attendance (months)",
      "attempt": "E-learning attempts (months)",
      "completion": "Completions (months)",
      "qualification": "Qualifications (months after ending or expiry)",
      "certificate": "Certificates (months)",
      "evaluation_response": "Evaluations (months after submission)",
      "import_raw_data": "Raw import data (months)"
    },
    "history": {
      "legend": "Learning history",
      "hint": "Completions, qualifications and certificates are kept by default: they are the proof of what someone achieved. An enrolment or completion that still carries something that is kept is skipped until that has expired too. A qualification that is still valid is never deleted."
    },
    "evaluation": {
      "legend": "Evaluations",
      "hint": "Submitted evaluations and other opinions. A knowledge test has no period of its own: it goes together with the completion it belongs to.",
      "action": "After the period",
      "actions": {
        "anonymise": "Anonymise: the answers stay for reporting, without a name",
        "delete": "Delete: the response and its answers are removed"
      }
    },
    "imports": {
      "legend": "Raw import data",
      "hint": "The rows read from an HR file, with for example names and dates of birth. After the period they are emptied; the summary of the import stays."
    },
    "fixed": {
      "legend": "Fixed periods",
      "personalData_one": "The personal data of a deleted user is made unrecognisable {count} day after the deletion. BCS sets this period for your environment.",
      "personalData_other": "The personal data of a deleted user is made unrecognisable {count} days after the deletion. BCS sets this period for your environment.",
      "mailOutbox_one": "Sent e-mails are deleted after {count} day (a platform period).",
      "mailOutbox_other": "Sent e-mails are deleted after {count} days (a platform period)."
    },
    "lastRun": {
      "legend": "Last applied",
      "none": "The retention periods have not been applied yet. This happens every night.",
      "summary": "On {date}: {erased} users made unrecognisable, {records} records processed and {shells} empty accounts removed."
    },
    "saved": "The retention periods have been saved.",
    "saveFailed": "Saving did not succeed."
  },
  "questionnaireStatus": {
    "heading": "Rule status",
    "heading_test": "Test rule status",
    "backToForm": "To the form",
    "backToForm_test": "Go to the test",
    "backToSurveys": "To the stand-alone questionnaires",
    "backToTraining": "To the training",
    "subject": "{form} for {training}",
    "subjectWithoutTraining": "Questionnaire {form}",
    "subjectWithoutTraining_test": "Test {form}",
    "anonymous": "Anonymous",
    "anonymousNote": "This rule is anonymous: you can see how many invitations are in each state, but not whose they are. Reminding or resending per person is therefore not possible; reminding everyone who is still open is.",
    "anonymousBelowFloor": "The results stay hidden until {floor} responses are in, across all sessions together. So far: {counted} of {floor}.",
    "loadError": "This rule could not be loaded.",
    "loadError_test": "This test rule could not be loaded.",
    "notFound": "This rule does not exist (any more).",
    "notFound_test": "This test rule does not (or no longer) exist.",
    "actionFailed": "That did not work. Please try again.",
    "backToRule": "To the rule",
    "backToRule_test": "Go to the test rule",
    "occurrence": {
      "heading": "Assignment: {date}, {location}",
      "headingNoLocation": "Assignment: {date}",
      "headingLoading": "Assignment",
      "notFound": "This assignment does not exist (any more).",
      "loadError": "This assignment could not be loaded."
    },
    "occurrences": {
      "title": "Assignments",
      "hint": "Per session of the training: who has been invited and how far along they are. Open an assignment to see the people.",
      "empty": "Nothing has been invited for this rule yet.",
      "empty_test": "Nobody has been invited for this test rule yet.",
      "loadError": "The assignments could not be loaded.",
      "future_one": "{count} future session, nothing sent yet.",
      "future_other": "{count} future sessions, nothing sent yet.",
      "column": {
        "date": "Session",
        "location": "Location",
        "trainers": "Trainers",
        "sent": "Sent",
        "submitted": "Completed",
        "open": "Open",
        "expired": "Expired",
        "actions": "Actions"
      },
      "sentOf": "{sent} of {invited}",
      "submittedOf": "{count} ({percent}%)",
      "view": "View",
      "viewNamed": "View the assignment of {name}",
      "noDate": "No date",
      "none": "–"
    },
    "assignment": {
      "active": "Running",
      "paused": "Paused",
      "archived": "Archived"
    },
    "notRunning": {
      "paused": "This rule is paused. Reminding and resending are possible again once it is resumed; links that were already sent keep working.",
      "paused_test": "This test rule is paused. Nothing goes out until it is resumed.",
      "archived": "This rule is archived. Reminding and resending are no longer possible; links that were already sent keep working until they expire.",
      "archived_test": "This test rule is archived and sends nothing any more."
    },
    "counts": {
      "title": "Counts",
      "loadError": "The counts could not be loaded.",
      "empty": "No invitations have been created from this rule yet.",
      "mailFailed": "Mail failed",
      "mailFailedHint": "When a mail fails, the invitation is marked as sent but the mail did not arrive. Send again sends it once more: with a new link, or with the address in My questionnaires when the questionnaire only opens in the app.",
      "submittedOf": "of {total} ({percent}%)",
      "submittedHint": "Invitations for which the questionnaire has been completed.",
      "submittedHint_test": "Invitations for which the test has been completed.",
      "open": "Open",
      "openHint": "Sent and still to be completed.",
      "expiredHint": "The response period ended without a response. Sending again reopens the invitation.",
      "moreDetail": "More: what is still to go out and what will not go ahead",
      "lessDetail": "Show less",
      "toSend": "Still to go out",
      "toSendHint": "Not sent yet: scheduled, waiting for attendance, waiting for a final completion, or held during a pause.",
      "notGoingAhead": "Will not go ahead",
      "notGoingAheadHint": "Cancelled or no longer to be sent, with the reason."
    },
    "state": {
      "waiting": "Waiting to be sent",
      "held": "On hold",
      "waiting_for_attendance": "Waiting for attendance",
      "waiting_for_completion": "Waiting until the completion is final",
      "sent": "Sent",
      "submitted": "Submitted",
      "expired": "Expired",
      "cancelled": "Cancelled",
      "recipient_inactive": "Recipient inactive",
      "waitingReady": "Ready to be sent"
    },
    "reason": {
      "completion_withdrawn": "Completion withdrawn",
      "condition_not_met": "Condition not met",
      "pause_declined": "Not picked up after the pause",
      "archived": "Assignment archived",
      "recipient_inactive": "Recipient inactive",
      "session_removed": "Session removed",
      "occurrence_cancelled": "Occurrence cancelled",
      "enrollment_cancelled": "Enrolment cancelled",
      "unknown": "Unknown reason"
    },
    "list": {
      "title": "Invitations",
      "loadError": "The invitations could not be loaded.",
      "empty": "There are no invitations yet.",
      "column": {
        "respondent": "Recipient",
        "state": "Status",
        "sent": "Sent",
        "expires": "Expires",
        "reminded": "Last reminder",
        "actions": "Actions"
      },
      "erased": "Deleted user",
      "anonymousRespondent": "Anonymous",
      "scheduled": "Scheduled for {date}",
      "submittedOn": "Submitted on {date}",
      "withdrawnOn": "{reason}, on {date}",
      "cycle": "Round {cycle}",
      "notYet": "Not yet",
      "waitingUntil": "Goes out on {date}",
      "waitingNextRound": "Goes out in the next sending round",
      "sendingOff": "Sending is switched off for this environment; it goes out as soon as it is switched back on",
      "emptyFiltered": "No invitations in the group ‘{name}’."
    },
    "actions": {
      "remind": "Remind now",
      "remindNamed": "Remind {name} now",
      "resend": "Send again",
      "resendNamed": "Send again to {name}",
      "reminded": "A reminder is ready to go to {name}.",
      "resent": "A new link is ready to go to {name}.",
      "reopened": "A new link is ready to go to {name}. The invitation had expired and is reopened until {date}; earlier links stay closed.",
      "resentInApp": "An email to My questionnaires is ready to go to {name}.",
      "reopenedInApp": "An email to My questionnaires is ready to go to {name}. The invitation had expired and is reopened until {date}."
    },
    "filter": {
      "active": "Filter: {name}",
      "clear": "Clear filter: {name}"
    },
    "remindOpen": {
      "open": "Remind everyone still open",
      "title": "Remind everyone who is still open",
      "body_one": "{count} invitation is open. Whoever has not responded yet gets a reminder: with a new link, or with the address in My questionnaires when the questionnaire only opens in the app. A link sent earlier keeps working. Anyone who was reminded recently is skipped.",
      "body_other": "{count} invitations are open. Whoever has not responded yet gets a reminder: with a new link, or with the address in My questionnaires when the questionnaire only opens in the app. A link sent earlier keeps working. Anyone who was reminded recently is skipped.",
      "confirm": "Send reminders",
      "nothingOpen": "There is no open invitation to remind right now.",
      "done_one": "{count} reminder queued.",
      "done_other": "{count} reminders queued.",
      "previewWill_one": "{count} reminder will go out.",
      "previewWill_other": "{count} reminders will go out.",
      "previewSkipped_one": "{count} skipped ({reason}).",
      "previewSkipped_other": "{count} skipped ({reason}).",
      "daysAgo_one": "invited less than {count} day ago",
      "daysAgo_other": "invited less than {count} days ago",
      "skip": {
        "reminded_recently": "Reminded recently: {count}",
        "too_soon_after_send": "Invited too recently: {count}",
        "mail_on_its_way": "A mail was already on its way: {count}",
        "recipient_inactive": "Recipient inactive: {count}",
        "no_address": "No email address: {count}",
        "not_queued": "Mail could not be queued: {count}",
        "closed": "Submitted, cancelled or expired in the meantime: {count}"
      }
    },
    "openResults": "View results"
  },
  "auditLog": {
    "heading": "Audit log",
    "intro": "Who changed what, and when. Filter per column; no filter is applied by default, so you see everything, newest first.",
    "export": "Export (CSV)",
    "empty": "The audit log is still empty.",
    "emptyFiltered": "No entries match these filters.",
    "filterError": "This filter cannot be applied. Adjust it and try again.",
    "pagination": "Audit log pagination",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {page} of {pages}",
    "diffShow": "Details",
    "diffHide": "Hide",
    "diffBefore": "Old value",
    "diffAfter": "New value",
    "diffContext": "Data",
    "badge": {
      "bcs": "on behalf of BCS Learning"
    },
    "cols": {
      "when": "When",
      "category": "Category",
      "action": "Action",
      "actor": "Who",
      "target": "On what",
      "detail": "Detail"
    },
    "filters": {
      "from": "From date",
      "to": "Up to and including date",
      "category": "Category",
      "categoryAll": "All categories",
      "action": "Action",
      "actionPlaceholder": "Search by action",
      "actor": "Person",
      "actorAll": "All people",
      "bcsOnly": "Only actions on behalf of BCS Learning",
      "clearAll": "Clear all filters",
      "none": "This column has no filter",
      "targetActive": "You are viewing the history of a single item. Clear the filters to see the whole log."
    },
    "categories": {
      "inschrijvingen": "Enrolments",
      "catalogus": "Catalogue",
      "rechten": "Permissions",
      "berichten": "Messages",
      "inloggen": "Sign-in",
      "instellingen": "Settings",
      "organisatie": "Organisation",
      "beveiliging": "Security",
      "overig": "Other"
    },
    "diffField": "Field",
    "redacted": "hidden",
    "reference": {
      "erasedUser": "Deleted user",
      "erasedExternalPerson": "Deleted external person",
      "removed": "removed"
    },
    "actorSystem": "System",
    "actorSystemNamed": "System ({name})",
    "history": {
      "heading": "History",
      "openFullLog": "View in the log",
      "empty": "Nothing has been recorded about this yet.",
      "notFound": "This item does not exist here (any more), so there is no history to show.",
      "pagination": "History pagination",
      "show": "History",
      "enrollmentTitle": "History of the enrolment of {name}"
    },
    "archive": {
      "periodArchived": "This period has been archived.",
      "periodArchivedHint": "These entries are no longer in the log itself but in the archive. Export the month, or bring it back temporarily to search it here.",
      "olderArchived": "The log up to and including {month} has been archived. Choose a period in the When column to view it or bring it back.",
      "monthLabel": "{month} ({rows} entries)",
      "export": "Export",
      "restore": "Bring this period back",
      "restoring": "{month} is being brought back…",
      "restored": "{month} has been brought back until {date}.",
      "failed": "Bringing back {month} failed: the archive file did not match or could not be read.",
      "restoreError": "Bringing the period back could not be started. Please try again.",
      "noRight": "Only someone with the right to export the log can bring back or export a period.",
      "historyArchived": "Older history has been archived.",
      "historyRestored": "Older history has been brought back until {date}."
    },
    "fields": {
      "title": "Title",
      "summary": "Summary",
      "description": "Description",
      "status": "Status",
      "type": "Type",
      "name": "Name",
      "category": "Category",
      "first_name": "First name",
      "last_name": "Last name",
      "email": "Email address",
      "phone": "Phone number",
      "locale": "Language",
      "external_id": "External key",
      "attributes": "Additional details",
      "manager_user_id": "Manager",
      "hire_date": "Start date",
      "end_date": "End date",
      "account_valid_from": "Account valid from",
      "account_valid_until": "Account valid until",
      "last_login_at": "Last signed in",
      "profile_picture_url": "Profile photo",
      "password": "Password",
      "user_id": "Participant",
      "learning_activity_id": "Learning activity",
      "occurrence_id": "Session",
      "waitlist_position": "Waiting list position",
      "cancelled_at": "Cancelled on",
      "cancel_reason": "Cancellation note",
      "cancel_reason_id": "Cancellation reason",
      "cancel_requested_at": "Cancellation requested on",
      "transferred_from_enrollment_id": "Moved from enrolment",
      "offer_expires_at": "Offer expires on",
      "composition": "Composition",
      "tracking_mode": "Progress tracking",
      "source_kind": "Source",
      "source_file": "Source file",
      "completion_rule": "Completion rule",
      "completion_threshold": "Completion percentage",
      "duration": "Duration",
      "duration_minutes": "Duration (minutes)",
      "language": "Language",
      "labels": "Tags",
      "tags": "Tags",
      "visibility_mode": "Visibility",
      "access_group_id": "Access group",
      "allow_anonymous": "Anonymous access",
      "max_enrollments": "Number of enrolments",
      "max_waitlist_registrations": "Number of waiting list registrations",
      "approval_flow_id": "Approval chain",
      "waitlist_enabled": "Waiting list",
      "waitlist_promotion_mode": "Allocation when a place frees up",
      "offer_window_hours": "Offer window (hours)",
      "waitlist_cap": "Waiting list cap",
      "cancellation_deadline": "Cancellation deadline",
      "cancel_before": "Cancelling before the deadline",
      "cancel_after": "Cancelling after the deadline",
      "min_participants": "Min. participants",
      "max_participants": "Max. participants",
      "enrollment_deadline": "Enrolment deadline",
      "delivery_mode": "Delivery mode",
      "timezone": "Time zone",
      "waitlist_enabled_by_default": "Waiting list on by default",
      "waitlist_offer_window_hours": "Offer window (hours)",
      "cancel_before_default": "Default: cancelling before the deadline",
      "cancel_after_default": "Default: cancelling after the deadline",
      "visibility_mode_default": "Default visibility",
      "approval_flow_id_default": "Default approval chain",
      "max_enrollments_default": "Default number of enrolments",
      "max_waitlist_registrations_default": "Default number of waiting list registrations",
      "enabled": "On",
      "frequency": "Frequency",
      "send_time": "Send time",
      "send_weekday": "Send day",
      "response_window_days": "Response period (days)",
      "scale_min": "Lowest scale value",
      "scale_max": "Highest scale value",
      "anonymity_floor": "Anonymity threshold",
      "reminder_min_days_after_send": "Reminder after (days)",
      "enrollment_months": "Retention of enrolments (months)",
      "attendance_months": "Retention of attendance (months)",
      "attempt_months": "Retention of attempts (months)",
      "completion_months": "Retention of completions (months)",
      "qualification_months": "Retention of qualifications (months)",
      "certificate_months": "Retention of certificates (months)",
      "evaluation_response_months": "Retention of evaluation responses (months)",
      "evaluation_response_action": "After the period, evaluation responses are",
      "import_raw_data_months": "Retention of import data (months)"
    }
  },
  "approvalsOverview": {
    "heading": "All approvals",
    "intro": "Every approval still open in this environment, with its handler and how long it has been waiting. If something is stuck, you can move it to someone else or handle it yourself.",
    "empty": "Nothing is open right now.",
    "cols": {
      "applicant": "Applicant",
      "course": "Activity",
      "assignee": "Handler",
      "waiting": "Waiting"
    },
    "kind": {
      "enrollment": "Enrolment",
      "cancellation": "Cancellation",
      "external_request": "External training",
      "other": "Other"
    },
    "unknownApplicant": "Unknown",
    "noAssignee": "With no one",
    "waitingDays_one": "{count} day",
    "waitingDays_other": "{count} days",
    "remind": "Remind",
    "reminded": "Reminded",
    "remindFailed": "The reminder was not sent. The request may already have been handled or withdrawn.",
    "move": "Move",
    "approve": "Approve",
    "reject": "Reject",
    "moveTitle": "Move approval",
    "moveBody": "The request from {applicant} is currently with {assignee}. Choose who takes it over.",
    "moveConfirm": "Move",
    "movePickerLabel": "New handler",
    "movePickerPlaceholder": "Search by name or e-mail address",
    "moveFailed": "Moving the approval failed.",
    "rejectTitle": "Reject request",
    "rejectComment": "Note for the applicant",
    "decideFailed": "The decision did not go through. The request may already have been handled or withdrawn."
  },
  "approvalFlows": {
    "heading": "Approval flows",
    "intro": "An approval flow is a chain of approvers. You pick which flow applies per learning activity.",
    "new": "New flow",
    "empty": "There are no approval flows yet.",
    "noSteps": "no steps",
    "stepCount": "{n} step(s)",
    "platformBadge": "Default",
    "ownBadge": "Own",
    "platformReadOnly": "This is a platform default flow. You can select and view it, but not change it.",
    "filterOwner": "Owner",
    "stepsHeading": "Steps (in order)",
    "stepN": "Step {n}",
    "addStep": "Add step",
    "choose": "Choose...",
    "singlePerson": "This route always resolves to one person.",
    "deadlineEscalates": "If the deadline passes, an extra step for HR is added.",
    "dependsOnApplicant": "Who this is depends on the applicant.",
    "nobodyFallsBackToHr": "Nobody found — falls back to HR.",
    "deleteTitle": "Delete flow",
    "deleteBody": "Are you sure you want to delete {name}?",
    "deleteFailed": "Could not delete. Is this flow still in use?",
    "saveFailed": "Could not save. Please check the steps.",
    "cols": {
      "name": "Name",
      "chain": "Chain"
    },
    "owner": {
      "all": "All",
      "platform": "Default (platform)",
      "own": "Own flows"
    },
    "mode": {
      "any": "One approval is enough",
      "all": "All must approve"
    },
    "fields": {
      "name": "Name",
      "description": "Description",
      "expiresAfterDays": "Decision period (days)",
      "expiresAfterDaysHint": "Leave empty to let a request never expire. With a period, a request nobody handles expires and the place becomes available to someone else.",
      "warnDaysBefore": "Warn (days before)",
      "warnDaysBeforeHint": "This many days before expiry the applicant is notified, so they can still nudge their approver.",
      "route": "Who decides",
      "role": "Role",
      "orgLevel": "Level",
      "orgField": "Role field",
      "decisionMode": "With multiple people",
      "deadline": "Decision deadline",
      "deadlineHours": "Hours",
      "person": "Person"
    },
    "route": {
      "own_manager": "Own manager",
      "org_role": "Role on an org unit",
      "tenant_role": "Role in this environment",
      "fixed_person": "Specific person"
    },
    "settingsHeading": "Approvals",
    "settingsIntro": "Choose which approval flow is pre-filled for a new learning activity.",
    "settingsNone": "No approval — enrol directly",
    "defaultLabel": "Default for new activities",
    "defaultHint": "A pre-fill only: existing activities do not change with it, and an activity deliberately set to no approval is never overruled.",
    "manageLink": "Manage approval flows",
    "editor": {
      "inspector": "Inspector",
      "selectHint": "Select a step in the chain to edit it, or add a step.",
      "removeStep": "Remove step",
      "moveUp": "Move step earlier in the chain",
      "moveDown": "Move step later in the chain"
    },
    "node": {
      "request": "Request",
      "requestTitle": "Someone requests approval",
      "outcome": "Outcome",
      "outcomeTitle": "Approved",
      "allOf": "all must approve",
      "deadline": "{n} hours"
    }
  },
  "workflows": {
    "heading": "Workflows",
    "intro": "Automate actions on events: trigger → condition → steps.",
    "new": "New workflow",
    "empty": "No workflows yet.",
    "on": "On",
    "off": "Off",
    "system": "Default",
    "custom": "Custom",
    "locked": "Locked",
    "lockedHint": "Locked by the platform — you can only view it, not disable, edit or delete it.",
    "unavailable": "Skipped",
    "unavailableHint": "This workflow uses something that isn't available in this environment, so it is skipped. It is kept.",
    "unavailableNotice": "One or more workflows are being skipped: they use something that isn't available in this environment. They are kept.",
    "systemHint": "Platform-provided default workflow. You can disable it; you cannot delete it (editing makes a custom copy).",
    "confirmDelete": "Delete workflow?",
    "confirmDeleteBody": "This permanently deletes \"{name}\".",
    "cols": {
      "name": "Name",
      "trigger": "Trigger",
      "enabled": "Active",
      "origin": "Type"
    },
    "fields": {
      "name": "Name",
      "key": "Key",
      "keyHint": "Stable, unique key within your tenant (lowercase, dashes).",
      "trigger": "Trigger",
      "description": "Description",
      "enabled": "Enable immediately"
    },
    "schedule": {
      "heading": "Trigger timing",
      "offsetDays": "Days offset",
      "offsetHint": "Negative = before the date (e.g. -7 for pre-boarding), 0 = on the day, positive = after.",
      "offsetHintAfter": "Number of days after enrolment. 0 = the same day, 7 = a week later.",
      "time": "Time (tenant timezone)"
    },
    "editor": {
      "inspector": "Inspector",
      "selectHint": "Select a block to edit it, or add a step.",
      "actionTitle": "Action",
      "actionKind": "Kind of action",
      "actionNoSettings": "This action has no settings.",
      "approvalTitle": "Approval",
      "addAction": "Action",
      "addApproval": "Approval",
      "removeStep": "Remove block",
      "addMail": "+ Mail",
      "subject": "Subject",
      "body": "Body",
      "dueHours": "Due after (hours)",
      "saved": "Saved.",
      "lockedNotice": "This workflow is locked by the platform. You can view it, but not change it.",
      "systemNotice": "This is a default workflow. Editing and saving the definition turns it into a custom copy (detached from the global set).",
      "recipient": {
        "label": "Recipient",
        "subjectUser": "The subject user",
        "fixed": "Fixed address",
        "orgUnitRole": "Org-unit role",
        "address": "Email address",
        "orgUnitManager": "Manager of the org unit",
        "contentOwner": "Manager of the training",
        "occurrenceTrainers": "Trainer(s) of the session"
      },
      "unit": {
        "label": "Org unit",
        "subjectUnit": "The user's unit",
        "orgRoot": "Organisation (root)",
        "fieldKey": "Field key (e.g. ceo, teamlead)"
      },
      "branch": {
        "on_approve": "On approve",
        "on_reject": "On reject",
        "on_timeout": "On timeout"
      },
      "node": {
        "trigger": "Trigger",
        "action": "Action",
        "approval": "Approval",
        "email": "Email",
        "digestLine": "Line in the summary email",
        "confirmEnrollment": "Confirm enrolment",
        "rejectEnrollment": "Reject enrolment",
        "confirmCancellation": "Confirm cancellation",
        "rejectCancellation": "Reject cancellation",
        "materializeExternalRequest": "Record external training",
        "rejectExternalRequest": "Reject external training request",
        "approvalTitle": "Review"
      }
    },
    "help": {
      "link": "Help",
      "backToList": "Back to workflows",
      "inEditor": "How it looks in the editor",
      "title": "How workflows work",
      "intro": "Workflows automate actions on events in the platform. Every workflow follows the same pattern: a trigger starts it, optional conditions filter when it actually runs, and steps perform actions — for example sending an email or requesting an approval.",
      "conceptsHeading": "The building blocks",
      "concepts": {
        "trigger": {
          "title": "Trigger",
          "body": "The event that starts the workflow, e.g. 'User created' or 'Enrollment requested'. Every workflow has exactly one trigger."
        },
        "scheduling": {
          "title": "Timing for date triggers",
          "body": "Date triggers (hire date, end date, account validity) fire on a day you choose: pick how many days before or after the date (e.g. 7 days before the hire date for pre-boarding, or 0 on the day itself) and at what time (in 15-minute steps, in the tenant's time zone). That lets you send a welcome email in the morning and a reminder in the afternoon. A new workflow never fires retroactively: it only fires for dates on or after it was created, so people already employed won't get it after the fact."
        },
        "condition": {
          "title": "Condition (optional)",
          "body": "A filter that decides whether the workflow actually runs, e.g. only when an enrollment is self-service. No condition means: always run."
        },
        "steps": {
          "title": "Steps",
          "body": "What happens, in order. A step is either an action (do something) or an approval (wait for someone's decision)."
        },
        "actionEmail": {
          "title": "Action: email",
          "body": "Automatically sends an email. You choose the recipient, subject and body. The text can use variables like {tpl} that are filled in per recipient."
        },
        "approval": {
          "title": "Approval",
          "body": "Pauses the workflow until someone approves or rejects. You set who decides, within how many hours, and what happens on approve, reject or timeout."
        },
        "recipient": {
          "title": "Recipient via org role",
          "body": "'Who' an email or approval goes to is not a fixed person, but a reference to a role field on an org unit (e.g. teamlead or ceo), relative to the subject user. Requirement: that field is filled at the right level in the org structure."
        },
        "enabling": {
          "title": "Enabling and disabling",
          "body": "A workflow only runs when it is on. Default workflows shipped by the platform can be toggled on or off; once you edit and save the steps, it becomes a custom copy detached from the global set."
        },
        "locked": {
          "title": "Locked workflows",
          "body": "Some workflows are locked by the platform (lock icon): as an admin you can view them, but not disable, edit or delete them. Superadmins manage these centrally and push changes with 'Sync to tenants'."
        }
      },
      "examplesHeading": "Examples",
      "resultLabel": "Result",
      "examples": {
        "welcome": {
          "title": "Welcome email for a new user",
          "scenario": "Trigger 'User created' → email action to the subject user, with subject 'Welcome, {tpl}'. Want to notify HR instead? Pick a fixed address as the recipient, e.g. hr@company.com.",
          "result": "Every new user automatically receives a welcome email, with no admin action needed.",
          "flow": {
            "trigger": "User created",
            "action": "Send email",
            "actionSub": "to the user"
          }
        },
        "approval": {
          "title": "Manager approval on self-enrollment",
          "scenario": "Trigger 'Enrollment requested' → condition 'self-service' → approval by the teamlead of the subject's unit (due after 72 hours). On approve: confirmation email to the user. On reject: rejection email. On timeout: a reminder.",
          "result": "Self-enrollments first pass by the teamlead before they become final, with automatic follow-up.",
          "flow": {
            "trigger": "Enrollment requested",
            "condition": "Only for self-enrollment",
            "approval": "Teamlead approval",
            "approvalSub": "due after 72 hours",
            "onApprove": "Confirmation email",
            "onReject": "Rejection email",
            "onTimeout": "Reminder"
          }
        }
      }
    }
  },
  "platformWorkflows": {
    "heading": "Platform workflows",
    "intro": "Global workflows cloned to every tenant. Locked workflows can't be changed by tenant admins.",
    "new": "New platform workflow",
    "empty": "No platform workflows yet.",
    "sync": "Sync to tenants",
    "syncStarted": "Sync started — changes are being pushed to every tenant in the background.",
    "keyHint": "Stable, unique key across the platform (lowercase, hyphens).",
    "lockedField": "Lock (admins can't change it)",
    "lockedHint": "A locked workflow is read-only for tenants; the platform also controls the on/off state.",
    "lockedYes": "Locked",
    "lockedNo": "Open",
    "cols": {
      "locked": "Access"
    },
    "confirmDelete": "Delete platform workflow?",
    "confirmDeleteBody": "This removes \"{name}\" from the platform set. Tenant copies already cloned remain.",
    "editorNotice": "Changes here reach existing tenants only after a sync; new tenants get the current state on creation.",
    "sync_status": {
      "col": "Rollout",
      "none": "No tenants",
      "notRolledOut": "Not rolled out",
      "coverage": "{synced}/{total} tenants",
      "inSync": "Up to date",
      "outdated": "{count} outdated",
      "outdatedHint": "These tenants still run an older version — sync to update them.",
      "overridden": "{count} customised",
      "overriddenHint": "These tenants customised the workflow themselves; a sync leaves those untouched.",
      "syncOne": "Sync",
      "syncOneHint": "Sync just this workflow to all tenants"
    }
  },
  "approvals": {
    "heading": "Approvals",
    "intro": "Open approvals waiting for your decision.",
    "empty": "No pending approvals.",
    "due": "Due",
    "approve": "Approve",
    "reject": "Reject",
    "unknownWorkflow": "Workflow",
    "rejectTitle": "Reject?",
    "rejectBody": "You are rejecting \"{name}\".",
    "reason": "Reason (optional)",
    "count": "{count} to do",
    "nothingToDo": "Nothing to do.",
    "applicant": "Applicant",
    "noIndependentTitle": "No independent reviewer: {name} requested this themselves",
    "noIndependentBody": "Add a reviewer to the chain, or let an administrator with the right to manage requests handle it.",
    "cannotDecideOwn": "You don't decide on your own request.",
    "course": "Course",
    "bulk": {
      "selectAll": "Select all",
      "selectRow": "Select \"{name}\"",
      "selectedCount": "{count} selected",
      "approveSelected": "Approve selection",
      "rejectSelected": "Reject selection",
      "confirmApproveTitle": "Approve selection?",
      "confirmApproveBody": "You are approving {count} requests at once. The applicants will be notified.",
      "confirmRejectTitle": "Reject selection?",
      "confirmRejectBody": "You are rejecting {count} requests at once. The reason you enter applies to all rejected requests.",
      "resultSummary": "{decided} of {requested} handled.",
      "outcome": {
        "already_handled": "{count} had already been handled.",
        "forbidden": "{count} were not assigned to you.",
        "not_found": "{count} no longer existed."
      }
    },
    "kind": {
      "enrollment": "Enrolments",
      "cancellation": "Cancellations",
      "external_request": "External training",
      "other": "Other"
    }
  },
  "mailOutbox": {
    "title": "Mail outbox",
    "empty": "No mail sent yet.",
    "forwardTo": "Forward to users",
    "forwardPlaceholder": "Pick one or more users…",
    "filterStatus": "Filter by status",
    "filterAll": "All statuses",
    "retentionNotice": "Showing emails from the last {days} days.",
    "recipients_one": "{count} recipient",
    "recipients_other": "{count} recipients",
    "openedOf": "{opened} / {total}",
    "expand": "Show recipients",
    "collapse": "Hide recipients",
    "batchMore": "First {shown} of {total} recipients — narrow down with search or the status filter.",
    "cols": {
      "status": "Status",
      "to": "Recipient",
      "subject": "Subject",
      "scheduled": "Scheduled / sent",
      "opens": "Opens"
    },
    "status": {
      "scheduled": "Scheduled",
      "sending": "Sending",
      "sent": "Sent",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "suppressed": "Not sent"
    },
    "actions": {
      "view": "View",
      "cancel": "Cancel",
      "resend": "Resend",
      "forward": "Forward"
    },
    "detail": {
      "title": "View mail",
      "recipient": "Recipient",
      "body": "Content",
      "attachments": "Attachments",
      "noBody": "No content was stored for this mail.",
      "error": "Error message:",
      "attachmentNotAllowed": "You cannot open this attachment. Only the sender or a recipient of the message may do so."
    }
  },
  "mailTemplates": {
    "title": "Mail texts",
    "intro": "Customise the texts of system emails for your organisation. The default texts are platform-managed; you only record your per-language deviations.",
    "searchPlaceholder": "Search by name or context…",
    "empty": "No mail templates found.",
    "edit": "Edit",
    "notTranslated": "This language has not been translated yet. Recipients receive the fallback-language text — shown below.",
    "badge": {
      "locked": "Locked",
      "customized": "Customised",
      "global": "Default"
    },
    "preview": {
      "title": "Preview",
      "subject": "Subject",
      "error": "Preview could not be built."
    },
    "tags": {
      "intro": "Click a tag to insert it at the cursor.",
      "scope": {
        "context": "Context",
        "global": "General",
        "link": "Links"
      }
    },
    "editor": {
      "back": "Back to overview",
      "lockedNote": "This template is locked by the platform and cannot be customised.",
      "footerHint": "This text appears as the footer at the bottom of every email. Leave empty to show no footer.",
      "lockedBody": "The content is shown in the preview alongside.",
      "subject": "Subject",
      "preheader": "Preheader",
      "preheaderHint": "Short summary some mail clients show next to the subject.",
      "body": "Content",
      "save": "Save",
      "saved": "Saved.",
      "saveErrorTitle": "The text contains errors",
      "reset": "Reset to default",
      "resetLoaded": "Default text loaded — click Save to confirm.",
      "customized": "Customised for your organisation.",
      "testTitle": "Send test email",
      "testTo": "To email address",
      "testSend": "Send test",
      "testOk": "Test email sent."
    }
  },
  "centralMailTemplates": {
    "title": "Global mail texts",
    "intro": "Manage the default texts of system emails per language. These are the texts every tenant inherits; lock a template to block per-tenant customisation.",
    "searchPlaceholder": "Search by name or context…",
    "empty": "No mail templates found.",
    "badge": {
      "locked": "Locked",
      "missing": "Incomplete",
      "customized": "{count} customised"
    },
    "customizedTooltip": "Tenants with a custom text:",
    "notTranslated": "This language has not been translated yet. Recipients receive the fallback-language text — click Edit to add the translation.",
    "edit": "Edit",
    "editor": {
      "back": "Back to overview"
    },
    "locked": "Locked for tenants",
    "footerHint": "This text appears as a footer at the bottom of every email. Leave empty to show no footer.",
    "subject": "Subject",
    "preheader": "Preheader",
    "body": "Content",
    "save": "Save",
    "saved": "Saved.",
    "reset": "Reset to default text",
    "resetLoaded": "Default text loaded — click Save to confirm.",
    "saveErrorTitle": "The text contains errors"
  },
  "centralMailOutbox": {
    "title": "Mail outbox (all tenants)",
    "intro": "Read-only overview of mail sent across all tenants. Content and actions are managed per tenant.",
    "empty": "No mail found.",
    "filterStatus": "Status",
    "allStatuses": "All statuses",
    "filterTenant": "Tenant",
    "allTenants": "All tenants",
    "cols": {
      "tenant": "Tenant"
    }
  },
  "elearning": {
    "backToCatalog": "Back to the catalogue",
    "completion": {
      "completed": "completed",
      "incomplete": "not yet completed",
      "unknown": "nothing reported yet"
    },
    "contentHostMissing": "This course cannot be opened yet: the environment is missing the host that serves course content. Please report this to the administrator.",
    "loadError": "We could not load this course.",
    "outdatedVersion": "This course was updated after you started. You are continuing in the version you were working in, so you lose nothing. Would you rather start fresh in the newest version?",
    "registered": "Recorded: {status}",
    "saveProgress": "Save progress now",
    "score": "score {score}%",
    "start": "Start the course",
    "startHint": "The course opens below. Your progress is saved along the way, so you can pick up where you left off.",
    "startNewestVersion": "Start over in the newest version",
    "starting": "Opening the course…",
    "anonymous": {
      "fallbackTitle": "E-learning",
      "startHint": "This course is freely accessible: you do not need to log in to take it.",
      "notRecorded": "Your progress and result are not saved. If you want your completion to count, log in and start the course from the catalogue.",
      "unavailable": "This course is no longer freely accessible. Ask the administrator for a new link, or log in."
    },
    "restartHint": "You are starting this training again from the beginning.",
    "backToLearningPath": "Back to your learning path",
    "superseded": {
      "title": "You are starting again"
    }
  },
  "myQuestionnaires": {
    "title": "My questionnaires",
    "description": "Questionnaires that are open for you. You can fill them in here or through the link in your email: it is the same questionnaire.",
    "loading": "Loading questionnaires…",
    "loadError": "Your questionnaires could not be loaded.",
    "retry": "Try again",
    "emptyTitle": "Nothing is open for you",
    "emptyBody": "When a questionnaire is waiting for you, you will see it here.",
    "untitled": "Untitled questionnaire",
    "openUntil": "Open until {date}",
    "back": "Back to my questionnaires",
    "closedTitle": "This questionnaire is no longer open",
    "closedBody": "If you have already filled it in, for example through the link in your email, your answers have been saved.",
    "submittedBody": "Your answers have been sent.",
    "testBadge": "Test",
    "state": {
      "awaiting_grading": "Awaiting grading",
      "graded": "Graded"
    },
    "submittedOn": "Submitted on {date}",
    "viewResult": "View your result",
    "viewResultNamed": "View your result for {title}",
    "resultHidden": "The result of this test is not shown."
  },
  "myQualifications": {
    "title": "My qualifications",
    "description": "Which qualifications you hold, until when they are valid and what they are based on. What has expired or no longer applies is in the history.",
    "loading": "Loading qualifications…",
    "loadError": "Your qualifications could not be loaded.",
    "retry": "Try again",
    "emptyTitle": "You do not hold any qualifications yet",
    "emptyBody": "When you complete a training that grants a qualification, you will see it here.",
    "holds": "Valid",
    "notHolding": "Not valid now",
    "notHoldingBody": "No registration of this qualification is valid at the moment.",
    "validUntil": "Valid until {date}",
    "openEnded": "Valid, with no end date",
    "expiresIn_one": "Expires in {count} day",
    "expiresIn_other": "Expires in {count} days",
    "expiresToday": "Expires today",
    "renewalStopped": "Will not be renewed",
    "groundsLabel": "Why this is valid",
    "groundWindowUntil": "until {date}",
    "groundWindowOpen": "no end date",
    "originCompletionNamed": "Completion of {title}",
    "origin": {
      "completion": "Completion of a training",
      "external_training": "External training",
      "self_declared": "Self-declared",
      "administrative": "Recorded administratively"
    },
    "evidence": {
      "trusted": "Recorded automatically",
      "verifiable": "Granted provisionally, can be corrected afterwards",
      "declaration": "Based on your own declaration"
    },
    "history_one": "History ({count} earlier registration)",
    "history_other": "History ({count} earlier registrations)",
    "historyWindow": "{from} up to and including {until}",
    "historyWindowOpen": "From {from}, with no end date",
    "endedOn": "Ended on {date}",
    "status": {
      "valid": "Valid",
      "not_yet_valid": "Not yet started",
      "expired": "Expired",
      "ended_by_choice": "Ended",
      "superseded": "Superseded",
      "corrected": "Corrected",
      "withdrawn": "Withdrawn",
      "never_valid": "Never valid"
    },
    "reason": {
      "superseded": "Replaced by a newer registration",
      "corrected": "Corrected: the validity had been recorded wrongly",
      "withdrawn_from_now": "Withdrawn: it no longer applies from that moment",
      "never_valid": "Withdrawn: you never held it"
    }
  },
  "myExternalRequests": {
    "title": "My requests",
    "description": "Your requests for training that is not in the catalogue, and how far along they are.",
    "new": "New request",
    "newTitle": "New external training request",
    "back": "Back to My requests",
    "loading": "Loading requests…",
    "loadError": "Your requests could not be loaded.",
    "retry": "Try again",
    "emptyTitle": "No requests yet",
    "emptyBody": "Would you like to take a training that is not in the catalogue? Request it here.",
    "emptyBodyNoTypes": "There is nothing to request at the moment.",
    "noTypesTitle": "Nothing to request",
    "notFoundTitle": "Request not found",
    "notFoundBody": "This request does not exist, or it is not yours.",
    "untitled": "Untitled request",
    "continue": "Continue",
    "open": "View",
    "submittedOn": "submitted on {date}",
    "withdrawnOn": "withdrawn on {date}",
    "rejectedTitle": "Your request has been rejected",
    "rejectedNoComment": "No explanation was given.",
    "runningNotice": "Your request has been approved. The training is registered in your name.",
    "awaitingManagement": "In progress — waiting for a decision by administration",
    "withdraw": "Withdraw request",
    "withdrawTitle": "Withdraw request?",
    "withdrawBody": "No decision has been made on your request yet. If you withdraw it, it will not be reviewed. This cannot be undone.",
    "discardTitle": "Discard draft?",
    "discardBody": "The draft and everything you entered will be removed. This cannot be undone.",
    "cancel": "Cancel",
    "status": {
      "concept": "Draft",
      "submitted": "Submitted",
      "in_approval": "In progress",
      "rejected": "Rejected",
      "withdrawn": "Withdrawn",
      "running": "Running"
    },
    "reason": {
      "form_updated": "The form has been updated since you started. Your values are still there for the fields that stayed; please check it and submit again.",
      "request_not_concept": "This request has already been submitted and can no longer be changed.",
      "request_not_withdrawable": "This request can no longer be withdrawn.",
      "type_not_live": "This request type is no longer open.",
      "unknown": "This is no longer possible for this request.",
      "attachments_full": "This request already has the maximum number of attachments."
    },
    "form": {
      "type": "Request type",
      "typePlaceholder": "Choose a type",
      "submit": "Submit",
      "save": "Save as draft",
      "discard": "Discard draft",
      "submitHint": "Once submitted, you can no longer change the request, but you can withdraw it as long as no decision has been made.",
      "otherProvider": "Another provider",
      "providerChoice": "Provider",
      "providerPlaceholder": "Choose a provider",
      "providerName": "Name of the provider",
      "didYouMean": "Did you mean one of these?",
      "teacherName": "Name of the teacher or coach",
      "teacherNameHint": "Optional.",
      "firstDay": "First day",
      "lastDay": "Last day",
      "day": "Day {number}",
      "removeDay": "Remove day",
      "addDay": "Add day",
      "price": "{name}: price",
      "quantity": "{name}: quantity",
      "costHint": "The total is calculated when you submit.",
      "saved": "Your draft has been saved.",
      "submitted": "Your request has been submitted. You will receive a confirmation by email.",
      "checkFields": "Not everything has been filled in correctly. Please check the marked fields.",
      "failed": "That did not work. Please try again."
    },
    "detail": {
      "heading": "What you requested",
      "provider": "Provider",
      "period": "Period",
      "costs": "Costs",
      "costLine": "Cost item",
      "excl": "Excl. VAT",
      "incl": "Incl. VAT",
      "total": "Total",
      "vatUnknown": "unknown",
      "empty": "–",
      "yes": "Yes",
      "no": "No"
    },
    "tiles": {
      "heading": "Not what you are looking for?",
      "body": "Request a training that is not in the catalogue."
    },
    "attachments": {
      "heading": "Attachments",
      "none": "No attachments.",
      "hint": "For example a quote or a programme. PDF, JPG or PNG, at most {max} files.",
      "full": "This request has the maximum number of attachments ({max}). Remove one to add another.",
      "remove": "Remove",
      "removeNamed": "Remove attachment {name}",
      "failed": "The attachment could not be processed. Please try again.",
      "unnamed": "Attachment",
      "saveFirst": "You can add attachments once you have saved the request as a draft."
    }
  },
  "questionnaireInvite": {
    "loading": "Opening the questionnaire…",
    "loadError": "The questionnaire could not be opened. Check your connection and try again.",
    "retry": "Try again",
    "closedTitle": "This link no longer works",
    "closedBody": "If you have already filled in the questionnaire, your answer has been saved.",
    "empty": "This questionnaire has no questions, so there is nothing to fill in.",
    "language": "Language",
    "subject": "This questionnaire is about {title}.",
    "subjectWithDates": "This questionnaire is about {title} ({dates}).",
    "anonymous": "Your name is not shown with your answers.",
    "requiredNote": "Questions marked with * are required.",
    "yes": "Yes",
    "no": "No",
    "other": "Other, please specify",
    "charsBetween": "Use at least {min} and at most {max} characters.",
    "charsMin": "Use at least {min} characters.",
    "charsMax": "Use at most {max} characters.",
    "choicesBetween": "Choose at least {min} and at most {max}.",
    "choicesMin": "Choose at least {min}.",
    "choicesMax": "Choose at most {max}.",
    "star": "{value} of {max} stars",
    "starLabelled": "{value} of {max} stars: {label}",
    "remarks": "Comments",
    "remarksHint": "Anything else you would like to share that the questions did not cover? You can add it here.",
    "submit": "Submit",
    "submitFailed": "Submitting did not work. Your answers are still here; please try again.",
    "fixErrors": "Not everything has been filled in correctly yet. Please check the highlighted questions.",
    "submittedTitle": "Thank you for filling this in",
    "submittedBody": "Your answers have been sent. You can now close this window."
  },
  "questionnaireAssignments": {
    "open": "Questionnaires",
    "openFor": "Questionnaires for {training}",
    "heading": "Questionnaire rules for {training}",
    "heading_test": "Test rules for {training}",
    "headingGeneric": "Questionnaire rules for this training",
    "headingGeneric_test": "Test rules for this training",
    "add": "Add a rule",
    "add_test": "Add a test",
    "intro": "A rule is fixed: this questionnaire goes out at this moment to whoever meets the conditions. A training can have several rules, also with the same questionnaire — for example halfway and at the end.",
    "intro_test": "A rule is fixed: this test goes out at this moment to whoever meets the conditions. A training can have several rules, also with the same test — for example halfway and at the end.",
    "notFound": "This training does not exist (any more).",
    "loadError": "The rules for this training could not be loaded.",
    "loadError_test": "The test rules for this training could not be loaded.",
    "empty": "This training has no questionnaire rule yet.",
    "empty_test": "This training has no test yet.",
    "showArchived_one": "Show archived rule ({count})",
    "showArchived_test_one": "Show archived test rule ({count})",
    "showArchived_other": "Show archived rules ({count})",
    "showArchived_test_other": "Show archived test rules ({count})",
    "onlyArchived": "All rules of this training are archived.",
    "onlyArchived_test": "All test rules of this training are archived.",
    "unknownForm": "Untitled questionnaire",
    "unknownForm_test": "Unnamed test",
    "panel": {
      "title": "Questionnaire rules",
      "title_test": "Tests",
      "empty": "This training has no questionnaire rules yet.",
      "add": "Add a rule",
      "mandatory": "Mandatory: {answer}"
    },
    "name": "{form} — {moment}; {conditions}",
    "anonymous": "Anonymous",
    "actionFailed": "That did not work. Please try again.",
    "table": {
      "caption": "Rules of this training",
      "caption_test": "Test rules of this training",
      "form": "Questionnaire",
      "form_test": "Test",
      "moment": "Moment",
      "conditions": "Conditions",
      "status": "Status",
      "invitations": "Invitations",
      "actions": "Actions",
      "invitationCount_one": "{count} invitation",
      "invitationCount_other": "{count} invitations",
      "invitationsNamed_one": "{count} invitation for {name}: view the status",
      "invitationsNamed_other": "{count} invitations for {name}: view the status"
    },
    "status": {
      "active": "Running",
      "paused": "Paused",
      "archived": "Archived"
    },
    "actions": {
      "edit": "Edit",
      "editNamed": "Edit {name}",
      "pause": "Pause",
      "pauseNamed": "Pause {name}",
      "resume": "Resume…",
      "resumeNamed": "Resume {name}",
      "archive": "Archive",
      "archiveNamed": "Archive {name}",
      "delete": "Delete",
      "deleteNamed": "Delete {name}"
    },
    "pause": {
      "title": "Pause rule",
      "title_test": "Pause test rule",
      "body": "A paused rule sends nothing. Invitations are still created and held; when you resume, you choose whether they go out after all. Links already sent keep working.",
      "body_test": "A paused rule sends nothing. Invitations are still created and held; when you resume, you choose whether they go out after all.",
      "confirm": "Pause",
      "done": "The rule is paused.",
      "done_test": "The test rule has been paused."
    },
    "archive": {
      "title": "Archive rule",
      "title_test": "Archive test rule",
      "body": "Archiving stops this rule for good. Invitations not yet sent are cancelled. Links already sent keep working until they expire.",
      "body_test": "Archiving stops this rule for good. Invitations that have not been sent yet are cancelled.",
      "confirm": "Archive",
      "done": "The rule is archived.",
      "done_test": "The test rule has been archived."
    },
    "delete": {
      "title": "Delete rule",
      "title_test": "Delete test rule",
      "body": "Nothing has been sent from this rule yet, so it can be deleted.",
      "bodyWithInvitations_one": "Nothing has been sent from this rule yet, so it can be deleted. The {count} invitation that is waiting goes with it; nobody has seen it.",
      "bodyWithInvitations_other": "Nothing has been sent from this rule yet, so it can be deleted. The {count} invitations that are waiting go with it; nobody has seen them.",
      "confirm": "Delete",
      "done": "The rule is deleted.",
      "done_test": "The test rule has been deleted."
    },
    "resume": {
      "title": "Resume rule",
      "title_test": "Resume test rule",
      "confirm": "Resume",
      "loadError": "What is waiting could not be loaded.",
      "nothingHeld": "Nothing is waiting. Resuming switches the rule back on; whoever completes afterwards gets the questionnaire as it is then.",
      "nothingHeld_test": "Nothing is waiting. Resuming switches the rule back on; whoever completes afterwards gets the test as it is then.",
      "done": "The rule is running again. Picked up: {refrozen}, cancelled: {withdrawn}.",
      "done_test": "The test rule is running again. Picked up: {refrozen}, lapsed: {withdrawn}."
    },
    "duplicate": {
      "existing": "This is the existing rule: {name}.",
      "existing_test": "This is the existing test rule: {name}.",
      "existingUnknown": "The existing rule is not in this list. Refresh the page to see it.",
      "existingUnknown_test": "The existing test rule is not in this list. Refresh the page to see it.",
      "marker": "Already exists with the same moment and conditions",
      "toList": "Show the existing rule in the list",
      "toList_test": "Show the existing test rule in the list"
    },
    "errors": {
      "wholeNumber": "Enter a whole number, 0 or more."
    },
    "saved": {
      "created": "The rule is added.",
      "created_test": "The test rule has been added.",
      "updated": "The rule is saved.",
      "updated_test": "The test rule has been saved.",
      "replaced": "The new rule is created and the old one is archived.",
      "replaced_test": "The new test rule is created and the old one is archived.",
      "replacedArchiveFailed": "The new rule is created, but the old one could not be archived. Archive it yourself, otherwise both will run.",
      "replacedArchiveFailed_test": "The new test rule was created, but the old one could not be archived. Archive it yourself, otherwise both keep running."
    },
    "editor": {
      "newTitle": "Add a rule",
      "newTitle_test": "Add a test",
      "editTitle": "Edit rule",
      "editTitle_test": "Change test rule",
      "replaceTitle": "New rule instead of this one",
      "replaceTitle_test": "New test rule instead of this one",
      "replaceConfirm": "Create and archive the old one",
      "backToList": "Back to the rules of the training",
      "backToList_test": "Back to the tests of the training",
      "asideTitle": "What this means",
      "nothingSkipped": "Nothing is skipped at this moment.",
      "notFound": "This rule does not exist (any more) for this training.",
      "notFound_test": "This test rule does not (or no longer) exist for this training.",
      "archived": "This rule is archived and can no longer be changed. Create a new one if you want to change something.",
      "archived_test": "This test rule is archived and can no longer be changed. Create a new one if you want to change something.",
      "fromNow": "A change applies to invitations created from now on.",
      "locked_one": "{count} invitation has already been created from this rule, so the questionnaire, role, moment and conditions are fixed. You can still change the response window, the introduction, the reminder and switch anonymity on.",
      "locked_test_one": "{count} invitation has already been created from this rule, so the test, role, moment and conditions are fixed. You can still change the response window, the introduction, the grader and the result for the learner.",
      "locked_other": "{count} invitations have already been created from this rule, so the questionnaire, role, moment and conditions are fixed. You can still change the response window, the introduction, the reminder and switch anonymity on.",
      "locked_test_other": "{count} invitations have already been created from this rule, so the test, role, moment and conditions are fixed. You can still change the response window, the introduction, the grader and the result for the learner.",
      "replace": "Create a new one and archive this one",
      "replacing": "You are creating a new rule based on {name}. After saving, that one is archived: what is still waiting there is cancelled, links already sent keep working.",
      "replacing_test": "You are creating a new test rule based on {name}. After saving, that one is archived: what is still waiting there is cancelled."
    },
    "field": {
      "form": "Questionnaire",
      "form_test": "Test",
      "formPlaceholder": "Choose a published questionnaire",
      "formPlaceholder_test": "Choose a published test",
      "noForms": "There is no published questionnaire yet.",
      "noForms_test": "There is no published test yet.",
      "formsError": "The questionnaires to choose from could not be loaded.",
      "formsError_test": "The tests to choose from could not be loaded.",
      "toForms": "Go to the questionnaires",
      "toForms_test": "Go to the tests",
      "role": "Who fills it in?",
      "moment": "When does it go out?",
      "conditions": "Conditions",
      "attendance": "Minimum attendance (%)",
      "attendanceHint": "Empty: no condition.",
      "attendanceHelp": "The share of sessions someone attended. Sessions someone was excused from do not count.",
      "attendanceBeforeEnd": "Not possible with a moment before the end of the session: attendance is not known yet then.",
      "outcome": "Outcome",
      "outcomeAfterFinalise": "Passed or not passed is only possible with the moment after completion: before that there is no outcome yet.",
      "sending": "Sending",
      "mailIntro": "Own introduction in the invitation",
      "mailIntroHint": "Empty: the default text of the invitation.",
      "anonymous": "Anonymous: do not show names with the answers",
      "anonymousHint": "You then see how many invitations are in each status, but not whose they are.",
      "anonymousLocked": "Can no longer be switched off: invitations with that promise already exist.",
      "anonymousWarning": "Note: answers are only shown together, and only once at least {floor} people have responded across all sessions of this training. With small groups that can take several sessions.",
      "delayAmount": "How much later",
      "delayHint": "0 is right at completion.",
      "delayUnit": "Unit",
      "session": "Which session",
      "sessionHint": "By date and start time; sessions without a date do not count.",
      "sessionNumber": "Session number",
      "offsetAmount": "How much",
      "offsetHint": "0 is at the end of the session.",
      "offsetUnit": "Unit",
      "offsetDirection": "Relative to the end",
      "afterLastDays": "Number of days after the last session",
      "afterLastDaysHint": "0 is at the end.",
      "afterLastDaysHelp": "In calendar days, from the end of the last session.",
      "fixedAt": "Date and time",
      "fixedAtHint": "In your own time. A moment that has already passed is not possible.",
      "mandatory": "Required for passing",
      "mandatoryHint": "The training only counts as passed once this questionnaire is filled in. It is filled in under My questionnaires after logging in, without a link, and does not expire.",
      "delivery": "How is the test taken?",
      "deliveryDigital": "Digital",
      "deliveryDigitalHint": "The participant takes the test in the app; the trainer marks it.",
      "deliveryExternal": "External",
      "deliveryExternalHint": "The test is taken and marked outside the system. You only record the result here, per participant in the attendance grid. No invitation is sent.",
      "deliveryExternalGrading": "You record the result in the attendance grid, when closing the occurrence.",
      "externalTestTitle": "External test",
      "mandatory_test": "Counts toward passing",
      "mandatoryHint_test": "The training is only passed once the test has been submitted, marked and passed. A qualification attached to the training is only granted then — not by attendance. A test that is not passed leaves the participant on not passed until the trainer decides otherwise.",
      "mandatoryNeedsMoment": "Only possible with a moment before completion: a questionnaire after completion can no longer hold back a completion that already exists.",
      "mandatoryNotEach": "Not possible at every session: it would be unclear which invitation holds back passing.",
      "mandatoryNoAttendance": "Cannot be combined with an attendance condition: anyone who does not meet it never receives the questionnaire and could then never pass.",
      "attendanceMandatory": "Not possible for a required questionnaire: anyone who does not meet the condition could then never pass.",
      "reminderMandatory": "A required questionnaire does not close on a date, so a reminder beforehand has no moment. Send reminders from the rule overview.",
      "grading": "Grading",
      "grader": "Grader",
      "graderPlaceholder": "Choose a grader (optional)",
      "graderHint": "Empty: the teachers of the session grade.",
      "showAnswers": "Show answers to the learner",
      "showAnswersHint": "On: once the test is graded, the learner also sees the questions with their answers and the comments per answer. Off: they only see the outcome, the score and the general comment. Those they always see."
    },
    "role": {
      "participant": "Participant",
      "teacher": "Teacher",
      "manager": "Manager",
      "later": "Coming later: teachers and managers fill it in while logged in."
    },
    "moment": {
      "after_finalise": "After completion",
      "after_finaliseHint": "When the completion is recorded, right away or later.",
      "at_session": "At a session",
      "at_sessionHint": "Around the end of a session — for example halfway through the training.",
      "after_last_session": "After the last session",
      "after_last_sessionHint": "A number of days after the end of the last session, regardless of completion.",
      "fixed_datetime": "On a fixed date",
      "fixed_datetimeHint": "One moment for everyone who is enrolled or completed by then."
    },
    "outcome": {
      "any": "Does not matter",
      "passed": "Only those who passed",
      "not_passed": "Only those who did not pass"
    },
    "unit": {
      "minutes": "minutes",
      "hours": "hours",
      "days": "days"
    },
    "selector": {
      "number": "Session number…",
      "last": "The last one",
      "each": "Every session"
    },
    "direction": {
      "after": "after the end",
      "before": "before the end"
    },
    "skipped": {
      "counting": "Counting what has already passed…",
      "failed": "Could not count how many moments have already passed.",
      "nothingPlanned": "There is no dated session on the schedule yet that this moment falls on.",
      "sessionsNone_one": "{count} session planned, still in the future.",
      "sessionsNone_other": "{count} sessions planned, all still in the future.",
      "occurrencesNone_one": "{count} occurrence planned; this moment is still in the future there.",
      "occurrencesNone_other": "{count} occurrences planned; this moment is still in the future for all of them.",
      "sessions_one": "{past} of the {count} session has already passed; nothing is sent for it.",
      "sessions_other": "{past} of the {count} sessions have already passed; nothing is sent for those.",
      "occurrences_one": "For {past} of the {count} occurrence this moment has already passed; nothing is sent there.",
      "occurrences_other": "For {past} of the {count} occurrences this moment has already passed; nothing is sent there.",
      "rule": "A rule only sends at moments still to come, counted from saving."
    },
    "duration": {
      "minutes_one": "{count} minute",
      "minutes_other": "{count} minutes",
      "hours_one": "{count} hour",
      "hours_other": "{count} hours",
      "days_one": "{count} day",
      "days_other": "{count} days"
    },
    "summary": {
      "afterFinaliseNow": "Right after completion",
      "afterFinaliseLater": "{delay} after completion",
      "sessionNumber": "session {number}",
      "session_last": "the last session",
      "session_each": "every session",
      "atSessionEnd": "At the end of {session}",
      "beforeSessionEnd": "{offset} before the end of {session}",
      "afterSessionEnd": "{offset} after the end of {session}",
      "afterLastSessionSameDay": "At the end of the last session",
      "afterLastSession": "{days} after the last session",
      "fixed": "On {date}",
      "noMoment": "No moment",
      "attendance": "at least {percent}% attendance",
      "passed": "passed only",
      "notPassed": "not passed only",
      "noConditions": "no conditions",
      "mandatory": "required for passing"
    }
  },
  "questionnaireOverview": {
    "intro": "All evaluation rules for questionnaires in one place: the rules on a training and the stand-alone questionnaires. By default you see the running and paused evaluation rules; choose All under Status to include the archived ones.",
    "intro_test": "All test rules in one place: the rules on a training. By default you see the running and paused test rules; choose All under Status to include the archived ones.",
    "empty": "There are no evaluation rules yet.",
    "empty_test": "There are no test rules yet.",
    "noMatch": "No evaluation rules match these filters.",
    "noMatch_test": "No test rules match these filters.",
    "loadError": "The evaluation rules could not be loaded.",
    "loadError_test": "The test rules could not be loaded.",
    "unknownForm": "Untitled questionnaire",
    "unknownForm_test": "Unnamed test",
    "unknownTraining": "Unknown training",
    "anonymous": "Anonymous",
    "survey": "Stand-alone questionnaire",
    "name": "{form} — {target}",
    "cols": {
      "form": "Questionnaire",
      "form_test": "Test",
      "target": "Training or audience",
      "moment": "Moment",
      "status": "Status",
      "mandatory": "Mandatory",
      "sent": "Sent",
      "submitted": "Submitted",
      "open": "Open",
      "actions": "Actions"
    },
    "filters": {
      "status": "Status",
      "statusDefault": "Running and paused",
      "statusAll": "All",
      "kind": "Type",
      "kindTraining": "On a training",
      "kindSurvey": "Stand-alone questionnaire",
      "form": "Questionnaire",
      "form_test": "Test",
      "training": "Training",
      "all": "All"
    },
    "actions": {
      "status": "View status",
      "statusNamed": "View the status of {name}",
      "training": "Training",
      "trainingNamed": "Open the rules of the training for {name}",
      "edit": "Edit",
      "editNamed": "Edit {name}"
    }
  },
  "questionnaireWindow": {
    "field": {
      "window": "Response window in days",
      "windowHint": "How long the link stays open after it is sent. Default {days} days, never longer than {ceiling} days. 0 means: as long as allowed.",
      "windowZero": "No fixed window: the link stays open as long as allowed, at most {ceiling} days (if sent {from}: until {date}).",
      "windowCapped": "That is longer than the maximum: the link closes after {ceiling} days (if sent {from}: on {date}).",
      "reminder": "Reminder before closing, in days",
      "reminderHint": "This many days before the link closes, the recipient gets a reminder with a new link; the first link keeps working. Empty: no reminder.",
      "reminderAt_one": "Reminder {count} day before closing, on {date} (if sent {from}).",
      "reminderAt_other": "Reminder {count} days before closing, on {date} (if sent {from}).",
      "reminderOutside_one": "A reminder {count} day before closing does not fall within the response window of {window} days. Choose fewer days.",
      "reminderOutside_other": "A reminder {count} days before closing does not fall within the response window of {window} days. Choose fewer days.",
      "today": "today",
      "onDate": "on {date}",
      "afterSend": "Reminder {number} after sending, in days",
      "afterSendHint_one": "This many days after sending, the recipient gets a reminder with a new link; the first link keeps working. At most {max}, ascending. The first can come after at least {count} day.",
      "afterSendHint_other": "This many days after sending, the recipient gets a reminder with a new link; the first link keeps working. At most {max}, ascending. The first can come after at least {count} days.",
      "afterSendAdd": "Add a reminder after sending",
      "afterSendRemove": "Remove reminder {number} after sending",
      "afterSendRemoveLabel": "Remove"
    }
  },
  "questionnaireSurveyRecipients": {
    "back": "Back to the stand-alone surveys",
    "heading": "Recipients",
    "note": "This is the audience as it stands now. The final list is determined at the moment of sending, on the scheduled send date.",
    "notFound": "This stand-alone survey does not exist (any more).",
    "loadError": "The recipients could not be loaded.",
    "empty": "The audience has nothing to show yet.",
    "total_one": "{count} recipient in total",
    "total_other": "{count} recipients in total",
    "duplicates_one": "{count} person is in more than one part and is counted once.",
    "duplicates_other": "{count} people are in more than one part and are counted once.",
    "countsOnly": "You only see numbers: names and email addresses are for those who may view users.",
    "treeLabel": "Parts of the audience",
    "subUnitsLabel": "Units under {name}",
    "count_one": "{count} person",
    "count_other": "{count} people",
    "directly": "Directly in {name}: {count}",
    "expandNamed": "Expand {name}",
    "collapseNamed": "Collapse {name}",
    "branch": {
      "everyone": "Everyone (all active users)",
      "individuals": "Chosen people"
    },
    "people": {
      "name": "Name",
      "email": "Email address",
      "empty": "Nobody is here any more.",
      "forbidden": "You may not see the names: that needs the permission to view users.",
      "loadError": "The people in {name} could not be loaded."
    }
  },
  "questionnaireSurveys": {
    "intro": "A stand-alone questionnaire is not tied to a training: you send a published questionnaire to an audience, now or on a fixed date. Who belongs to it is counted at the moment of sending.",
    "new": "New stand-alone questionnaire",
    "loadError": "The stand-alone questionnaires could not be loaded.",
    "empty": "There are no stand-alone questionnaires yet.",
    "onlyArchived": "There are only archived stand-alone questionnaires.",
    "showArchived_one": "Show archived questionnaire ({count})",
    "showArchived_other": "Show archived questionnaires ({count})",
    "unknownForm": "Unknown questionnaire",
    "anonymous": {
      "chooseAudience": "Whether anonymity is possible depends on the size of the audience. Choose an audience first.",
      "unknown": "Whether anonymity is possible can only be said once the audience has been counted.",
      "unavailable_one": "Anonymity is not possible: this audience counts {count} person, below the threshold of {floor}. That way the questionnaire promises nothing it cannot keep.",
      "unavailable_other": "Anonymity is not possible: this audience counts {count} people, below the threshold of {floor}. That way the questionnaire promises nothing it cannot keep.",
      "willDrop": "This questionnaire was set to anonymous; that is removed when you save."
    },
    "name": "{form}, {date}",
    "actionFailed": "That did not work. Please try again.",
    "sentTo_one": "to {count} person",
    "sentTo_other": "to {count} people",
    "heldReason_one": "Not sent: anonymity was promised, but at sending the audience counted {count} person, below the threshold. Edit it to schedule it again.",
    "heldReason_other": "Not sent: anonymity was promised, but at sending the audience counted {count} people, below the threshold. Edit it to schedule it again.",
    "state": {
      "scheduled": "Scheduled",
      "sent": "Sent",
      "held": "Held back",
      "archived": "Archived"
    },
    "table": {
      "caption": "Stand-alone questionnaires, with their audience, moment and status",
      "form": "Questionnaire",
      "audience": "Audience",
      "moment": "Moment",
      "state": "Status",
      "invitations": "Invitations",
      "actions": "Actions",
      "invitationCount_one": "{count} invitation",
      "invitationCount_other": "{count} invitations",
      "invitationsNamed_one": "{count} invitation for {name}: view the status",
      "invitationsNamed_other": "{count} invitations for {name}: view the status",
      "recipientsNow": "Recipients (now {count})",
      "recipientsNamed": "Recipients of {name}: {count} right now, see who they are"
    },
    "actions": {
      "edit": "Edit",
      "editNamed": "Edit {name}",
      "archive": "Archive",
      "archiveNamed": "Archive {name}",
      "delete": "Delete",
      "deleteNamed": "Delete {name}"
    },
    "archive": {
      "title": "Archive stand-alone questionnaire",
      "body": "Archiving stops this questionnaire for good. Links already sent keep working until they expire.",
      "confirm": "Archive",
      "done": "The stand-alone questionnaire is archived."
    },
    "delete": {
      "title": "Delete stand-alone questionnaire",
      "body": "Nothing has been sent from this questionnaire yet, so it can be deleted.",
      "confirm": "Delete",
      "done": "The stand-alone questionnaire is deleted."
    },
    "saved": {
      "now_one": "The questionnaire goes out to {count} person right after you confirm.",
      "now_other": "The questionnaire goes out to {count} people right after you confirm. With a large group it can take a few minutes before everyone has it.",
      "date_one": "The questionnaire goes out on {date}; the audience now counts {count} person. Who belongs to it is counted again at that moment.",
      "date_other": "The questionnaire goes out on {date}; the audience now counts {count} people. Who belongs to it is counted again at that moment."
    },
    "audience": {
      "everyone": "Everyone",
      "units_one": "{count} unit",
      "units_other": "{count} units",
      "roles_one": "{count} role",
      "roles_other": "{count} roles",
      "people_one": "{count} person",
      "people_other": "{count} people",
      "none": "No audience"
    },
    "editor": {
      "newTitle": "New stand-alone questionnaire",
      "editTitle": "Edit stand-alone questionnaire",
      "backToList": "To the stand-alone questionnaires",
      "notFound": "This stand-alone questionnaire does not exist (any more).",
      "loadError": "The stand-alone questionnaire could not be loaded.",
      "closedSent_one": "This questionnaire was sent on {date} to {count} person. It can no longer be edited; you can archive it from the list.",
      "closedSent_other": "This questionnaire was sent on {date} to {count} people. It can no longer be edited; you can archive it from the list.",
      "closedArchived": "This questionnaire is archived and can no longer be edited.",
      "toInvitations": "To the invitations",
      "review": "Review and confirm",
      "heldNotice_one": "This questionnaire was not sent: it was anonymous, but at sending the audience counted {count} person, below the threshold. Choose a larger audience or drop anonymity; saving schedules it again.",
      "heldNotice_other": "This questionnaire was not sent: it was anonymous, but at sending the audience counted {count} people, below the threshold. Choose a larger audience or drop anonymity; saving schedules it again."
    },
    "field": {
      "form": "Questionnaire",
      "formPlaceholder": "Choose a published questionnaire",
      "formsError": "The questionnaires to choose from could not be loaded.",
      "noForms": "There is no published questionnaire yet.",
      "audience": "Audience",
      "audienceHint": "Choose units, roles, people or everyone. Someone who falls under several rows gets one invitation. Only active people count.",
      "addSegment": "Add a row",
      "moment": "When does it go out?",
      "fixedAt": "Date and time",
      "fixedAtHint": "In your own time. A moment that has already passed is not possible.",
      "sending": "Sending",
      "anonymous": "Anonymous: do not show names with the answers",
      "anonymousHint": "You then see how many invitations are in each status, but not whose they are. Possible from {floor} people."
    },
    "moment": {
      "now": "Now",
      "nowHint": "Right after you confirm. With a large group it can take a few minutes before everyone has it.",
      "date": "On a fixed date",
      "dateHint": "Whoever belongs to the audience at that moment receives it."
    },
    "segment": {
      "label": "Audience row {number}",
      "type": "Kind, row {number}",
      "org_units": "Organisational units",
      "roles": "Roles",
      "individuals": "Chosen people",
      "everyone": "Everyone",
      "everyoneHint": "All active people in this environment.",
      "includeSubUnits": "Include the units below",
      "remove": "Remove",
      "removeNamed": "Remove row {number}"
    },
    "picker": {
      "units": "Search for a unit",
      "unitsNamed": "Units, row {number}",
      "roles": "Search for a role",
      "rolesNamed": "Roles, row {number}",
      "people": "Search by name or email address",
      "peopleNamed": "People, row {number}",
      "loadError": "The list to choose from could not be loaded."
    },
    "preview": {
      "title": "Recipients",
      "nothing": "Choose an audience; you will then see here how many people it counts now.",
      "counting": "Counting…",
      "updating": "Updating…",
      "count_one": "{count} person",
      "count_other": "{count} people",
      "failed": "The number could not be counted.",
      "rule": "Only active people count. The audience is counted again at sending."
    },
    "errors": {
      "noAudience": "Choose at least one audience.",
      "segmentIncomplete": "Choose who falls under this row, or remove the row.",
      "nobody": "This audience counts nobody right now: nothing would go out.",
      "countFailed": "The number of recipients could not be counted. Please try again."
    },
    "confirm": {
      "title": "Confirm sending",
      "count_one": "This questionnaire goes to {count} person.",
      "count_other": "This questionnaire goes to {count} people.",
      "form": "Questionnaire",
      "when": "When",
      "anonymous": "Anonymous",
      "yes": "Yes",
      "no": "No",
      "now": "As soon as you confirm",
      "nowHint": "It goes out right away; with a large group it can take a few minutes before everyone has it. After that you can no longer edit it, only archive it.",
      "dateHint": "You can edit it until that moment. Who belongs to it is counted again then; the number may differ.",
      "sendNow": "Confirm and send",
      "schedule": "Confirm and schedule",
      "changed_one": "The number has changed: the audience now counts {count} person instead of {previous}. Please confirm again.",
      "changed_other": "The number has changed: the audience now counts {count} people instead of {previous}. Please confirm again."
    }
  },
  "assetLimits": {
    "uploadHint": "{types} — max {max} MB",
    "fileTooLarge": "This file is {size} MB. The maximum is {max} MB.",
    "fileTypeRejected": "This file type is not allowed. Allowed: {types}."
  },
  "uploadLimits": {
    "platformDescription": "These values apply to every environment that does not have its own. Customers cannot change them: a file-type list is a security setting.",
    "tenantDescription": "What you set here applies to this environment only. Leave a field empty to fall back to the value that applies to every environment.",
    "storageUsage": "This environment currently uses {used} of {quota} MB ({percent}%) for its own content.",
    "sources": {
      "tenant": "Own value for this environment",
      "platform": "Set platform-wide",
      "fallback": "Default"
    },
    "units": {
      "kilobytes": "Value (MB)",
      "megabytes": "Value (MB)",
      "count": "Value"
    },
    "types": "Allowed file types",
    "addType": "Add a type",
    "add": "Add",
    "removeType": "Remove {type}",
    "forbiddenHint": "These types cannot be allowed because they can carry scripts: {types}.",
    "ceilingHint": "At most {max} MB — the web server will not accept more.",
    "overCeiling": "The limit cannot exceed {max} MB.",
    "mustBeNumber": "Enter a positive number.",
    "notOverridable": "This limit applies to every environment and cannot be changed here.",
    "clearOverride": "Back to the default",
    "fallbackNote": "Without an own value, {value} applies here.",
    "saved": "The limits have been saved.",
    "nothingChanged": "Nothing has changed, so there is nothing to save.",
    "loadError": "We could not load the upload limits."
  },
  "platformSettings": {
    "title": "Global settings",
    "sections": {
      "general": "General",
      "mail": "Mail",
      "files": "Files"
    },
    "general": {
      "empty": "No global settings under this topic yet."
    },
    "mail": {
      "transportTitle": "Sender & transport (default)",
      "mode": "Send mode",
      "modeRelay": "Platform relay (recommended)",
      "modeSmtp": "Own SMTP server",
      "fromAddress": "From address",
      "fromName": "From name",
      "replyTo": "Reply-To",
      "smtpHost": "SMTP host",
      "smtpPort": "SMTP port",
      "smtpEncryption": "Encryption",
      "smtpUsername": "SMTP username",
      "smtpPassword": "SMTP password",
      "passwordSet": "A password is set — leave empty to keep it unchanged.",
      "connectionTest": "Test connection",
      "connectionHint": "Tests the saved transport settings without sending a mail. Save first.",
      "connectionOk": "Connection successful.",
      "testTitle": "Test mail",
      "testHint": "Sends a test mail via the platform transport, outside any tenant.",
      "testTo": "Test address",
      "testToInvalid": "Enter a valid email address.",
      "testSend": "Send test",
      "testOk": "Test mail sent.",
      "dnsTitle": "DNS check (SPF/DKIM/DMARC)",
      "dnsHint": "Checks the email-authentication records of the platform From domain. Save first.",
      "dnsCheck": "Check DNS",
      "dnsDomain": "Domain",
      "dkimSelector": "DKIM selector (optional)",
      "dkimSelectorHint": "DKIM selector e.g. 'default' or 's1' — needed to look up the right DKIM record.",
      "dnsExpected": "Add a TXT record on {host} containing:",
      "spfNoRelay": "does not include our relay",
      "dnsStatus": {
        "ok": "OK",
        "warn": "warning",
        "missing": "missing",
        "skipped": "not checked"
      },
      "lifecycleTitle": "Sending & retention (default)",
      "sendingEnabled": "Actually send mail",
      "openTracking": "Open tracking (pixel)",
      "storeTransactionalBody": "Store transactional mail content",
      "delayMinutes": "Delay (minutes)",
      "retentionDays": "Retention (days)"
    }
  },
  "common": {
    "filePicker": {
      "drop": "Drag a file here or click to choose",
      "choose": "Choose file",
      "replace": "Replace",
      "remove": "Remove"
    },
    "dropzone": {
      "primary": "Drag files here or click to choose",
      "secondary": "Multiple files at once is fine (max 10 MB each)"
    },
    "cancel": "Cancel",
    "close": "Close",
    "copy": "Copy",
    "copied": "Copied!",
    "create": "Create",
    "save": "Save",
    "saved": "Saved",
    "loading": "Loading…",
    "error": "Something went wrong",
    "edit": "Edit",
    "open": "Open",
    "search": "Search",
    "yes": "Yes",
    "no": "No",
    "tableEmpty": "No rows to display.",
    "tableNoMatch": "No results match your search.",
    "tableMatchCount": "{matched} of {total}",
    "tableRange": "{from}–{to} of {total}",
    "tablePageSize": "Per page",
    "tablePageOf": "Page {current} of {total}",
    "tableExport": "Export CSV",
    "tableExportHint": "All filtered rows in the current sort order. Actions column is omitted.",
    "delete": "Delete",
    "remove": "Remove",
    "expand": "Expand",
    "collapse": "Collapse",
    "unknownError": "Something went wrong. Please try again.",
    "fieldRequired": "This field is required.",
    "invalidEmail": "Please enter a valid email address.",
    "view": "View",
    "weekday": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "saving": "Saving…",
    "actions": "Actions",
    "tableRowNumber": "#",
    "tableSelectAll": "Select all rows",
    "tableSelectRow": "Select row {n}",
    "tableSortAsc": "sorted ascending",
    "tableSortDesc": "sorted descending",
    "tableScrollRegion": "Table, scrollable sideways",
    "tablePreviousPage": "Previous page",
    "tableNextPage": "Next page",
    "helpFor": "Explanation: {field}",
    "moveUp": "Move up",
    "moveDown": "Move down"
  },
  "shadowBanner": {
    "stop": "Stop shadow",
    "startedAt": "active since {time}",
    "userShadow": {
      "heading": "You are working as {name}",
      "subline": "Initiated by {impersonator}",
      "sublineWithOrigin": "Initiated by {impersonator} (acting as a shadow of superadmin {origin})"
    },
    "superadminTenantAdmin": {
      "heading": "You are working as a tenant-admin via superadmin shadow",
      "subline": "Original superadmin: {origin}"
    }
  },
  "localeOverrides": {
    "heading": "Texts",
    "intro": "Override texts in the app per language. An empty override falls back to the default.",
    "searchPlaceholder": "Search by key or text…",
    "colKey": "Key",
    "default": "Default",
    "override": "Override",
    "reset": "Reset",
    "resetNamespace": "Reset namespace",
    "historyAction": "History",
    "namespaceCount": "{total} keys · {overridden} overridden",
    "requiredPlaceholders": "Use: {list}",
    "confirmResetTitle": "Reset namespace?",
    "confirmResetBody": "Delete all overrides in '{namespace}' for this language. Defaults will be used again.",
    "historyTitle": "History — {key}",
    "empty": {
      "all": "No keys to show yet.",
      "search": "No results for this search."
    },
    "history": {
      "empty": "No changes recorded.",
      "before": "Previous value",
      "after": "New value",
      "disabledHint": "No history — no override saved yet for this key.",
      "by": "by {actor}",
      "byShadow": "by {impersonator} (shadowing {actor})",
      "byShadowFromSuperadmin": "by {impersonator} (shadowing {actor}; signed in as superadmin {origin})",
      "bySuperadminShadow": "by {actor} (superadmin {origin} via shadow)",
      "action": {
        "created": "Created",
        "updated": "Updated",
        "deleted": "Deleted"
      }
    },
    "errors": {
      "html": "HTML tags are not allowed.",
      "placeholder": "Missing placeholder(s): {list}",
      "saveFailed": "Save failed."
    }
  },
  "auth": {
    "login": {
      "title": "Sign in",
      "subtitle": "Superadmin access to the BCS LMS/LXP platform.",
      "email": "E-mail address",
      "password": "Password",
      "remember": "Keep me signed in",
      "submit": "Sign in",
      "genericError": "Could not sign in. Please try again."
    },
    "mfa": {
      "title": "Second step",
      "subtitle": "Enter the code from your authenticator app.",
      "code": "Code",
      "submit": "Confirm",
      "recoveryHint": "No access to your app? Use one of your recovery codes.",
      "noRecoveryHint": "You have no recovery codes left."
    }
  },
  "superadmin": {
    "dashboard": {
      "heading": "Dashboard",
      "intro": "Overview of the BCS LMS/LXP platform.",
      "totalTenants": "Tenants total",
      "activeTenants": "Active tenants",
      "imports": {
        "activeImports": "Active imports",
        "allClearTitle": "Imports — all clear",
        "allClearBody": "No failed imports in the last 7 days.",
        "failuresTitle": "Imports — recent failures",
        "failuresBody": "{failed24h} failed in the last 24 hours · {failed7d} in the last 7 days."
      },
      "storage": {
        "allClearTitle": "Storage — all clear",
        "allClearBody": "None of the {count} environments is approaching its storage limit.",
        "attentionTitle": "Storage — needs attention",
        "attentionBody": "{warn} environments are approaching their limit · {over} are over it.",
        "usage": "{used} of {quota} MB ({percent}%)"
      }
    },
    "tenants": {
      "heading": "Tenants",
      "new": "New tenant",
      "edit": "Edit tenant — {name}",
      "empty": "No tenants yet. Create the first one to get started.",
      "confirmDelete": "Delete tenant?",
      "confirmDeleteBody": "This soft-deletes {name}. Data is retained and can be restored by an engineer.",
      "confirmSlugLabel": "Type \"{slug}\" to confirm",
      "confirmSlugHint": "The tenant's slug. Case-sensitive.",
      "confirmDeleteDomainTitle": "Remove domain?",
      "confirmDeleteDomainBody": "This permanently removes {host}. It will stop resolving and users can no longer reach this tenant through it.",
      "cols": {
        "name": "Name",
        "slug": "Slug",
        "status": "Status",
        "locale": "Locale",
        "domains": "Domains"
      },
      "legacyDomainHint": "Leftover host from a previous slug or custom domain. Still resolves to this tenant; no longer used for new login URLs. Use the × to remove it.",
      "removeDomain": "Remove {host}",
      "manageDomainHint": "Admin host — separate session for tenant administration (ADR-0028).",
      "contentDomainHint": "Content host — e-learning material runs here, in its own origin (ADR-0033 § 4).",
      "loginUrlTitle": "One-time admin login URL",
      "loginUrlBody": "Send this URL to the new tenant-admin. It works once and expires in 15 minutes.",
      "orgStructure": "Org structure",
      "manage": "Manage",
      "fields": {
        "adminEmail": "Initial admin e-mail",
        "adminHint": "Optional — create the first tenant-admin user in the same step. They will receive a login URL shortly.",
        "adminName": "Initial admin name",
        "availableLocales": "Available languages",
        "availableLocalesHint": "Languages tenant users can choose from. Tick at least one; the default locale must be ticked.",
        "availableLocalesRequired": "At least one language must be available.",
        "bcsNumber": "BCS number",
        "bcsNumberHint": "The customer number we use within BCS for this customer. Unique per tenant.",
        "contentSlug": "Content host slug",
        "contentSlugHint": "The host that serves e-learning content, as a single label under the central domain. Leave empty for content-<slug>. It must differ from the tenant slug and the manage slug — that separation is exactly why this host exists. Note: each environment needs a DNS/proxy rule for this name.",
        "currency": "Currency",
        "currencyHint": "The currency used within this tenant, for example for prices and budgets.",
        "customDomain": "Custom domain",
        "customDomainHint": "Optional. A single hostname (e.g. leren.acme.nl) the tenant is also reachable on. DNS + TLS are the tenant's responsibility; leave blank to keep only the default subdomain.",
        "locale": "Default locale",
        "localeHint": "Applied to new tenant users unless they pick a different language themselves.",
        "localeNotAvailable": "The default locale must also be ticked in the available-languages list.",
        "manageSlug": "Admin slug",
        "manageSlugHint": "Subdomain of the admin console (a single label under the platform domain). Leave blank for the default manage-<slug>.",
        "name": "Display name",
        "noPlatformLocales": "No platform languages enabled yet — add at least one via the Languages menu.",
        "retentionDays": "Retention for deleted users (days)",
        "retentionDaysHint": "After how many days soft-deleted users are permanently (GDPR) erased. Empty = default 365 days. Enforced by the daily retention task.",
        "slug": "Slug",
        "slugHint": "Lowercase letters, digits and dashes. Forms the default subdomain.",
        "status": "Status",
        "themeMode": "Theme",
        "themeModeHint": "Set the colour theme for this tenant: let users choose (switch in the top bar), or enforce light/dark.",
        "themeModes": {
          "dark": "Always dark",
          "light": "Always light",
          "switch": "User chooses (switch)"
        },
        "timezone": "Timezone",
        "timezoneHint": "Scheduled imports run at the local time of this timezone — a tenant in Mexico_City with schedule 07:00 runs at 07:00 Mexico-City-time, not at 07:00 in the Netherlands."
      },
      "seed": {
        "hint": "Optional — copy a curated set of config from an existing tenant. Picking nothing creates a blank tenant.",
        "sourceLabel": "Copy from tenant",
        "sourceBlank": "— blank tenant (no copy) —",
        "scopesLegend": "What to copy",
        "toastCopied": "Tenant created. Copied:",
        "toastSkipped": "Skipped (nothing to copy):",
        "scopes": {
          "org_structure": {
            "label": "Org-structure",
            "hint": "Categories + their hierarchy + custom field schemas. The actual units (departments, teams) are NOT copied."
          },
          "user_field_schema": {
            "label": "User field-schema",
            "hint": "The full custom-fields definition users get on this tenant."
          },
          "display_name_format": {
            "label": "Display-name format",
            "hint": "Template that composes user display names. Forces user field-schema to be copied too."
          },
          "branding": {
            "label": "Branding",
            "hint": "Colour tokens + logo. Logo file is copied too."
          },
          "import_sources": {
            "label": "Import sources",
            "hint": "Source rows + their slot/column mapping. Forces org-structure and user field-schema to be copied too — the mapping references org-levels + user fields. Credentials are NEVER copied; sources land disabled with empty credentials so the admin fills them in before activating."
          },
          "workflow_templates": {
            "label": "Workflows",
            "hint": "The source tenant's workflow definitions (trigger → condition → steps). Runs stay tenant-specific; only the definitions are copied. The global default set is already seeded into every new tenant anyway."
          }
        }
      },
      "statusLabels": {
        "implementation": "Implementation",
        "active": "Active",
        "suspended": "Suspended",
        "archived": "Archived"
      },
      "statusHints": {
        "implementation": "Default for newly-created tenants. The tenant works as normal for the implementation team, but no transactional emails go out — switch to Active once the platform is configured and ready to invite real users.",
        "active": "Live for end-users. Logins, mail, and every feature work normally.",
        "suspended": "Tenant is paused. End-user logins are refused; existing sessions get a 503 on their next request and are logged out. Superadmin shadow-login still works so you can investigate or unblock the tenant from inside.",
        "archived": "Tenant is wound down. The site returns 404 to everyone, including superadmin shadow-login. Data stays in the database; lift the archive first if you need access again."
      },
      "cards": {
        "general": "General",
        "generalHint": "Name, slug, custom domain and status of the tenant.",
        "languages": "Languages",
        "languagesHint": "Default language and the languages users in this tenant can pick from."
      },
      "sections": {
        "general": "General",
        "locales": "Languages",
        "branding": "Layout",
        "mail": "Mail",
        "pickerLabel": "Section",
        "login": "Login",
        "limits": "Files",
        "modules": "Modules",
        "documents": "Documents"
      },
      "modules": {
        "intro": "Which modules this environment has. Only BCS switches a module on or off; the environment’s administrator never sees a module that is off.",
        "empty": "No modules have been registered yet. Everything the platform can do today is available to every environment.",
        "loadError": "The modules could not be loaded.",
        "retry": "Try again",
        "state": {
          "standard": "Present as standard",
          "sold": "Sold",
          "legacy_activatable": "No longer sold, can still be activated",
          "retired": "Being retired"
        },
        "on": "On",
        "off": "Off",
        "alwaysOn": "Always on and cannot be switched off.",
        "retiredOff": "Being retired: can no longer be switched on.",
        "enable": "Switch on",
        "disable": "Switch off",
        "enabledBy": "Switched on by {name} on {date}",
        "disabledBy": "Switched off by {name} on {date}",
        "removedPerson": "a removed administrator",
        "unknownPerson": "unknown",
        "neverSwitched": "Never switched on or off.",
        "confirmRetiredTitle": "Switch off a module that is being retired?",
        "confirmRetiredBody": "Module {module} is being retired. If you switch it off now, it cannot be switched on again. The data is kept.",
        "confirmRetired": "Switch off anyway"
      },
      "mail": {
        "transportTitle": "Sender & transport",
        "mode": "Send mode",
        "modeInherit": "Global default",
        "modeInheritHint": "Follows the global default: {mode}",
        "modeRelay": "Platform relay (recommended)",
        "modeSmtp": "Own SMTP server",
        "fromAddress": "From address",
        "fromName": "From name",
        "replyTo": "Reply-To",
        "smtpHost": "SMTP host",
        "smtpPort": "SMTP port",
        "smtpEncryption": "Encryption",
        "smtpUsername": "SMTP username",
        "smtpPassword": "SMTP password",
        "passwordSet": "A password is set — leave empty to keep it unchanged.",
        "lifecycleTitle": "Sending & retention",
        "sendingEnabled": "Actually send mail",
        "openTracking": "Open tracking (pixel)",
        "storeTransactionalBody": "Store transactional mail content",
        "delayMinutes": "Delay (minutes)",
        "retentionDays": "Retention (days)",
        "testTitle": "Test mail",
        "testHint": "Sends a test mail via the configured transport, even when sending is off.",
        "testTo": "Test address",
        "testToInvalid": "Enter a valid email address.",
        "testSend": "Send test",
        "testOk": "Test mail sent.",
        "connectionTest": "Test connection",
        "connectionHint": "Tests the saved transport settings without sending a mail. Save first.",
        "connectionOk": "Connection successful.",
        "dnsTitle": "DNS check (SPF/DKIM/DMARC)",
        "dnsHint": "Checks the email-authentication records of the configured From domain. Predicts whether mail will pass recipients' spam filters. Save first.",
        "dnsCheck": "Check DNS",
        "dnsDomain": "Domain",
        "dkimSelector": "DKIM selector (optional)",
        "dkimSelectorHint": "DKIM selector e.g. 'default' or 's1' — needed to look up the right DKIM record.",
        "dnsExpected": "Add a TXT record on {host} containing:",
        "spfNoRelay": "does not include our relay",
        "dnsStatus": {
          "ok": "OK",
          "warn": "warning",
          "missing": "missing",
          "skipped": "not checked"
        }
      },
      "unsavedConfirm": "You have unsaved changes. Continue without saving?",
      "userFields": {
        "baseHeading": "Base fields",
        "baseHint": "Always present on every user. Fixed fields — only the label and 'required' can be changed.",
        "requiredLabel": "Required",
        "labelForLocale": "Label ({locale})",
        "schemaHeading": "Additional fields",
        "schemaHint": "Each field defined here appears on every user profile. The available types are the same as for org-structure units.",
        "displayNameHeading": "Display name format",
        "displayNameHint": "Composes the user's display label from their split-name fields. Tokens in curly braces (first_name, last_name, email, or any custom field key) are replaced with that user's value. The default produces \"Jan Janssen\"; switch to a last-name-first format for sortable directories or combine with a custom \"initialen\" field.",
        "displayNameFormat": "Format template",
        "displayNameUnknownTokens": "Unknown tokens in template — fix or these will produce empty strings:",
        "displayNameTokensHeading": "Available tokens",
        "displayNamePreview": "Preview:"
      },
      "branding": {
        "heading": "Layout",
        "hint": "Customise the look and feel of this tenant's workspace. Changes take effect on the next page load.",
        "primaryColor": "Brand colour",
        "primaryColorHint": "Hex value (e.g. #1a56db). Applied to buttons, links, and the active nav indicator. Leave blank for the platform default.",
        "accentColor": "Accent colour",
        "accentColorHint": "Hex value (e.g. #13796d). Used as the second stop in primary-button gradients and for secondary chips and icons. Leave blank for the platform default.",
        "buttonHoverColor": "Button hover colour",
        "buttonHoverColorHint": "Hex value. Background of primary buttons when the cursor is on them. Leave blank to use a slightly darker variant of the brand colour.",
        "activeIndicatorColor": "Active-menu indicator",
        "activeIndicatorColorHint": "Hex value. The thin coloured bar to the left of the currently-open page in the sidebar. Leave blank to follow the brand colour.",
        "sidebarColor": "Sidebar colour",
        "sidebarColorHint": "Hex value (e.g. #1B1F33). Replaces the default dark sidebar background. Must be dark enough for white text to remain readable — values that fail the contrast check are rejected on save.",
        "sidebarPreview": "Live preview of the sidebar with this colour",
        "nameInUi": "Portal name",
        "nameInUiHint": "Name displayed in the sidebar and browser tab. Defaults to the tenant's display name when left blank.",
        "senderName": "Training sender name",
        "senderNameHint": "The name this customer's training function goes by (HR, L&D, Training). Signs learning-related messages, for example \"L&D — Acme Care\"; account and access messages carry the organisation name only. Leaving it blank is fine — then only the organisation name appears.",
        "logo": "Logo",
        "logoHint": "PNG or JPG, max 2 MB. Shown in the sidebar instead of the default BCS logo.",
        "logoUpload": "Upload logo",
        "logoReplace": "Replace",
        "logoRemove": "Remove logo",
        "logoPreview": "Logo preview",
        "logoInvalid": "Upload failed. Check the file type (PNG/JPG) and size (max 2 MB).",
        "logoLayout": "Logo + name layout",
        "logoLayoutHint": "Pick how the logo and the portal name combine in the sidebar and on the login screen.",
        "logoLayouts": {
          "logo_then_title": "Logo with the name beside it",
          "logo_above_title": "Logo with the name underneath",
          "logo_only": "Logo only",
          "title_only": "Name only"
        },
        "logoAlign": "Brand alignment",
        "logoAlignHint": "Whether the logo + name sit at the start of the sidebar header or are centred horizontally. Applies to whichever layout you picked above.",
        "logoAligns": {
          "left": "Aligned to the start",
          "center": "Centred"
        },
        "favicon": "Favicon",
        "faviconHint": "PNG, JPG or ICO, max 256 KB. Shown in the browser tab instead of the default BCS favicon.",
        "faviconUpload": "Upload favicon",
        "faviconReplace": "Replace",
        "faviconRemove": "Remove favicon",
        "faviconPreview": "Favicon preview",
        "faviconInvalid": "Upload failed. Check the file type (PNG/JPG/ICO) and size (max 256 KB)."
      },
      "bcs": {
        "title": "BCS Login (OIDC)",
        "intro": "Choose the login mode for this tenant and configure BCS Login (Keycloak). Client secrets are never shown; leave blank to keep unchanged.",
        "mode": "Login mode",
        "modePassword": "Email & password",
        "modeBcs": "BCS Login (OIDC)",
        "modeDev": "Dev login",
        "baseUrl": "Base URL",
        "realm": "Realm",
        "clientId": "Client ID",
        "customerNr": "Customer number",
        "customerNrHint": "Blank = {number}, the BCS number under General. Only fill this in if this environment needs a different number.",
        "customerNrEmpty": "No BCS number under General yet",
        "customerNrMissing": "BCS Login cannot be enabled without a customer number — fill in the BCS number under General, or set one here.",
        "environmentCode": "Environment code",
        "applicationCode": "Application code",
        "scopes": "Scopes",
        "clientSecret": "Client secret",
        "secretSet": "Leave blank to keep the existing secret. Only fill this in to replace it.",
        "secretRequired": "Required to enable BCS Login.",
        "jitProvision": "Auto-create unknown users (JIT)",
        "provisioningTitle": "Creating accounts in BCS Login",
        "provisioningConfigured": "The provisioning client is configured on the server and applies to every environment. It is not shown here because it belongs to the product line, not to a customer.",
        "provisioningMissing": "No provisioning client is configured on this server, so no accounts are created in or revoked from BCS Login. That is a server setting, not a setting of this environment.",
        "saveFailed": "Save failed",
        "genericError": "Could not save. Check the values and try again.",
        "customerNrNoGeneral": "There is no BCS number under General yet. Fill it in there, or give this environment its own number here.",
        "customerNrOverrideTitle": "Own customer number for this environment",
        "customerNrOverride": "The login uses {override} instead of {general} from General. If that is wrong, clear this field."
      },
      "documents": {
        "heading": "Documents",
        "intro": "Whether the BCS certificate templates can be chosen in this environment. Off takes precedence over the customer's own setting.",
        "available": "BCS templates available",
        "saveFailed": "Saving failed.",
        "offNote": "Off: the customer does not see the BCS templates and cannot switch them on. Where one is already chosen, it keeps making certificates."
      }
    },
    "auditLog": {
      "heading": "Audit log",
      "intro": "Read-only history of changes made on this tenant. Newest first. Filter by action prefix, actor or target type to narrow the view.",
      "empty": "No audit entries match the current filters.",
      "diffShow": "Show diff",
      "pageOf": "Page {current} of {total}",
      "filters": {
        "actionPlaceholder": "user.",
        "actorComboPlaceholder": "Search by name or email…",
        "actorComboAria": "Filter by actor",
        "sectionSuperadmins": "Superadmins",
        "sectionUsers": "Users",
        "targetTypePlaceholder": "User, Tenant…",
        "from": "From",
        "to": "Through",
        "clearAll": "Clear all filters"
      },
      "cols": {
        "when": "When",
        "actor": "Actor",
        "action": "Action",
        "target": "Target",
        "diff": "Diff"
      }
    },
    "superadmins": {
      "heading": "Superadmins",
      "intro": "Manage the platform-team. Add a colleague, rename or rotate their password, remove them when they move on.",
      "new": "Add superadmin",
      "edit": "Edit superadmin",
      "empty": "No superadmins yet — that's unusual; the seeded superadmin should be here.",
      "mfaOn": "MFA enabled",
      "mfaOff": "MFA off",
      "resetPassword": "Reset password",
      "resetPasswordSubmit": "Reset password",
      "resetPasswordBody": "Set a new password for {name}. They'll need to use this on their next login.",
      "confirmDelete": "Remove superadmin?",
      "confirmDeleteBody": "Soft-deletes {name}. Their audit-log entries are kept; their session is invalidated on next request.",
      "cols": {
        "name": "Name",
        "email": "E-mail",
        "mfa": "MFA"
      },
      "fields": {
        "name": "Name",
        "email": "E-mail",
        "password": "Password",
        "passwordHint": "Minimum 12 characters with letters (mixed case) and digits."
      }
    }
  },
  "tenantSetup": {
    "heading": "Tenant setup",
    "intro": "Everything this tenant needs to get started or adjust later. Pick a section to dive in.",
    "comingSoon": "Coming soon",
    "impersonate": "Log in as tenant admin",
    "impersonateGenericError": "Could not mint a login URL for this tenant.",
    "impersonateUrlTitle": "One-time tenant-admin login URL",
    "impersonateUrlBody": "Open this URL in this browser, or copy it to use in another browser or incognito window. It works once and expires shortly.",
    "impersonateUrlOpen": "Open in new tab",
    "sections": {
      "orgStructure": {
        "title": "Organisation structure",
        "description": "Define the categories, their hierarchy, and the custom fields the tenant-admin can fill in per unit."
      },
      "imports": {
        "title": "User imports",
        "description": "CSV uploads, SFTP feeds, or HR-system integrations (AFAS, YouForce, HR2Day, Polaris)."
      },
      "platformSettings": {
        "title": "Platform settings",
        "description": "Branding, auth driver, license limits, and other tenant-wide configuration."
      },
      "auditLog": {
        "title": "Audit log",
        "description": "Read-only history of mutations on this tenant: who changed what, when. Filter by action, actor or target type."
      }
    }
  },
  "platformAssets": {
    "add": "Add images",
    "addError": "Adding failed. Please try again.",
    "confirmRemove": "Are you sure? The image disappears for everyone using it.",
    "empty": "There are no images in the library yet.",
    "heading": "Platform library",
    "intro": "The images we supply. They are not copied to environments: they live here once. Click an image to see where it stands, roll it out, or revoke it. PNG and JPG only; several at a time is fine.",
    "loadError": "The library could not be loaded.",
    "next": "Next",
    "pageOf": "Page {page} of {total}",
    "pagination": "Pagination",
    "prev": "Previous",
    "push": "Roll out",
    "pushConfirm": "Roll out to {count} environment(s)",
    "pushError": "Rolling out failed. Please try again.",
    "syncError": "Updating the environments failed.",
    "altError": "The alt text could not be saved.",
    "revokeError": "The image could not be revoked.",
    "pushHas": "Already has it",
    "pushIntro": "Choose which environments this image goes to. Nothing happens to environments you do not tick.",
    "sourceChangedHint": "This is what the source holds now. If you take it over, it becomes the image — in every environment that has it in its library, everywhere it is used.",
    "syncDone": "{pushed} availabilities added across {tenants} environments. Images an administrator had removed were left alone.",
    "sync": "Update in all environments",
    "altHint": "Every environment receives this text. An environment may override it per language with its own; where it does not, this one stands.",
    "altHeading": "Supplied alt text",
    "selectAll": "All environments",
    "rolloutHeading": "Roll out to environments",
    "pushLoadError": "The environments could not be loaded.",
    "pushRemoved": "Removed by the customer",
    "revokeFor": "Revoke from {name}",
    "revoke": "Revoke",
    "pushRevoked": "Revoked by us",
    "remove": "Remove",
    "removeError": "Removing failed. Please try again.",
    "removeFor": "Remove {name}"
  },
  "platformLocales": {
    "heading": "Platform languages",
    "intro": "The catalogue of languages tenants can pick from. Disabled entries stay in the table for reference but no longer appear in tenant forms. Adding a language here doesn't ship a translation — make sure the matching src/shared/i18n/locales/[code].json bundle exists, otherwise users see English fallback strings.",
    "new": "Add language",
    "edit": "Edit language",
    "empty": "No languages yet. Add one to let tenants pick it.",
    "on": "Enabled",
    "off": "Disabled",
    "cols": {
      "code": "Code",
      "label": "Label",
      "enabled": "Enabled"
    },
    "confirmDelete": "Remove language?",
    "confirmDeleteBody": "Remove {label} ({code}) from the catalogue. Tenants that still reference this code in their settings will drop it silently on the next save.",
    "fields": {
      "code": "Code",
      "codeHint": "Only a language the platform has texts for: {codes}.",
      "label": "Native label",
      "labelHint": "How speakers of the language write the language's own name (Nederlands, Deutsch, Français, …).",
      "position": "Position",
      "positionHint": "Lower numbers appear first in tenant dropdowns.",
      "enabled": "Enabled"
    }
  },
  "orgStructure": {
    "userFields": {
      "heading": "User fields",
      "intro": "Applies to all users of this tenant. Define the external-ID label, additional fields (same types as units) and the display-name format."
    },
    "userStructure": {
      "title": "User structure",
      "summary": "{count} additional fields · display name:"
    },
    "heading": "Organisation structure",
    "intro": "Define the categories, their hierarchy, and the custom fields a tenant-admin can fill in per unit. Drag rows to re-order or re-parent.",
    "new": "Add category",
    "edit": "Edit category",
    "empty": "No categories defined yet. Add the first one to get started.",
    "customFields": "custom field(s)",
    "confirmDelete": "Delete category?",
    "confirmDeleteBody": "Deletes {name}. Units in this category and all user assignments to them will be removed — type {name} to confirm.",
    "confirmDeletePrompt": "Type the category name to confirm",
    "moveUpSibling": "Move up within siblings",
    "moveDownSibling": "Move down within siblings",
    "moveOutdent": "One level up (out of the parent category)",
    "moveIndent": "One level down (under the category above)",
    "dragHint": "Drag a category: drop on top of another to make it a child, drop above or below to reorder as a sibling.",
    "dragHandle": "Drag to move",
    "badge": {
      "required": "Required",
      "multiple": "Multiple"
    },
    "fields": {
      "key": "Key",
      "keyHint": "Stable identifier, lowercase letters/digits/dashes/underscores. Used in the HR-import mapping UI later.",
      "parent": "Belongs under",
      "parentNone": "None (top level)",
      "parentHint": "Determines where this category sits in the tree — same as dragging, but more precise.",
      "labelFor": "Label ({locale})",
      "fieldSchema": "Custom fields for units in this category",
      "fieldSchemaHint": "Shape: { \"fields\": [{ \"key\": \"code\", \"type\": \"string\", \"required\": true, \"label\": { \"en\": \"Code\" } }] }. Types: string, text, email, number, date, boolean, userid.",
      "fieldSchemaHintShort": "Each field defined here turns into a typed input on every unit in this category (in the tenant app)."
    },
    "membership": {
      "heading": "User membership",
      "hint": "Controls how users get assigned to units in this category.",
      "membershipRequired": "Every user must be in at least one unit in this category.",
      "allowMultipleUnits": "A user may sit in multiple units in this category.",
      "allowNesting": "A unit may sit under another unit in the same category.",
      "allowNestingHint": "Turn this on if your structure has, for example, teams within teams. With it off, a unit can only sit under the parent category.",
      "ancestorAutoRequiredHint": "A required category implicitly requires its ancestor categories too — otherwise users couldn't pick a unit.",
      "impactWarn": "{count} existing user(s) currently have no unit in this category — their accounts stay active, but the next edit will require a pick.",
      "impactSoftValidated": "This category has no units yet; making it required only takes effect once you add some."
    },
    "externalIdLabel": {
      "heading": "External ID label",
      "hint": "The external-ID field is always present on every unit in this category. Use this to rename the label — for example \"Cost center code\". Leave empty to use the default label \"External ID\".",
      "labelFor": "Label ({locale})"
    }
  },
  "tenant": {
    "dashboard": {
      "heading": "My dashboard",
      "intro": "What is waiting for you, in one place.",
      "loading": "Loading your dashboard…",
      "loadError": "Your dashboard could not be loaded.",
      "retry": "Try again",
      "emptyTitle": "Nothing is waiting for you right now",
      "emptyBody": "As soon as there is a task, an approval, a training or a request for you, it will appear here.",
      "block": {
        "loading": "Loading…",
        "loadError": "This block could not be loaded.",
        "retry": "Try again",
        "viewAll": "View all",
        "count_one": "{count} open",
        "count_other": "{count} open"
      },
      "tasks": {
        "title": "My tasks",
        "empty": "You have no open tasks.",
        "openUntil": "Open until {date}",
        "submittedOn": "Submitted on {date}",
        "attendanceSince": "Attendance open since {date}",
        "untitledActivity": "Untitled training",
        "typeLink": "{label} ({count})",
        "kind": {
          "questionnaire": "Questionnaire",
          "grading": "Grading",
          "attendance": "Attendance"
        }
      },
      "approvals": {
        "title": "Pending approvals",
        "empty": "No approvals are waiting for you.",
        "unknownApplicant": "Unknown applicant",
        "decideBefore": "Decide before {date}",
        "kind": {
          "enrollment": "Enrolment",
          "cancellation": "Cancellation",
          "external_request": "External training",
          "other": "Request"
        }
      },
      "myCourses": {
        "title": "My courses",
        "count_one": "{count} course",
        "count_other": "{count} courses",
        "empty": "You are not enrolled in anything that needs you or is running right now.",
        "progress": "{percent}% completed",
        "state": {
          "waiting": "Waiting for you",
          "active": "In progress",
          "upcoming": "Coming up"
        },
        "action": {
          "respond_offer": "You have been offered a place: respond to it",
          "fill_questionnaire_one": "A questionnaire or test is waiting for you",
          "fill_questionnaire_other": "{count} questionnaires or tests are waiting for you",
          "start": "Not started yet",
          "continue": "Continue",
          "attend": "Session"
        }
      },
      "nextTraining": {
        "title": "My next training",
        "empty": "No more trainings are planned for you."
      },
      "myLessons": {
        "title": "My lessons this week",
        "empty": "You are not teaching this week.",
        "count_one": "{count} lesson",
        "count_other": "{count} lessons"
      },
      "session": {
        "inZone": "{when} (time zone {zone})"
      },
      "myRequests": {
        "empty": "You have no running requests.",
        "emptyCanStart": "Request a training that is not in the catalogue."
      }
    },
    "adminDashboard": {
      "heading": "Dashboard",
      "intro": "What is on your plate, what happened today and what is in your environment.",
      "loading": "Loading the dashboard…",
      "loadError": "The dashboard could not be loaded.",
      "retry": "Try again",
      "emptyTitle": "Nothing here for you yet",
      "emptyBody": "Your permissions do not include any of the admin dashboard blocks. Use the menu to continue.",
      "nothingWaiting": "Nothing is waiting for you.",
      "zones": {
        "waiting": "Waiting for me",
        "today": "What happened today",
        "now": "What is happening now",
        "environment": "What is in my environment"
      },
      "signals": {
        "title": "Signals",
        "empty": "No signals.",
        "count_one": "{count} signal",
        "count_other": "{count} signals",
        "cancelledToday_one": "{count} cancellation today",
        "cancelledToday_other": "{count} cancellations today",
        "belowMinimum": "Below the minimum: {taken} of at least {minimum} participants",
        "decide": "Will this training go ahead?"
      },
      "logins": {
        "title": "Logged in",
        "today": "Today",
        "yesterday": "Last seen yesterday"
      },
      "enrollmentsToday": {
        "title": "Enrolments today",
        "enrolled": "Enrolments",
        "cancelled": "Cancellations"
      },
      "logStrip": {
        "title": "Recent in the log",
        "empty": "No logins, enrolments or cancellations in the log yet.",
        "someone": "Someone",
        "login": "{name} logged in",
        "enrollment": "{name} enrolled for {course}",
        "enrollmentNoCourse": "{name} enrolled",
        "cancellation": "{name} cancelled for {course}",
        "cancellationNoCourse": "{name} cancelled an enrolment",
        "enrollmentByOther": "{actor} enrolled {participant} for {course}",
        "enrollmentByOtherNoCourse": "{actor} enrolled {participant}",
        "enrollmentNoActor": "{participant} was enrolled for {course}",
        "enrollmentNoActorNoCourse": "{participant} was enrolled",
        "cancellationByOther": "{actor} cancelled the enrolment of {participant} for {course}",
        "cancellationByOtherNoCourse": "{actor} cancelled the enrolment of {participant}",
        "cancellationNoActor": "The enrolment of {participant} for {course} was cancelled",
        "cancellationNoActorNoCourse": "The enrolment of {participant} was cancelled",
        "erased": "Deleted user"
      },
      "shortcuts": {
        "title": "Shortcuts",
        "empty": "No shortcuts.",
        "users": "Active users",
        "catalog": "Catalogue"
      },
      "failedCertificates": {
        "title": "Certificates not made",
        "count_one": "{count} certificate",
        "count_other": "{count} certificates",
        "empty": "All certificates have been made."
      },
      "documentTemplateUpdates": {
        "title": "New version of a BCS template",
        "count_one": "{count} template",
        "count_other": "{count} templates",
        "empty": "No new versions.",
        "versions": "Version {from} → {to}",
        "tenant_logo_changed": "New environment logo",
        "tenant_logo_removed": "Environment logo removed"
      }
    },
    "sendMessage": {
      "title": "Send message",
      "intro": "Compose a message and choose who receives it. You'll see how many users it reaches before sending.",
      "subject": "Subject",
      "body": "Message",
      "audience": "Recipients",
      "segmentType": "Audience",
      "types": {
        "individuals": "Individual users",
        "orgUnits": "Org units",
        "orgUnitManagers": "Unit managers",
        "everyone": "Everyone",
        "everyoneHint": "All active users."
      },
      "pickUsers": "Search and pick users…",
      "pickUnits": "Search and pick units…",
      "includeDescendants": "Include sub-units",
      "addSegment": "Add audience",
      "attachments": "Attachments",
      "addAttachment": "Add attachment",
      "attachmentError": "Upload failed — check file type and size (max 10 MB).",
      "timing": "Send timing",
      "when": "When to send",
      "whenNow": "Immediately",
      "whenLater": "Schedule for date/time",
      "scheduledFor": "Send at",
      "reaches": "Reaches {count} user(s)",
      "noAudience": "No audience selected yet.",
      "send": "Send",
      "sent": "Message scheduled for {count} recipient(s).",
      "confirmTitle": "Send message?",
      "confirmBody": "This message will be sent to {count} user(s).",
      "confirmBodyUnknown": "Are you sure you want to send this message?",
      "confirmSend": "Yes, send",
      "editor": {
        "toolbar": "Formatting",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "heading": "Heading",
        "bulletList": "Bullet list",
        "numberList": "Numbered list",
        "alignLeft": "Align left",
        "alignCenter": "Center",
        "alignRight": "Align right",
        "link": "Insert link",
        "linkPrompt": "Enter an https URL:",
        "linkTitle": "Insert link",
        "linkTextLabel": "Text",
        "linkUrlLabel": "URL",
        "linkInsert": "Insert",
        "linkInvalid": "Use an https:// or mailto: link.",
        "linkChipHint": "The {tag} tag becomes the clickable link.",
        "linkRemove": "Remove link"
      }
    }
  },
  "orgChart": {
    "heading": "Org chart",
    "coverage": {
      "title": "Who is in {name}?",
      "back": "Back to the group",
      "today": "This is who falls in it today. A group works with rules, so tomorrow it may be someone else.",
      "ofTotal": "{members} of {total}",
      "emptyUnit": "no people",
      "namedIncluded": "included by the rule",
      "namedExcluded": "excluded by the rule",
      "legendFull": "everyone is in",
      "legendSome": "some are in",
      "legendNone": "nobody is in",
      "legendNamedIncluded": "rule names this unit: include",
      "legendNamedExcluded": "rule names this unit: exclude",
      "total": "{count} people in total.",
      "unplaced": "Of those, {count} sit in no unit at all, so they are not shown here.",
      "unavailable": "We could not load who this group covers."
    },
    "hint": "Drag a block onto its new parent unit to move it; drag the background to pan, scroll to zoom. Keyboard: arrow keys = navigate, Enter = edit unit, space = collapse/expand.",
    "levelFilter": "Show categories",
    "search": "Search a unit…",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "export": "Export as image (PNG)",
    "exportPdf": "Download as PDF — sharp vector text, even for large charts",
    "print": "Print org chart",
    "hits_one": "{count} match — Enter jumps to it",
    "hits_other": "{count} matches — Enter jumps to the next",
    "back": "Table view",
    "fit": "Fit to screen",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "expand": "Expand child units",
    "collapse": "Collapse child units",
    "members_one": "{count} member",
    "members_other": "{count} members",
    "empty": "No units yet — create them in the table view first.",
    "toUnits": "Go to organisation units"
  },
  "orgUnitsList": {
    "heading": "Units by category",
    "viewChart": "Org chart",
    "intro": "Per-category overview. Click a tab to switch category and a row to open the detail page.",
    "level": "Category",
    "searchPlaceholder": "Search by name, external ID, parent, or attribute…",
    "addFor": "New {level}",
    "empty": "No units in this category. Add one or adjust your search.",
    "unknownUser": "Unknown user",
    "viewMembers": "View {count} members of this unit",
    "col": {
      "name": "Name",
      "parent": "Parent",
      "members": "Members"
    }
  },
  "unitDetail": {
    "loading": "Loading…",
    "detailsHeading": "Details",
    "membersHeading": "Members",
    "membersNonLeafHint": "Users typically hang off the deepest level; this unit can hold members too but it's unusual.",
    "noMembers": "No members yet.",
    "childrenHeading": "Child units",
    "noChildren": "No child units yet."
  },
  "userProfile": {
    "avatar": {
      "heading": "Profile picture",
      "upload": "Upload photo",
      "replace": "Replace photo",
      "remove": "Remove",
      "present": "A profile picture is set",
      "cropTitle": "Crop photo",
      "cropHint": "Drag to reposition and use the slider to zoom.",
      "cropZoom": "Zoom",
      "cropConfirm": "Apply"
    },
    "loading": "Loading…",
    "openLink": "Profile",
    "detailsHeading": "Profile details",
    "assignmentsHeading": "Organisation membership",
    "assignmentsHint": "Pick the unit(s) in each category this user belongs to. A sub-category becomes available once its parent is filled.",
    "noCategories": "No categories defined — ask BCS Learning to fill in the organisation structure.",
    "noUnitsForCategory": "No units in \"{category}\" — add some first via Organisation structure.",
    "pickPlaceholder": "Pick…",
    "pickerLockedNoParent": "Fill in \"{parent}\" first to enable this picker.",
    "cascadeClearedToast": "Removed from \"{category}\": {names} (parent changed)",
    "save": "Save",
    "savedToast": "Assignments saved.",
    "saveError": "Save failed — check the per-category errors.",
    "customFieldsHeading": "Additional fields",
    "deletedBanner": "This user has been deleted. Editing is disabled — you can restore the user or erase their data permanently.",
    "lastLogin": "Last logged in: {when}",
    "lastLoginNever": "Never logged in",
    "restore": "Restore user",
    "restoreError": "Restore failed. Please try again.",
    "gdpr": {
      "heading": "Privacy (GDPR)",
      "intro": "Export all of this user's data, or erase it permanently on request.",
      "export": "Export data",
      "exportError": "Export failed. Please try again.",
      "erase": "Erase data",
      "eraseError": "Erase failed. Please try again.",
      "eraseConfirmTitle": "Permanently erase data?",
      "eraseConfirmBody": "This irreversibly removes {name}: profile, links and memberships. Anonymised traces are kept for the audit trail. This cannot be undone.",
      "eraseConfirmLabel": "Type the email address to confirm: {email}"
    }
  },
  "tenantUsers": {
    "heading": "Users",
    "impersonate": "Log in as",
    "impersonateFailed": "We could not log you in as this user.",
    "new": "New user",
    "edit": "Edit user — {name}",
    "empty": "No users yet.",
    "confirmDelete": "Delete user?",
    "confirmDeleteBody": "Soft-deletes {name}. Audit trail is retained.",
    "viewDeleted": "Deleted users",
    "backToActive": "Back to active users",
    "deletedHeading": "Deleted users",
    "deletedListIntro": "You are viewing deleted users. Open a profile to restore the user or erase their data permanently.",
    "deletedEmpty": "No deleted users.",
    "bulkErase": "Erase permanently ({count})",
    "bulkEraseTitle": "Permanently erase users?",
    "bulkEraseBody": "You are about to irreversibly erase {count} user(s): profiles, links and memberships. Anonymised traces are kept for the audit trail. This cannot be undone.",
    "bulkEraseConfirmLabel": "Type the number to confirm: {count}",
    "bulkEraseConfirm": "Erase permanently",
    "bulkEraseError": "Erase failed. Please try again.",
    "bulkEraseDone": "{count} user(s) permanently erased.",
    "bulkEraseDoneSkipped": "{count} user(s) permanently erased; {skipped} skipped (last administrator).",
    "bulkEraseDonePartial": "{count} user(s) permanently erased. {failed} could not be erased and are still in the list; the error has been reported.",
    "bulkEraseDonePartialSkipped": "{count} user(s) permanently erased; {skipped} skipped (last administrator). {failed} could not be erased and are still in the list; the error has been reported.",
    "fields": {
      "name": "Name",
      "firstName": "First name",
      "lastName": "Last name",
      "displayNameLabel": "Display name:",
      "email": "E-mail",
      "role": "Role",
      "status": "Status",
      "isExternal": "External user",
      "isExternalHint": "Not employed by this organisation — an auditor, a freelance trainer or a contractor, for example. A message to \"everyone\" does not reach external accounts by default.",
      "isLearner": "Takes training",
      "isLearnerHint": "This person learns and counts towards reporting on completed activities. Independent of external: a contractor is external and learning, an auditor is external and not. Off also means: no base role User.",
      "externalId": "External ID",
      "phone": "Phone",
      "hireDate": "Hire date",
      "endDate": "End date",
      "accountValidFrom": "Account valid from",
      "accountValidFromHint": "Before this date the user cannot log in yet. Empty = valid straight away.",
      "accountValidUntil": "Account valid until",
      "accountValidUntilHint": "After this date the user can no longer sign in. Empty = valid indefinitely.",
      "deletedAt": "Deleted on",
      "roles": "Roles"
    },
    "status": {
      "active": "Active",
      "invited": "Invited",
      "suspended": "Suspended",
      "expired": "Expired",
      "not_yet_valid": "Not yet valid"
    },
    "roles": {
      "tenant-admin": "Administrator",
      "user": "User"
    },
    "filteredByUnit": "Filtered to members of \"{unit}\".",
    "clearFilter": "Show all users",
    "baseRoleNote": "Every new user also receives the base role User.",
    "createdButRoleFailed": "The user was created, but not all roles could be granted:",
    "toProfile": "Go to profile",
    "filteredByRole": "Only users with the role \"{role}\".",
    "manageRoles": "Manage roles and scope →",
    "pickRoles": "Pick one or more roles"
  },
  "orgUnits": {
    "heading": "Organisation units",
    "missingParent": "Missing required parent unit",
    "missingParentBanner_one": "{count} unit should sit under a parent unit according to the current structure, but has none. Link it via Edit.",
    "missingParentBanner_other": "{count} units should sit under a parent unit according to the current structure, but have none. Link them via Edit.",
    "intro": "Fill the tree defined by the superadmin. Add children, edit attributes, and assign tenant users.",
    "new": "Add unit",
    "edit": "Edit unit",
    "empty": "No units yet. Add your first organisation on top.",
    "noLevelsTitle": "No categories defined",
    "noLevelsBody": "Ask BCS Learning to define at least one category before you can add units.",
    "confirmDelete": "Delete unit?",
    "confirmDeleteBody": "Soft-deletes {name}. Only possible once the unit is empty: no employees in it and no units below it.",
    "impactUnavailable": "We could not load what depends on this unit. Try again before you delete.",
    "impact": {
      "blockedLead": "Not possible right now — the unit is not empty:",
      "losingLead": "This falls away once you delete:",
      "users": "{count} employee(s) are still in it",
      "children": "{count} unit(s) sit below it",
      "roleAssignments": "{count} role assignment(s) scoped to this unit will grant nothing",
      "accessGroups": "{count} access group(s) become broken and include nobody",
      "exclusions": "Note: {count} access group(s) exclude this unit. They become broken too and include nobody — until you repair them.",
      "nothingAttached": "Nothing else depends on this unit.",
      "groupNames": "This concerns: {names}."
    },
    "assignTitle": "Assign user to unit",
    "assignBody": "Pick a user to assign to {name}. Only active assignments are shown on the user profile.",
    "assign": "Assign",
    "fields": {
      "level": "Category",
      "name": "Name",
      "externalId": "External ID",
      "externalIdHint": "Stable id from your HR system — used when the same record is re-imported.",
      "attributes": "Custom attributes",
      "attributesHint": "Values for the custom fields declared in this category's schema.",
      "parent": "Parent unit",
      "parentOf": "Parent {level}",
      "parentHintFree": "Optional. The unit this one hangs under in the tree.",
      "parentHintConstrained": "This category hangs under \"{level}\" — only units in that category are shown.",
      "parentRequired": "This category has to hang under a parent unit — pick one.",
      "pickParent": "pick a parent unit",
      "noParent": "— no parent (root) —",
      "user": "User"
    }
  },
  "fieldSchema": {
    "empty": "No custom fields yet. Click \"Add field\" to define the first one.",
    "addField": "Add field",
    "fields": {
      "key": "Key",
      "type": "Type",
      "required": "Required",
      "labelFor": "Label ({locale})",
      "role": "Role"
    },
    "dragHandle": "Drag to reorder",
    "labels": {
      "expand": "Show labels",
      "collapse": "Hide labels",
      "none": "No labels filled in",
      "collapsedSummary": "Labels filled for:"
    },
    "errors": {
      "invalidKey": "Use lowercase letters, digits, dashes or underscores (e.g. \"cost_center\").",
      "duplicateKey": "This key is already in use in this category."
    },
    "roles": {
      "none": "No role (own field)"
    }
  },
  "orgFields": {
    "types": {
      "string": "Text (single line)",
      "text": "Text (multi-line)",
      "email": "E-mail",
      "number": "Number",
      "date": "Date",
      "boolean": "Yes / No",
      "userid": "User (e.g. manager)"
    }
  },
  "attributeForm": {
    "noFields": "This category has no custom fields.",
    "required": "This field is required.",
    "boolean": {
      "label": "Yes"
    }
  },
  "profile": {
    "prefs": {
      "heading": "Preferences",
      "rememberDrafts": "Remember drafts on forms",
      "rememberDraftsHint": "Saves what you type locally, on all pages, so you don't lose it."
    },
    "mfa": {
      "title": "Two-step verification",
      "intro": "An extra step when signing in, on top of your password. You need an authenticator app for it.",
      "start": "Set up",
      "qrAlt": "QR code for your authenticator app",
      "secretHint": "No camera? Enter this key by hand:",
      "code": "Code from the app",
      "confirm": "Switch on",
      "on": "Two-step verification is switched on.",
      "newCodes": "New recovery codes",
      "disable": "Switch off",
      "codesTitle": "Keep these recovery codes",
      "codesHint": "You see them once. Store them somewhere other than your phone — without one of these codes you cannot get back in if you lose your app.",
      "genericError": "That did not work. Please try again."
    },
    "heading": "My profile",
    "intro": "Update your own details. Your e-mail stays fixed — your audit trail is attached to it.",
    "saved": "Saved.",
    "fields": {
      "email": "E-mail",
      "name": "Name",
      "locale": "Language",
      "localeHint": "The language the app is shown in."
    }
  },
  "tenantAuth": {
    "title": "Signing you in",
    "verifying": "Verifying your login link…",
    "success": "Signed in! Taking you to your workspace.",
    "failedTitle": "Login failed",
    "genericError": "Could not sign you in. Ask your admin for a fresh login link.",
    "sessionExpired": "Your session has timed out. Please open your dev-login URL again to sign back in.",
    "needLoginUrl": "Sign in by opening the dev-login URL your admin sent you.",
    "loginUrlHint": "Each URL works once and expires after 15 minutes — request a new one if you've already used it.",
    "backHome": "Back to home",
    "form": {
      "title": "Sign in",
      "email": "E-mail address",
      "password": "Password",
      "remember": "Keep me signed in",
      "submit": "Sign in",
      "forgotLink": "Forgot your password?",
      "loading": "Loading…",
      "genericError": "Could not sign in. Check your details and try again."
    },
    "forgot": {
      "title": "Forgot your password?",
      "intro": "Enter your e-mail address and we'll send you a link to set a new password.",
      "email": "E-mail address",
      "submit": "Send reset link",
      "done": "If that address has an account, a reset link is on its way. Check your inbox.",
      "backToLogin": "Back to sign in",
      "genericError": "Something went wrong. Please try again."
    },
    "reset": {
      "title": "Set a new password",
      "intro": "Choose a new password for your account.",
      "password": "New password",
      "passwordConfirmation": "Confirm new password",
      "submit": "Set password",
      "success": "Your password has been set. You can sign in now.",
      "toLogin": "Go to sign in",
      "invalid": "This reset link is invalid or has expired. Request a new one.",
      "genericError": "Something went wrong. Please try again.",
      "missingToken": "This page needs a valid reset link. Use the link from your e-mail."
    },
    "bcs": {
      "title": "Sign in",
      "lead": "Sign in with your BCS account.",
      "button": "Sign in with BCS",
      "failedTitle": "Sign-in failed",
      "failedBody": "Something went wrong signing in with BCS. Please try again."
    }
  },
  "imports": {
    "heading": "User imports",
    "intro": "Configured import-sources for this tenant. Each source describes one HR-export feed (file or feed) and how its columns map onto platform users + units. Sources can run on a schedule once active.",
    "sources": {
      "heading": "Import sources",
      "intro": "Each row is a configured feed — file upload, FTP folder, or API. Open one to walk through the wizard again.",
      "new": "New import source",
      "run": "Run",
      "empty": "No import sources configured yet. Click \"New import source\" to start the wizard.",
      "confirmDelete": "Delete \"{name}\"? Users and units already imported through it stay — their source-link just clears.",
      "scheduleActive": "Active",
      "scheduleOff": "Schedule disabled",
      "scheduleNoTimes": "Active but no times configured",
      "scheduleAt": "Runs daily at {times}",
      "types": {
        "csv_upload": "CSV upload",
        "csv_sftp": "FTP / SFTP",
        "api": "API"
      }
    },
    "preview": {
      "results": "Preview results",
      "downloadExcel": "Download as Excel",
      "columnMismatchBanner": "One or more files don't match the saved column mapping — fields without a column will stay empty in the import. Check the missing-columns list per slot below before continuing.",
      "missingColumns": "Missing in file",
      "extraColumns": "Extra in file (will be ignored)",
      "errorClustersHeading": "Error summary ({n} total) — click to expand",
      "summary": {
        "rows": "rows",
        "users": "Users",
        "units": "Units",
        "assignments": "Assignments",
        "errors": "Errors",
        "create": "{n} create",
        "update": "{n} update",
        "unchanged": "{n} unchanged",
        "skip": "{n} skip",
        "noFile": "No file provided for this slot."
      },
      "table": {
        "row": "#",
        "actions": "Planned actions",
        "errors": "Errors",
        "empty": "Nothing to preview — the file produced zero rows.",
        "capped": "Showing the first 50 rows + every error row. Download Excel for the full list."
      },
      "ops": {
        "create": "Create",
        "update": "Update",
        "skip_unchanged": "Unchanged",
        "skip": "Skip",
        "skip_duplicate": "Duplicate",
        "excluded": "Excluded",
        "error": "Error"
      },
      "opsShort": {
        "create": "new",
        "update": "updated",
        "unchanged": "unchanged"
      }
    },
    "run": {
      "title": "Run import",
      "intro": "Drop the source files for this configuration. Each file is matched to a configured slot by name — review the matches, fix any mismatches, and run a dry-run before committing.",
      "dropHere": "Drop CSV files here",
      "orPick": "or click to pick files",
      "filesHeading": "Files",
      "filesEmpty": "No files yet. Drop one or more CSV files above.",
      "vendorHeading": "Vendor import — no upload needed",
      "vendorBody": "Records are fetched live from the {vendor} API when you click Preview or Run. The slots configured in the mapping step are queried in order.",
      "matchedSlot": "Matched slot",
      "noMatch": "No matching slot",
      "skip": "Skip this file",
      "duplicateMatch": "Two files match the same slot — pick a different slot for one of them.",
      "missingSlots": "These configured slots have no file yet: {slots}",
      "headerToggle": "First row contains column titles",
      "headerToggleHint": "Off = treat the first line as data and use Excel-style A/B/C column letters.",
      "removeFile": "Remove",
      "runPreview": "Run preview",
      "rerun": "Re-run preview",
      "running": "Running preview…",
      "noFilesPicked": "Pick at least one CSV to run the preview.",
      "commit": "Commit import",
      "skipExisting": "{n} already linked",
      "confirmTitle": "Commit this import?",
      "confirmBody": "The dry-run is read-only; this step writes everything to the database. Re-importing the same files later is safe — already-imported rows update in place.",
      "confirmErrorsHint": "Some rows had errors in the preview. Those rows will be skipped during the commit; the rest will land normally.",
      "confirmGo": "Yes, commit",
      "successTitle": "Import committed",
      "successCount": "{n} rows changed",
      "successDone": "Back to overview",
      "remoteFilesHeading": "Files on the server",
      "slotResolveHeading": "Slot → file resolution",
      "slotResolveNoPattern": "(no match-pattern set; slot won't run)",
      "slotResolveNoMatch": "(no remote file matches)",
      "remoteFilesHint": "What's currently in {path} on the FTP server. The import job picks the latest file matching each slot's pattern.",
      "refreshRemote": "Refresh",
      "remoteEmpty": "No files in the configured remote folder yet.",
      "confirmCommit": "Apply for real"
    },
    "runs": {
      "heading": "Recent runs",
      "intro": "Every import attempt — drafts in progress, completed runs, and any failures.",
      "empty": "No runs yet for this tenant.",
      "discard": "Discard",
      "confirmDiscard": "Discard this import run? The uploaded files and parsed rows will be removed. Committed runs cannot be discarded.",
      "unnamedMapping": "(mapping deleted)",
      "rowsSummary": "+{created} new · ~{updated} updated · {failed} failed",
      "status": {
        "draft": "Draft",
        "dry_run": "Dry-run",
        "running": "Running",
        "succeeded": "Succeeded",
        "failed": "Failed",
        "cancelled": "Cancelled"
      }
    },
    "runDetail": {
      "title": "Import run",
      "source": "Source",
      "noSource": "(unknown source)",
      "mapping": "Mapping",
      "actor": "Started by",
      "noActor": "(automated)",
      "startedAt": "Started",
      "finishedAt": "Finished",
      "duration": "Duration",
      "totalsHeading": "Totals",
      "noChange": "No changes",
      "slotsHeading": "Per file",
      "errorRowsHeading": "Rows with errors",
      "errorRowsHint": "Capped at 50 rows for storage. The dry-run Excel export holds the full list.",
      "noDetail": "This run was created by an older import flow that didn't store a detailed summary.",
      "failureTitle": "Run failed — no changes were persisted",
      "failureBody": "The engine threw an error and rolled back the entire transaction. The data is in its pre-run state; you can fix the input and start a new run."
    },
    "wizard": {
      "titleNew": "New import source",
      "titleEdit": "Edit import source",
      "stepperLabel": "Wizard steps",
      "back": "Back",
      "nextStep": "Next",
      "finish": "Finish",
      "vendorDocsLink": "{vendor} documentation →",
      "steps": {
        "type": "Type & name",
        "connection": "Connection",
        "mapping": "Mapping",
        "exclusions": "Exclusions",
        "schedule": "Schedule"
      },
      "step1": {
        "heading": "Step 1 — type & name",
        "hint": "Pick how this tenant delivers data. Phase 1 ships only file upload; FTP and API follow.",
        "name": "Name",
        "nameRequired": "Give the source a recognisable name.",
        "type": "Source type",
        "types": {
          "csv_upload": "CSV upload",
          "csv_uploadHint": "The implementation team uploads the file(s) manually each time.",
          "csv_sftp": "FTP / SFTP",
          "csv_sftpHint": "Files are fetched from a remote FTP, SFTP, or FTPS server on a schedule.",
          "api": "API",
          "comingSoon": "Coming soon"
        },
        "vendorConfig": "{vendor} configuration",
        "testVendorConn": "Test connection",
        "testVendorOk": "Connection works! Tried slot \"{slot}\", fetched {n} sample record.",
        "testVendorFail": "Connection failed"
      },
      "fileBrowser": {
        "heading": "Browse server files",
        "hint": "Click a file to use it as the sample for this slot. The filename also becomes the slot's match-pattern for scheduled runs (the latest matching file is picked each run).",
        "empty": "No CSV / TXT / TSV files in the configured remote folder."
      },
      "connection": {
        "heading": "Connection details",
        "hint": "Where the import-job should fetch files from. Pick the protocol your HR system supports; the rest of the form adapts to that choice.",
        "protocol": "Protocol",
        "protocols": {
          "sftp": "SFTP (SSH)",
          "ftp": "FTP (plain)",
          "ftps_explicit": "FTPS — explicit TLS (port 21)",
          "ftps_implicit": "FTPS — implicit TLS (port 990)"
        },
        "host": "Host",
        "port": "Port",
        "portHint": "Leave blank to use the protocol default (22 for SFTP, 21 for FTP/FTPS-explicit, 990 for FTPS-implicit).",
        "remotePath": "Remote folder",
        "remotePathHint": "Where the import will look for files. The server's home directory by default.",
        "username": "Username",
        "password": "Password",
        "passwordSftpHint": "Optional for SFTP — leave empty when using key-based auth instead.",
        "passwordFtpHint": "Required for FTP / FTPS.",
        "passwordSavedPlaceholder": "(saved — leave blank to keep)",
        "privateKey": "SSH private key",
        "privateKeyHint": "Pick the .pem / .key file. We read its text content; the file itself is never uploaded as-is. Encrypted at rest.",
        "privateKeyLoaded": "Key loaded — saves on next step.",
        "privateKeyAlreadySaved": "(saved — pick a new file to replace)",
        "passphrase": "Key passphrase",
        "passphraseHint": "Only fill this in when the SSH key file is itself encrypted with a passphrase.",
        "passphraseSavedPlaceholder": "(saved — leave blank to keep)",
        "hostFingerprint": "Host fingerprint (optional)",
        "hostFingerprintHint": "SHA-256 fingerprint of the server's public host key. When set, we refuse to connect on mismatch — useful as MITM protection on long-running schedules.",
        "testButton": "Test connection",
        "testNeedsSave": "Save the connection first, then test.",
        "testSuccess": "Connected — found {n} file(s) in the remote folder.",
        "testFailure": "Connection failed"
      },
      "step2": {
        "heading": "Step 2 — mapping",
        "hint": "Per file: upload a CSV to see five sample rows, then connect each column to a platform field. A single row can produce a user PLUS one or more units at any org-level — pick the right target per column.",
        "hintVendor": "Per endpoint: fetch a sample from the vendor to see five example records, then connect each field to a platform field. A single row can produce a user PLUS one or more units at any org-level — pick the right target per column.",
        "addFile": "Add file",
        "addEndpoint": "Add endpoint",
        "empty": "No files configured yet. Click \"Add file\" to start.",
        "slotLabel": "File {n}",
        "slotName": "Slot name",
        "matchFilename": "Match filename (optional)",
        "hasHeaderRow": "First row contains column titles",
        "uploadSample": "Upload sample CSV",
        "replaceSample": "Replace sample",
        "pickServerFile": "Pick file from server",
        "replaceServerFile": "Replace server file",
        "fetchVendorSample": "Fetch sample from vendor",
        "refreshVendorSample": "Refresh vendor sample",
        "slotNameNeededForSample": "Pick a slot first so we know which vendor endpoint to query.",
        "pickVendorSlot": "— pick an endpoint —",
        "slotLabelInput": "Label (optional)",
        "slotLabelInputHint": "A friendly name shown in run reports and dashboards. Leave empty to fall back on the endpoint key.",
        "slotLabelPlaceholder": "Employees — HQ",
        "serverFileSampleNeeded": "no preview yet — pick the file again to refresh",
        "rowCount": "({n} rows)",
        "sampleHeading": "Sample preview (5 rows spread across the file)",
        "mapHeading": "Column mapping",
        "mapHint": "Pick which platform field each CSV column fills. Leave on \"Skip\" if a column shouldn't be imported. Multiple columns can target different entities (e.g. user-fields + department-fields + role-fields in the same row).",
        "mapWithoutSampleHint": "Re-upload the CSV to see the sample rows. The mapping below was saved earlier and is still applied.",
        "skipColumn": "Skip this column",
        "groupUser": "User",
        "groupOrgUnit": "Org-unit: {level}",
        "fields": {
          "external_id": "External ID",
          "name": "Full name",
          "first_name": "First name",
          "last_name": "Last name",
          "email": "Email",
          "locale": "Language",
          "status": "Status",
          "parent_external_id": "Parent (external ID)",
          "parent_external_id_named": "Parent {parent} (external ID)",
          "parent_same_level_external_id": "Parent {level} at the same level (external ID)",
          "user_unit_link": "Link to {level} (by external ID)"
        },
        "transformLabel": "Normalise",
        "transforms": {
          "none": "None (raw value)",
          "trim": "Trim whitespace",
          "digits_only": "Digits only (310.031.100.010 → 310031100010)",
          "strip_dots": "Strip dots (1.234 → 1234)",
          "lowercase": "Lowercase",
          "uppercase": "Uppercase"
        },
        "prefixLabel": "Prefix",
        "prefixPlaceholder": "literal text or a template",
        "idHint": "Identifier columns can be normalised + prefixed before matching. Prefix templates may pull other cells from the same row by wrapping the column header in curly braces. Configure both sides of a cross-file link with the same prefix + transform — otherwise the engine treats them as different ids."
      },
      "exclusions": {
        "heading": "Exclusions",
        "hint": "Users + units to skip even when they appear in the source files. Identifiers are matched against the FINAL prefixed/transformed value the engine writes (i.e. the same id you see on the platform). One entry per line.",
        "unitsLabel": "Units to exclude — {level}",
        "unitsHint": "External IDs of units at this level to skip. A user with no surviving link at this level is excluded too.",
        "unitsPlaceholder": "4587\n9999",
        "userIdsLabel": "Users to exclude — by external ID",
        "userIdsHint": "Exact match against the prefixed external_id.",
        "userIdsPlaceholder": "afas:12345",
        "emailsLabel": "Users to exclude — by email",
        "emailsHint": "Case-insensitive exact match. Use a leading * for a domain rule, e.g. *@oudbedrijf.nl",
        "emailsPlaceholder": "foo@old.nl\n*@oudbedrijf.nl"
      },
      "step3": {
        "heading": "Step 3 — schedule",
        "hint": "When this source should kick off automatically. Phase-1 sources only run when the schedule is active AND at least one time is set.",
        "uploadHint": "An upload-based source runs only when the implementation team manually uploads the file(s) and triggers the run — there's no automatic schedule. Run dry-runs and commits via the source's \"Run\" page.",
        "activate": "Source is active",
        "timesHeading": "Daily run times",
        "timesHint": "Add as many times as needed — the source runs at each one every day.",
        "noTimes": "No times yet. Click below to add one.",
        "addTime": "Add time"
      }
    },
    "editor": {
      "newTitle": "New mapping",
      "editTitle": "Edit mapping",
      "intro": "A mapping is a list of slots. Each slot points at one CSV file shape (e.g. \"users.csv\") and tells the importer which column maps to which platform field.",
      "name": "Name",
      "description": "Description",
      "slotsHeading": "Slots",
      "slotsIntro": "Add a slot per CSV file shape. Drop a sample CSV to auto-detect headers — review the matches and tweak.",
      "addUserSlot": "User slot",
      "addOrgUnitSlot": "Org-unit slot",
      "noSlots": "No slots yet. Add a user or org-unit slot to start mapping.",
      "slotLabel": "Slot {n}",
      "slotName": "Slot name",
      "targetUser": "users",
      "targetOrgUnit": "org-units",
      "targetLevelKey": "Org-level",
      "targetLevelKeyHint": "Which category of the organisation structure these rows belong to.",
      "pickLevel": "— pick a category —",
      "matchFilename": "Match filename (optional)",
      "matchFilenameHint": "Used at upload time to auto-pick this slot when the user drops a file with this name.",
      "sampleDrop": "Drop a sample CSV here, or click to browse.",
      "sampleReplace": "Replace sample CSV",
      "sampleLoaded": "{n} columns + {rows} sample row(s). Sample isn't stored — only used to suggest mappings.",
      "sampleParseError": "Could not parse the file as CSV. Try saving it as UTF-8 with comma or semicolon delimiters.",
      "columnsHeading": "Columns",
      "columnsHint": "Pick which CSV column fills each platform field. Required fields are marked with *.",
      "pickColumn": "pick a column",
      "columnHeaderPlaceholder": "Type the CSV header name",
      "field": {
        "external_id": "External ID",
        "email": "Email",
        "name": "Name",
        "locale": "Language",
        "status": "Status",
        "parent_external_id": "Parent (external ID)"
      },
      "unitAssignmentsHeading": "Unit assignments",
      "unitAssignmentsHint": "Per category: which CSV column tells the importer which unit this user belongs to.",
      "addUnitAssignment": "Add assignment",
      "via": {
        "external_id": "by external ID",
        "email": "by email",
        "name": "by name"
      },
      "previewHeading": "Sample preview ({n} row(s))",
      "strategyHeading": "Strategy",
      "strategyHint": "Use \"enrich\" when this CSV holds extra fields for users or units that another slot creates — e.g. assignments.csv with team and function for users that come from users.csv.",
      "strategy": {
        "createOrUpdate": "Create new or update existing — match on the identifying key, create when nothing matches.",
        "enrich": "Enrich existing only — match on the join column below; rows without a match become errors in the dry-run."
      },
      "joinOnHint": "Which CSV column holds the lookup key, and which platform field it should match against.",
      "joinOnFrom": "Join column (this file)",
      "joinOnVia": "Match against"
    }
  },
  "locations": {
    "heading": "Training locations",
    "intro": "Manage the training locations that can be chosen per day when planning an occurrence.",
    "new": "New training location",
    "empty": "There are no training locations yet. Add one to make it selectable when planning.",
    "editTitle": "Edit training location",
    "active": "Active",
    "inactive": "Inactive",
    "confirmDelete": "Delete training location?",
    "confirmDeleteBody": "Are you sure you want to delete “{name}”? Occurrences that used this training location keep their free-text location.",
    "cols": {
      "name": "Name",
      "city": "City",
      "capacity": "Capacity",
      "position": "Order",
      "active": "Active",
      "kind": "Kind"
    },
    "fields": {
      "name": "Name",
      "city": "City",
      "address": "Address",
      "capacity": "Capacity",
      "capacityHint": "Physical room capacity (informational). Empty = unknown.",
      "position": "Order",
      "positionHint": "Lower = higher in the list.",
      "active": "Active (selectable when planning)",
      "isExternal": "External training location (provided by another party)"
    },
    "internal": "Internal",
    "external": "External"
  },
  "externalPeople": {
    "heading": "External people",
    "intro": "Manage the external people (without an account) you can pick as a trainer when planning.",
    "new": "New external person",
    "empty": "There are no external people yet. Add one so you can pick them as a trainer when planning.",
    "editTitle": "Edit external person",
    "active": "Active",
    "inactive": "Inactive",
    "confirmDelete": "Delete external person?",
    "confirmDeleteBody": "Are you sure you want to delete “{name}”? You will no longer be able to choose this person as a trainer. Occurrences they are already the trainer of keep them as trainer.",
    "cols": {
      "name": "Name",
      "email": "Email",
      "position": "Order",
      "active": "Active",
      "company": "Company",
      "deletedAt": "Deleted on"
    },
    "tabs": {
      "current": "Current",
      "deleted": "Deleted"
    },
    "deleted": {
      "intro": "Deleted external people no longer appear in the list or the trainer picker, but their name, email and note are still stored. If an erasure request comes in, erase them here.",
      "empty": "There are no deleted external people left to erase."
    },
    "fields": {
      "name": "Name",
      "email": "Email",
      "note": "Note",
      "position": "Order",
      "positionHint": "Lower = higher in the list.",
      "active": "Active (selectable as trainer)",
      "company": "External company / educator",
      "companyHint": "Optional. Empty = independent freelancer."
    },
    "noCompany": "No company (freelancer)",
    "erase": {
      "action": "Erase",
      "actionLabel": "Erase: {name}",
      "title": "Erase external person?",
      "irreversible": "Erasing is permanent. You cannot undo this.",
      "body": "The name, email address and note of “{name}” will be permanently removed, as will these details in the audit log. The person disappears from this list and can no longer be chosen as a trainer.",
      "history": "The trainer history is kept: occurrences this person was the trainer of keep their trainer and from now on show it as “Deleted external person”.",
      "confirmLabel": "Type “{name}” to confirm",
      "confirmHint": "Type the name exactly as shown above.",
      "submit": "Erase permanently",
      "done": "“{name}” has been erased. Occurrences this person was the trainer of now show “Deleted external person”."
    }
  },
  "cancellationReasons": {
    "heading": "Cancellation reasons",
    "intro": "Manage the reasons a learner can choose from when cancelling an enrolment.",
    "new": "New reason",
    "empty": "No cancellation reasons yet. Add one to show it in the cancellation picker.",
    "editTitle": "Edit reason",
    "active": "Active",
    "inactive": "Inactive",
    "confirmDelete": "Delete reason?",
    "confirmDeleteBody": "Are you sure you want to delete “{label}”? Already-cancelled enrolments keep their reason.",
    "cols": {
      "label": "Reason",
      "position": "Order",
      "active": "Active"
    },
    "fields": {
      "label": "Reason",
      "position": "Order",
      "positionHint": "Lower = higher in the list.",
      "active": "Active (show to learners)"
    }
  },
  "externalCompanies": {
    "heading": "External companies",
    "intro": "Manage external companies (educators, suppliers). Mark a company as an educator so you can pick the educator first and then the trainer when planning.",
    "new": "New external company",
    "empty": "There are no external companies yet. Add one to start using them.",
    "editTitle": "Edit external company",
    "active": "Active",
    "inactive": "Inactive",
    "confirmDelete": "Delete external company?",
    "confirmDeleteBody": "Are you sure you want to delete \"{name}\"? Trainers linked to this company become independent freelancers again.",
    "cols": {
      "name": "Name",
      "email": "Email",
      "educator": "Educator",
      "position": "Order",
      "active": "Active",
      "origin": "Origin"
    },
    "fields": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "note": "Note",
      "position": "Order",
      "positionHint": "Lower = higher in the list.",
      "isEducator": "Is an educator (appears in the trainer picker)",
      "active": "Active (selectable when planning)"
    },
    "promote": "Move to managed list",
    "origin": {
      "admin": "Administrator",
      "request": "Request"
    },
    "suggestions": {
      "heading": "Did you perhaps mean one of these?",
      "hint": "Is the company already listed above? Then use that one instead of creating a second."
    }
  },
  "roles": {
    "heading": "Roles & permissions",
    "intro": "A role is a bundle of permissions. What someone may do comes from the role; where they may do it you choose when assigning. Roles belong to your organisation: you may edit them, duplicate them and create your own.",
    "empty": "There are no roles in this environment yet.",
    "loading": "Loading roles…",
    "loadError": "The roles could not be loaded.",
    "new": "+ New role",
    "column": {
      "role": "Role",
      "rank": "Rank",
      "origin": "Origin",
      "permissions": "Permissions",
      "assigned": "Assigned to",
      "actions": "Actions"
    },
    "permissionCount": "{held} of {total}",
    "origin": {
      "standard": "Standard",
      "standard_customised": "Standard · customised",
      "self_made": "Self-made"
    },
    "action": {
      "view": "View",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "delete": "Delete"
    },
    "rankHint": "Higher number = less authority",
    "readOnlyBanner": "This role has rank {rank}. You can only edit roles with a higher number than your own rank ({own}).",
    "readOnlyBannerNoRank": "This role has rank {rank}. You hold no role with a rank yourself, so you cannot edit roles.",
    "rankRangeHint": "From {min} to {max}. Higher number = less authority",
    "rankFixedHint": "The rank of this role is fixed",
    "rankOutOfRange": "Choose a rank from {min} to {max}.",
    "newAtoms": {
      "title_one": "A new permission has been added",
      "title_other": "{count} new permissions have been added",
      "body": "They are not on any role yet. New permissions are never switched on automatically.",
      "show": "See what is new"
    },
    "delete": {
      "title": "Delete role?",
      "body": "The role {label} will be deleted. Assignments to this role disappear with it.",
      "confirm": "Delete",
      "inUse": "This role is used by an approval flow and cannot be deleted: {flows}"
    },
    "builder": {
      "newHeading": "New role",
      "name": "Role name",
      "nameHint": "What users see. Adjustable per language; the internal key does not change with it.",
      "otherLanguages": "Other languages",
      "rank": "Rank",
      "search": "Search permissions…",
      "onlyEnabled": "Only what is enabled",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "moduleCount": "{held} of {total}",
      "summary": "What you are changing",
      "summaryOn": "Permissions on",
      "summaryRequired": "Came along as a requirement",
      "summaryUnavailable": "Not available to you",
      "summaryPeople": "People with this role",
      "lockedBy": "Comes along with: {atoms}",
      "notYours": "You do not hold this permission yourself, so you cannot grant it.",
      "dangerous": "Dangerous",
      "indispensable": "Indispensable",
      "impact_one": "This change affects {count} person.",
      "impact_other": "This change affects {count} people.",
      "save": "Save",
      "cancel": "Cancel",
      "saving": "Saving…",
      "saved": "The role has been saved.",
      "templateDiff_one": "There is {count} permission from the standard that this role does not have yet.",
      "templateDiff_other": "There are {count} permissions from the standard that this role does not have yet.",
      "addFromTemplate": "Add",
      "viewPeople_one": "View the person with this role",
      "viewPeople_other": "View the {count} people with this role"
    },
    "confirm": {
      "title": "Are you sure?",
      "added": "Permissions added",
      "removed": "Permissions removed",
      "dangerousAdded_one": "{count} of these is dangerous",
      "dangerousAdded_other": "{count} of these are dangerous",
      "impact_one": "This affects {count} person with this role.",
      "impact_other": "This affects {count} people with this role.",
      "nothing": "Nothing changes about the permissions.",
      "confirm": "Save",
      "back": "Back"
    },
    "count_one": "{count} role",
    "count_other": "{count} roles"
  },
  "roleAssignment": {
    "heading": "Assign a role to {name}",
    "userLoadError": "This user could not be loaded.",
    "intro": "What someone may do comes from the role. Where it applies you choose here.",
    "backToProfile": "← Back to the profile",
    "revoke": "Revoke",
    "includeSubtree": "Include the units below it",
    "subtreeHint": "Without this, the role applies only within the chosen unit itself.",
    "pickRole": "Choose a role",
    "pickOrgUnit": "Search for a unit",
    "current": {
      "heading": "Current roles",
      "empty": "This user does not have a role yet.",
      "loadError": "This user's roles could not be loaded."
    },
    "add": {
      "heading": "Assign a role",
      "submit": "Assign"
    },
    "fields": {
      "role": "Role",
      "scope": "Where does this role apply?",
      "orgUnit": "Organisational unit"
    },
    "blocked": {
      "rank": "you may not hand out this role",
      "delta": "you do not hold: {atoms}"
    },
    "scopeOption": {
      "tenant_wide": "The whole environment",
      "org_unit": "One organisational unit",
      "ownership": "Only what is linked to this person",
      "direct_reports": "Only the direct reports of this person"
    },
    "scopeHint": {
      "tenant_wide": "The role applies everywhere in this environment.",
      "org_unit": "The role applies within the chosen unit.",
      "ownership": "The role applies to the things this person is linked to — courses they own the content of, for instance, or occurrences they teach.",
      "direct_reports": "The role only applies to the people this person is the manager of. If no one has this person set as their manager, this person sees no one. Occurrences and the catalogue are not covered by this scope: a manager works in My team in the app."
    },
    "scope": {
      "tenant_wide": "The whole environment",
      "ownership": "Only what is linked to this person",
      "direct_reports": "Only the direct reports of this person",
      "orgUnitWithSubtree": "{unit} and everything below it",
      "orgUnitOnly": "{unit} only"
    },
    "preview": {
      "heading": "What this covers",
      "pickRoleFirst": "Choose a role first — there is nothing to calculate without one.",
      "calculating": "Calculating…",
      "failed": "The calculation failed. You can still save; you are only missing the preview.",
      "tenantWide": "This role applies everywhere in this environment.",
      "ownership": "Today that means: courses this person is responsible for · occurrences they teach · their own enrolments · their own profile.",
      "directReports": "Today that means: the users, enrolments, participations and qualifications of the people this person manages directly. Not their managers, and not occurrences or the catalogue.",
      "units_one": "{count} organisational unit",
      "units_other": "{count} organisational units",
      "people_one": "{count} person falls under this",
      "people_other": "{count} people fall under this",
      "widerThanChosen": "Note: you chose one unit, but with the units below it this covers more."
    }
  },
  "effectiveAccess": {
    "heading": "What this person may do",
    "heldCount_one": "{count} of {total} permission",
    "heldCount_other": "{count} of {total} permissions",
    "search": "Search permissions",
    "searchPlaceholder": "For example: enrolment",
    "showUnheld": "Also show what this person may not do",
    "noMatch": "No permissions match this.",
    "moduleCount": "{count} of {total}",
    "dangerous": "Dangerous",
    "notHeld": "This person does not have it.",
    "via": "via {role} — {scope} — {surface}",
    "impliedBy": "(came along with {atom})",
    "surface": {
      "app": "counts in the app",
      "manage": "counts in the admin console"
    }
  },
  "attendance": {
    "title": "Attendance",
    "myTeaching": "My sessions",
    "myTeachingEmpty": "You are not linked to any session as a teacher yet.",
    "openBadge": "Attendance open",
    "participant": "Participant",
    "day": "Day",
    "save": "Save attendance",
    "saved": "Attendance saved.",
    "noParticipants": "No participants hold a seat on this occurrence yet.",
    "noDays": "This occurrence has no days scheduled yet.",
    "status": {
      "not_recorded": "Not recorded yet",
      "present": "Present",
      "absent": "Absent",
      "excused": "Absent with reason",
      "substituted": "Substituted"
    },
    "completion": {
      "label": "Completed",
      "true": "Yes",
      "false": "No",
      "null": "Cannot say yet",
      "explainNull": "At least one day has not been recorded, so no statement can be made yet."
    },
    "loadError": "Attendance could not be loaded.",
    "saveError": "Attendance could not be saved.",
    "closeOut": {
      "action": "Close out occurrence",
      "achievedOn": "Achieved on",
      "achievedOnHint": "Today by default. Not in the future, and not before an earlier completion of the same participant on this activity.",
      "achievedOnInFuture": "The achieved-on date cannot be in the future.",
      "outcome": "Outcome",
      "outcomeFor": "Outcome for {name}",
      "skip": "Skip",
      "passed": "Passed",
      "failed": "Not passed",
      "reason": "Reason for the deviation",
      "reasonHint": "This outcome differs from what the attendance says. The reason is recorded alongside it.",
      "reasonRequired": "There is still a deviation without a reason. Fill it in before you close out.",
      "needsForce": "A day is still open, so there is nothing to derive from. Only someone with the right to force an outcome can set one here.",
      "notOpen": "Cannot be completed",
      "notOpenExplain": "This enrolment is no longer running. It is still listed because attendance was recorded for it.",
      "alreadyDone": "Already completed",
      "alreadyDoneOn": "Completed on {date}",
      "wasDeviation": "Deviated from the attendance",
      "confirmTitle": "Close out this occurrence?",
      "confirmBody": "{finalized} participants get an outcome now; {skipped} are skipped and can still be completed later.",
      "confirmTerminal": "The occurrence is set to closed afterwards. That cannot be undone.",
      "done": "Closed out. {finalized} participants completed, {skipped} skipped.",
      "error": "The occurrence could not be closed out.",
      "withdraw": "Withdraw",
      "withdrawTitle": "Withdraw the completion for {name}",
      "withdrawExplain": "The completion is kept, along with who recorded it and why it was withdrawn — it simply no longer counts anywhere. The field opens up again afterwards, so you can record a new outcome.",
      "withdrawReason": "Why are you withdrawing this?",
      "withdrawReasonHint": "Later on this is the only explanation left.",
      "withdrawError": "Withdrawing failed. Try again, or refresh the page.",
      "withdrawKind": "What applies from now on?",
      "withdrawKindPlaceholder": "Make a choice",
      "withdrawKindFromNow": "They had it — no longer from now on",
      "withdrawKindNeverValid": "The outcome was wrong — they never had it",
      "withdrawKindHint": "This decides what a report about an earlier period looks like. The first leaves that history standing; the second says an earlier report was wrong."
    },
    "cellLabel": "{name} on {day} — {status}",
    "notes": {
      "column": "Notes",
      "title": "Notes about {name}",
      "open": "Notes about {name} ({count})",
      "empty": "Nothing has been written about this participant yet.",
      "new": "New note",
      "newHint": "Only you can see this, unless you share it below.",
      "add": "Save note",
      "share": "Visible to this participant's manager",
      "sharedMarker": "shared with the manager",
      "by": "{author} — {date}",
      "unknownAuthor": "Unknown",
      "error": "The note could not be saved.",
      "delete": "Remove",
      "edit": "Edit note",
      "editAction": "Edit",
      "editedMarker": "edited"
    },
    "showCancelled": "Also show {count} cancelled participant(s)",
    "markAllPresent": "All present",
    "markAllRow": "Whole day",
    "external": {
      "column": "External test",
      "choose": "Result of the external test for {participant}",
      "placeholder": "Result",
      "record": "Record",
      "error": "The result could not be recorded.",
      "outcome": {
        "passed": "Passed",
        "not_passed": "Not passed"
      },
      "resultLabel": "Result from the external party for {participant} (percentage or grade)",
      "resultPlaceholder": "E.g. 72% or 7.5"
    }
  },
  "accessGroups": {
    "heading": "Access groups",
    "lead": "One description of who, usable in more than one place. A group describes people with rules — not with a list of names — so it still holds when someone changes department.",
    "new": "New access group",
    "empty": "There are no access groups yet. Create one as soon as you want a learning activity to be meant for a particular group.",
    "loadError": "We could not load the access groups.",
    "backToList": "Back to the overview",
    "memberCount": "{count} people",
    "showOnChart": "Show on the org chart where these people sit",
    "usedByCount": "used by {count} learning activities",
    "usage": {
      "title": "Used by {count} course(s)",
      "nowhere": "This group is not used anywhere.",
      "hidden": "And {count} course(s) you are not allowed to see.",
      "unavailable": "We could not load where this group is used."
    },
    "impact": {
      "title": "What changes?",
      "lead": "This group governs the visibility of {count} course(s). Your change applies there straight away.",
      "gaining": "{count} person(s) will gain access they do not have today.",
      "losing": "{count} person(s) will lose access they have today.",
      "nobodyChanges": "Nothing changes for anyone — the group covers the same people.",
      "totals": "{current} member(s) now, {proposed} after saving.",
      "confirm": "Save anyway",
      "unavailable": "We could not work out what this change means. Please try again."
    },
    "columns": {
      "name": "Name",
      "members": "Size",
      "usedBy": "Used by"
    },
    "fields": {
      "name": "Name",
      "description": "Description"
    },
    "branch": {
      "include": "Who belongs",
      "includeHint": "Anyone matching one of these groups belongs.",
      "exclude": "Who drops out",
      "excludeHint": "Exclusion wins: anyone matching this drops out, even if they fit above."
    },
    "addGroup": "Add group",
    "removeGroup": "Remove group",
    "noGroups": "No groups yet.",
    "allOf": "Matches everything below",
    "and": "and",
    "or": "or",
    "emptyGroupMatchesNobody": "This group has no condition yet and therefore covers nobody.",
    "addCondition": "Add condition",
    "removeCondition": "Remove",
    "chooseKind": "Choose a kind…",
    "choose": "Choose…",
    "searchPerson": "Search for a person…",
    "includeSubtree": "Including the units below",
    "unitWithSubtree": "{name} (and everything below it)",
    "unitOnly": "{name} only",
    "unknownReference": "unknown",
    "atom": {
      "org_unit": "Organisational unit",
      "user": "Person",
      "role": "Role"
    },
    "plain": {
      "label": "In plain language:",
      "nobody": "Nobody — there is not a single condition to match yet.",
      "except": "except"
    },
    "broken": {
      "badge": "Broken",
      "notice": "This group refers to something that no longer exists ({count} reference(s)). As long as that is the case the group includes nobody — not even through an exclusion rule. Remove the reference or pick something else."
    },
    "references": {
      "title": "This appears in access groups",
      "lead": "If you delete it, these groups become broken: they include nobody until you repair them.",
      "excluding": "(excludes)"
    }
  },
  "ltiProviders": {
    "heading": "LTI connections",
    "intro": "Providers you can attach to your catalogue over LTI 1.1 or 1.3. Register one here once; after that you pick it on a learning activity.",
    "new": "Add provider",
    "editTitle": "Edit provider",
    "empty": "No provider has been registered yet.",
    "active": "Active",
    "inactive": "Inactive",
    "secretSet": "Set",
    "secretUnset": "Not set",
    "confirmDelete": "Delete provider",
    "confirmDeleteBody": "Are you sure you want to delete {name}?",
    "confirmDeleteUnknown": "Trainings using this supplier are archived — they disappear from the catalogue, but results already achieved are kept.",
    "confirmDeleteNone": "No training uses this supplier.",
    "confirmDeleteAffected_one": "One training will be archived — it disappears from the catalogue, but results already achieved are kept.",
    "confirmDeleteAffected_other": "{count} trainings will be archived — they disappear from the catalogue, but results already achieved are kept.",
    "confirmDeleteRest_one": "and one more",
    "confirmDeleteRest_other": "and {count} more",
    "cols": {
      "name": "Name",
      "issuer": "Issuer",
      "clientId": "Client ID",
      "secret": "Secret",
      "active": "Active"
    },
    "fields": {
      "name": "Name",
      "issuer": "Issuer",
      "issuerHint": "The address the vendor gives as its issuer, for example https://lti.example.com",
      "clientId": "Client ID",
      "deploymentId": "Deployment ID",
      "authLoginUrl": "Login address (OIDC)",
      "redirectUris": "Redirect addresses",
      "redirectUrisHint": "One address per line. This is where the system sends the signed launch; addresses not listed here are refused.",
      "jwksUrl": "JWKS address",
      "jwksUrlHint": "This is where the system fetches the vendor's public keys. An address inside our own network is refused.",
      "supportsDeepLinking": "You can pick a course at this vendor",
      "supportsDeepLinkingHint": "With this on, a training shows a 'Pick a course' button that takes you to the vendor to choose one. We cannot tell by ourselves whether a vendor supports this — ask them if you are unsure. With it off, you enter the address of the course by hand.",
      "version": "LTI version",
      "version13": "LTI 1.3 (recommended)",
      "version11": "LTI 1.1",
      "consumerKey": "Key (consumer key)",
      "consumerKeyHint": "The key you received from the vendor. Enter the matching password below.",
      "clientSecret": "Client secret",
      "clientSecretHint": "Stored encrypted and never shown again.",
      "clientSecretKeepHint": "Leave empty to keep the stored secret. Enter something to replace it.",
      "active": "Active"
    }
  },
  "digestSettings": {
    "heading": "Summary email",
    "intro": "Notifications that do not need a message of their own are bundled into one periodic email per recipient. Set here when it leaves; which notifications ride along is a per-workflow choice.",
    "enabled": "Send the summary email",
    "enabledHint": "While this is off, bundled notifications keep waiting and nothing goes out. Nothing is deleted — switch it back on and everything still comes along.",
    "willFallSilent_one": "There is {count} notification going out through the summary email. It falls silent while this is off.",
    "willFallSilent_other": "There are {count} notifications going out through the summary email. They fall silent while this is off.",
    "frequencyLabel": "How often",
    "frequency": {
      "daily": "Every day",
      "weekly": "Every week"
    },
    "weekdayLabel": "On which day",
    "timeLabel": "At what time",
    "timeHint": "In your organisation’s timezone. The mail leaves in fifteen-minute blocks, so pick a time on :00, :15, :30 or :45.",
    "saved": "The settings have been saved.",
    "saveFailed": "Saving failed."
  },
  "combobox": {
    "noResults": "No results.",
    "loading": "Loading…"
  },
  "aurora": {
    "modalClose": "Close",
    "alertDismiss": "Dismiss",
    "passwordShow": "Show password",
    "passwordHide": "Hide password",
    "comboboxRemove": "Remove {label}"
  },
  "returnTrail": {
    "afterSave": {
      "form": "After saving, this is added at the end of form ‘{title}’ and you return there.",
      "form_test": "After saving, this is added at the end of test ‘{title}’ and you return there.",
      "category": "After saving, this is added at the end of category ‘{title}’ and you return there."
    },
    "fromParent": {
      "form": "You are working here from form ‘{title}’.",
      "form_test": "You are working here from test ‘{title}’.",
      "category": "You are working here from category ‘{title}’."
    },
    "back": {
      "form": "Back to the form",
      "form_test": "Back to the test",
      "category": "Back to the category"
    },
    "cancel": {
      "form": "Cancel, back to the form",
      "form_test": "Cancel, back to the test",
      "category": "Cancel, back to the category"
    },
    "saveAndReturn": {
      "form": "Save and return to the form",
      "form_test": "Save and back to the test",
      "category": "Save and return to the category"
    },
    "discard": {
      "title": "Discard changes?",
      "body": "What you entered here has not been saved and will be lost if you go back.",
      "keep": "Keep editing",
      "confirm": "Discard and go back"
    },
    "added": {
      "category": "The new category was created and added at the end of the form.",
      "category_test": "The new category has been created and added at the end of the test.",
      "question": "The new question was created and added at the end of the category."
    },
    "attachFailed": {
      "category": "The new category was saved, but could not be added to the form. Adjust it and save again to retry, or go back with the button above.",
      "category_test": "The new category was saved but could not be added to the test. Adjust it and save again to retry, or go back with the button above.",
      "question": "The new question was saved, but could not be added to the category. Adjust it and save again to retry, or go back with the button above."
    }
  },
  "answerReadout": {
    "notAnswered": "Not answered",
    "scale": "{value} of {max}",
    "scaleLabelled": "{value} of {max}: {label}",
    "other": "Other: {text}"
  },
  "testGrading": {
    "retry": "Try again",
    "outcome": {
      "passed": "Passed",
      "not_passed": "Not passed"
    },
    "queue": {
      "title": "Grading",
      "description": "Submitted tests waiting for you, per session. Expand a session to see its tests.",
      "loading": "Loading tests…",
      "loadError": "The tests waiting to be graded could not be loaded.",
      "emptyTitle": "Nothing to grade",
      "emptyBody": "As soon as a participant submits a test you are the grader of, it will appear here.",
      "noTitle": "Unnamed training",
      "noDate": "No date",
      "count_one": "{count} test",
      "count_other": "{count} tests",
      "column": {
        "training": "Training",
        "date": "Date",
        "count": "To grade"
      },
      "responsesOf": "Tests of {title}",
      "unknownRespondent": "Unknown participant",
      "submittedAt": "Submitted on {date}",
      "grade": "Grade",
      "gradeNamed": "Grade the test of {name}",
      "expand": "Show the tests",
      "collapse": "Hide the tests"
    },
    "grade": {
      "back": "Back to grading",
      "title": "Test of {name}",
      "loading": "Loading test…",
      "loadError": "The test could not be loaded.",
      "notFoundTitle": "This test is not available to you",
      "notFoundBody": "It does not exist, has not been submitted yet, or you are not a grader of this test.",
      "refused": "You cannot grade this test.",
      "answers": "Answers",
      "answerComment": "Comment on this answer (optional)",
      "answerCommentHintVisible": "The participant sees this comment with their answer.",
      "answerCommentHintHidden": "Showing answers is off: this comment stays with you and the administrators.",
      "answerCommentGiven": "Grader comment",
      "respondentRemarks": "Participant remarks",
      "judgement": "Judgement",
      "outcome": "Outcome",
      "score": "Score (optional)",
      "scoreHint": "For information only: the score decides nothing. You choose the outcome yourself.",
      "scoreInvalid": "Enter a number, zero or higher.",
      "scoreGiven": "Score: {score} (for information only)",
      "comment": "Comment on the test (optional)",
      "commentHint": "The participant always sees this comment with their result.",
      "save": "Save grading",
      "saving": "Saving…",
      "saved": "The test of {name} has been graded.",
      "conflict": "Another grader beat you to it: this test has been graded in the meantime. What you entered was not saved. The judgement as it stands now is shown below.",
      "saveError": "Saving failed. Check your connection and try again.",
      "gradedBy": "Graded by {name} on {date}",
      "answersVisibleToRespondent": "The participant sees this result, with their answers and the comments per answer.",
      "answersHiddenFromRespondent": "The participant sees the outcome, the score and the general comment, but not their answers or the comments per answer."
    }
  },
  "testResult": {
    "title": "Result of {title}",
    "loading": "Loading result…",
    "loadError": "The result could not be loaded.",
    "retry": "Try again",
    "closedTitle": "This result is not available",
    "closedBody": "The test has not been graded yet.",
    "gradedOn": "Graded on {date}",
    "outcome": "Outcome",
    "score": "Score: {score}",
    "scoreNote": "(for information only)",
    "graderComment": "Grader comment",
    "answers": "Your answers",
    "answerComment": "Grader comment",
    "answersHidden": "Your answers and the comments per question are not shown for this test."
  },
  "questionnaireResults": {
    "anonymous": "Anonymous",
    "retry": "Try again",
    "backToList": "Back to results",
    "notFoundTitle": "Not found",
    "notFoundBody": "This report does not exist or you cannot read it.",
    "responses_one": "{count} response",
    "responses_other": "{count} responses",
    "suppressed": "Too few responses — {count} of at least {floor}",
    "suppressedWhy": "Below that minimum we show no outcome, not even an average. That way nobody can be identified afterwards.",
    "list": {
      "title": "Results",
      "description": "The outcome of the evaluations of your sessions. An outcome only appears once enough people have responded.",
      "loading": "Loading results…",
      "loadError": "The sessions could not be loaded.",
      "emptyTitle": "No sessions with evaluations yet",
      "emptyBody": "As soon as one of your sessions has an evaluation, it will appear here.",
      "noTitle": "Untitled",
      "noDate": "No date",
      "noRules": "No evaluations",
      "column": {
        "training": "Training",
        "date": "Date",
        "rules": "Evaluations"
      }
    },
    "occurrence": {
      "loading": "Loading report…",
      "loadError": "The report could not be loaded.",
      "emptyTitle": "No evaluations on this session",
      "emptyBody": "No evaluation runs for this session, so there is nothing to read."
    },
    "rule": {
      "loading": "Loading report…",
      "loadError": "The report could not be loaded.",
      "subject": "{kind} · {training}",
      "kind": {
        "training": "Training",
        "elearning": "E-learning",
        "survey": "Stand-alone survey"
      },
      "totalTitle": "Total across all sessions",
      "totalComplementWhy": "The total stays hidden while, next to what you can read per session, it would reveal a small session. It appears as soon as that is no longer possible.",
      "textsPerOccurrence": "The texts people wrote can be read per session.",
      "byOccurrenceTitle": "Per session",
      "byOccurrenceHint": "Only counts are shown here. The outcome of a session is in its own report.",
      "column": {
        "occurrence": "Session",
        "counted": "Responses",
        "status": "Report"
      },
      "occurrenceGone": "Session no longer available",
      "statusDisclosed": "Enough responses"
    },
    "question": {
      "untitled": "Question without text",
      "answers_one": "{count} answer",
      "answers_other": "{count} answers",
      "mean": "Average: {mean} (scale {min} to {max})",
      "distributionOf": "Distribution of the answers to: {prompt}",
      "yes": "Yes",
      "no": "No",
      "other": "Other, namely",
      "multipleHint": "More than one answer could be chosen, so the shares do not add up to 100%.",
      "divergedTitle": "This question was worded differently",
      "divergedBody": "The wording of this question changed over time. The answers have been added together. This is how the question was asked:",
      "formulation": "{prompt} — {count}×",
      "notAggregated": "This question was counted but not added up: its type differs between forms or cannot be reported yet."
    },
    "table": {
      "value": "Value",
      "answer": "Answer",
      "count": "Count",
      "share": "Share",
      "shareOf": "Share"
    },
    "remarks": {
      "title": "Remarks"
    },
    "freeText": {
      "show": "Show the answers to {label} ({count})",
      "hide": "Hide the answers to {label}",
      "loading": "Loading answers…",
      "loadError": "The answers could not be loaded.",
      "order": "The answers are shown without a name and in random order.",
      "listLabel": "Answers to {label}",
      "pagerLabel": "Pages of answers to {label}",
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {page} of {last}"
    }
  },
  "qualifications": {
    "heading": "Qualifications",
    "intro": "The qualifications your organisation keeps track of, such as first aid, VCA or a forklift licence. A training can grant one: whoever completes it holds it from then on.",
    "tabs": {
      "definitions": "Definitions",
      "held": "Who holds what"
    },
    "new": "New qualification",
    "newTitle": "New qualification",
    "editTitle": "Edit qualification",
    "count_one": "{count} qualification",
    "count_other": "{count} qualifications",
    "empty": "No qualifications yet. Create the first one to link it to a training.",
    "emptyFiltered": "No qualifications match these filters.",
    "loadError": "The qualifications could not be loaded.",
    "filter": {
      "status": "Show",
      "active": "Active",
      "archived": "Archived",
      "all": "All"
    },
    "cols": {
      "name": "Name",
      "validity": "Validity",
      "held": "Held by",
      "grants": "Trainings"
    },
    "duration": {
      "none": "Does not expire",
      "day_one": "{count} day",
      "day_other": "{count} days",
      "month_one": "{count} month",
      "month_other": "{count} months",
      "year_one": "{count} year",
      "year_other": "{count} years"
    },
    "unit": {
      "day": "Days",
      "month": "Months",
      "year": "Years"
    },
    "status": {
      "archived": "Archived"
    },
    "fields": {
      "name": "Name",
      "description": "Description",
      "expires": "This qualification expires",
      "amount": "Period",
      "unit": "Unit",
      "unitPlaceholder": "Choose a unit",
      "durationHint": "How long the qualification stays valid after it is granted.",
      "durationChangeHint": "Changing this does not touch existing holders: their end date was fixed when they received it.",
      "noEndHint": "This qualification has no end date. Holders keep it until someone withdraws it.",
      "active": "Active",
      "activeHint": "An archived qualification can no longer be chosen or granted. Whoever holds it, keeps it."
    },
    "actions": {
      "editNamed": "Edit {name}",
      "archive": "Archive",
      "archiveNamed": "Archive {name}",
      "restore": "Restore",
      "restoreNamed": "Restore {name}"
    },
    "archiveConfirm": {
      "title": "Archive this qualification?",
      "body": "{name} can no longer be chosen or linked to a training. You can restore it later.",
      "bodyHeld_one": "{name} is held by {count} person. They keep it, but it can no longer be chosen or linked to a training. You can restore it later.",
      "bodyHeld_other": "{name} is held by {count} people. They keep it, but it can no longer be chosen or linked to a training. You can restore it later."
    },
    "discard": {
      "title": "Discard changes?",
      "body": "You have unsaved changes. If you close now, they are lost.",
      "confirm": "Discard",
      "keep": "Keep editing"
    },
    "notice": {
      "created": "Qualification created.",
      "updated": "Qualification saved.",
      "archived": "{name} archived.",
      "restored": "{name} restored."
    },
    "grantedBy": {
      "title": "Granted by",
      "intro": "The trainings that grant this qualification. You link a training on its own screen.",
      "empty": "No training grants this qualification yet.",
      "loadError": "The trainings could not be loaded.",
      "noEnd": "no end date",
      "own": "own period: {duration}",
      "inherited": "default period: {duration}"
    }
  },
  "heldQualifications": {
    "heading": "Who holds what",
    "intro": "Every qualification someone holds, with its validity and where it comes from. Filter on who, what and when it expires.",
    "count_one": "{count} result",
    "count_other": "{count} results",
    "empty": "Nobody holds a qualification yet. Rows appear here when someone completes a training that grants one.",
    "emptyFiltered": "No rows match these filters.",
    "loadError": "The held qualifications could not be loaded.",
    "noEnd": "no end date",
    "daysLeft_one": "{count} day left",
    "daysLeft_other": "{count} days left",
    "renewalStopped": "Renewal stopped",
    "note": "Note (optional)",
    "filter": {
      "qualification": "Qualification",
      "person": "Person",
      "personPlaceholder": "Search for a person",
      "status": "Status",
      "expiring": "Expires",
      "any": "Any time",
      "expiringOption": "Within {days} days",
      "all": "All",
      "archivedName": "{name} (archived)",
      "clear": "Clear filters"
    },
    "status": {
      "valid": "Valid",
      "not_yet_valid": "Not yet valid",
      "expired": "Expired",
      "ended_by_choice": "Ended, not renewed",
      "superseded": "Replaced",
      "corrected": "Corrected",
      "withdrawn": "Withdrawn",
      "never_valid": "Never valid",
      "active": "Active (valid or upcoming)",
      "ended": "Ended (any reason)"
    },
    "origin": {
      "completion": "Training completed",
      "external_training": "External training",
      "self_declared": "Self-declared",
      "administrative": "Registered by an administrator"
    },
    "evidence": {
      "trusted": "Recorded by the system",
      "verifiable": "Verifiable evidence",
      "declaration": "Declaration, unverified"
    },
    "sourceType": {
      "completion_record": "Completion",
      "import_run": "Import run",
      "migration_run": "Migration run"
    },
    "endReason": {
      "superseded": "Replaced by a newer one",
      "corrected": "Corrected",
      "withdrawn_from_now": "Withdrawn from now on",
      "never_valid": "Declared never valid"
    },
    "cols": {
      "person": "Person",
      "qualification": "Qualification",
      "window": "Valid",
      "origin": "Origin",
      "ground": "Ground",
      "status": "Status"
    },
    "detail": {
      "window": "Validity",
      "origin": "Origin",
      "evidence": "Ground",
      "source": "Source",
      "noSource": "No source event (registered by hand)",
      "run": "Run",
      "ended": "Ended",
      "renewalStopped": "Renewal stopped",
      "recorded": "Recorded on"
    },
    "actions": {
      "withdraw": "Withdraw",
      "withdrawNamed": "Withdraw {name}",
      "stopRenewal": "Stop renewal",
      "stopRenewalNamed": "Stop renewal of {name}",
      "resumeRenewal": "Resume renewal",
      "resumeRenewalNamed": "Resume renewal of {name}"
    },
    "withdraw": {
      "title": "Withdraw this qualification?",
      "body": "{name}: this ends the qualification and cannot be undone.",
      "reason": "Reason",
      "reasonPlaceholder": "Choose a reason",
      "reasonRequired": "Choose a reason for the withdrawal.",
      "reasons": {
        "withdrawn_from_now": "From now on",
        "never_valid": "Never valid"
      },
      "reasonHints": {
        "withdrawn_from_now": "The person held it until now. Reports about the past still count it.",
        "never_valid": "It should never have been granted. Reports about the past no longer count it."
      },
      "confirm": "Withdraw"
    },
    "stopRenewal": {
      "title": "Stop renewal?",
      "body": "{name}: the qualification is not renewed. Once it runs out it shows as ended, not expired. You can undo this while it is still valid.",
      "confirm": "Stop renewal"
    },
    "resumeRenewal": {
      "title": "Resume renewal?",
      "body": "{name}: the qualification is renewable again.",
      "confirm": "Resume renewal"
    },
    "notice": {
      "withdrawn": "{name} withdrawn.",
      "stopped": "Renewal of {name} stopped.",
      "stoppedMany": "Renewal of {name} stopped on {count} rows.",
      "resumed": "Renewal of {name} resumed.",
      "resumedMany": "Renewal of {name} resumed on {count} rows."
    }
  },
  "activityQualifications": {
    "title": "Grants qualification",
    "intro": "Whoever completes this training holds these qualifications from then on.",
    "loadError": "The linked qualifications could not be loaded.",
    "empty": "This training grants no qualification.",
    "emptyNew": "No qualification chosen yet. The link is made when you save the activity.",
    "notForComposition": "A bundle or learning path does not grant a qualification itself; choose a single activity to link one.",
    "noEnd": "no end date",
    "own": "own period: {duration}",
    "inherited": "default period: {duration}",
    "add": "Link a qualification",
    "addTitle": "Link a qualification",
    "editTitle": "Edit validity",
    "qualification": "Qualification",
    "qualificationPlaceholder": "Choose a qualification",
    "qualificationRequired": "Choose a qualification.",
    "ownDurationHint": "Leave empty to use the default period of the qualification.",
    "ownDurationHintWithDefault": "Leave empty to use the default: {duration}.",
    "noEndHint": "This qualification has no end date, so there is no period to set.",
    "editNamed": "Edit {name}",
    "removeNamed": "Remove {name}",
    "remove": "Remove",
    "removeConfirm": {
      "title": "Unlink this qualification?",
      "body": "{name} is no longer granted by this training. People who already hold it keep it."
    },
    "notice": {
      "added": "Qualification linked.",
      "updated": "Validity saved.",
      "removed": "{name} unlinked."
    }
  },
  "externalRequestTypes": {
    "list": {
      "heading": "External training request types",
      "intro": "A type is for example training or coaching, with its own form, cost lines and chain. There is no default type: set one up first and then switch it on. Without a live version employees have no entry point anywhere.",
      "new": "New type",
      "empty": "There are no types yet. Create one to allow requests for external training.",
      "on": "On (v{number})",
      "off": "Off",
      "open": "Open",
      "cols": {
        "name": "Type",
        "status": "Status",
        "versions": "Versions"
      },
      "fields": {
        "name": "Name",
        "key": "Key",
        "keyHint": "Lower-case letters, digits and _. You cannot change the key afterwards."
      }
    },
    "detail": {
      "empty": "This type has no versions yet.",
      "cols": {
        "version": "Version",
        "status": "Status",
        "liveFrom": "Live from"
      },
      "edit": "Edit",
      "view": "View",
      "goLive": "Go live",
      "schedule": "Schedule",
      "unschedule": "Undo scheduling",
      "discard": "Discard",
      "newConceptFrom": "New draft from this",
      "newConcept": "New empty draft",
      "conceptExists": "There is already a draft; there can be only one at a time.",
      "notValid": "This version cannot go live yet. This has to be right first:",
      "isOn": "The type is on: employees can request it.",
      "isOff": "The type is off: there is no live version, so employees have no entry point.",
      "rename": "Rename",
      "scheduleTitle": "Schedule version {number}",
      "liveFrom": "Live from",
      "liveFromHint": "Time zone of the environment ({timezone}). At that moment the version is checked again; if something no longer holds, the current version stays live.",
      "discardTitle": "Discard draft?",
      "discardBody": "Version {number} will be removed. A live or closed version is always kept.",
      "catalogTile": {
        "heading": "Tile in the catalogue",
        "label": "Show a tile in the catalogue",
        "hintOn": "Employees who may submit requests see a tile in the catalogue that lets them request this type.",
        "hintOff": "The tile only appears once this type is on (has a live version)."
      }
    },
    "status": {
      "concept": "Draft",
      "scheduled": "Scheduled",
      "live": "Live",
      "phasing_out": "Phasing out",
      "archived": "Archived",
      "failed": "Failed"
    },
    "transition": {
      "version_not_editable": "Only a draft can be changed. Make a new draft from this version.",
      "version_wrong_state": "This is not possible for a version in this state.",
      "concept_exists": "There is already a draft for this type. Finish it or discard it.",
      "schedule_exists": "A switch is already scheduled for this type.",
      "moment_not_in_future": "Choose a moment in the future."
    },
    "role": {
      "title": "Title",
      "provider": "Provider",
      "cost": "Cost",
      "period": "Period",
      "qualification": "Qualification"
    },
    "phase": {
      "request": "Request",
      "agreement": "Agreement",
      "verification": "Verification",
      "change": "Change"
    },
    "cost": {
      "kind": {
        "fixed": "Fixed amount",
        "unit": "Price × quantity"
      },
      "vat": {
        "none": "VAT unknown",
        "excl": "Amount excl. VAT",
        "incl": "Amount incl. VAT"
      },
      "empty": "No cost lines yet. Add at least one: the total of the lines is the Cost role.",
      "key": "Key",
      "type": "Type",
      "vatLabel": "VAT",
      "rate": "Rate",
      "remove": "Remove",
      "add": "Add cost line"
    },
    "preview": {
      "heading": "Live preview",
      "language": "Language of the preview",
      "empty": "Add fields to see the form.",
      "noCostLines": "Add a cost line to see the costs.",
      "price": "{name} — price",
      "quantity": "{name} — quantity",
      "totalExcl": "Total excl. VAT",
      "totalIncl": "Total incl. VAT",
      "vatUnknown": "unknown (not every line knows its VAT)",
      "firstDay": "first day",
      "lastDay": "last day",
      "allDays": "The employee enters every day of the training here.",
      "providerPlaceholder": "Choose or search a provider…",
      "qualificationPlaceholder": "Choose a qualification…"
    },
    "editor": {
      "heading": "Version {number}",
      "introConcept": "This draft can be edited. Going live and scheduling check it first.",
      "introReadOnly": "This version is immutable. To change it, make a new draft from this version.",
      "back": "Back to the type",
      "check": "Check",
      "checkOk": "Everything holds: this version can go live.",
      "checkMissing_one": "There is still {count} thing that does not hold:",
      "checkMissing_other": "There are still {count} things that do not hold:",
      "checkStale": "You changed something since the check. Save and check again.",
      "saved": "The draft has been saved.",
      "saveFailed": "The draft could not be saved.",
      "failed": "The switch to this version did not go ahead; the old version stayed live. This no longer held at that moment:",
      "settings": "Settings",
      "settingsHint": "Costs are read on the chosen basis, so nothing is ever converted. The rules with conditions per phase come with the process graph; here you choose the chain for the request.",
      "costBasis": "Read costs on the basis of",
      "basis": {
        "excl": "Total excl. VAT",
        "incl": "Total incl. VAT"
      },
      "periodMode": "Period of the training",
      "period": {
        "all_days": "All days",
        "first_last": "First and last day",
        "none": "No date"
      },
      "requestChain": "Approval chain for the request",
      "noChain": "No chain chosen yet",
      "learningForm": "Learning form of the training",
      "learningFormHelp": "An approved request becomes an external training in the employee's name, with this learning form. The list comes from the learning forms in the catalogue settings.",
      "learningFormDefault": "Default ({name})",
      "agreementTemplate": "Agreement",
      "noAgreement": "No agreement",
      "agreementUnavailable": "Available once agreements can be issued",
      "moreRules": "This version has more than one rule for the request (for example from an import). They stay as they are; edit them with the process graph.",
      "form": "Form",
      "formHint": "Title, provider and cost are always required. Give every field a name in every language of the environment.",
      "costLines": "Cost lines",
      "costHint": "The platform calculates the total and stores the lines and the total together as a snapshot on the request."
    },
    "violation": {
      "cost_basis_missing": "Choose the basis on which costs are read (excl. or incl. VAT).",
      "period_mode_missing": "Choose what the type asks for in dates.",
      "learning_form_unknown": "The chosen learning form \"{key}\" is no longer one of the learning forms of this environment. Choose another one or leave it empty.",
      "field_key_invalid": "The key \"{key}\" is not valid: use lower-case letters, digits and _, starting with a letter.",
      "field_key_duplicate": "The key \"{key}\" is on two fields.",
      "field_type_invalid": "The field \"{key}\" has an unknown type.",
      "field_label_missing": "The field \"{key}\" has no label in {locale}.",
      "role_duplicate": "The role {role} is on more than one field.",
      "role_type_invalid": "The field \"{key}\" has a type that does not fit the role {role}.",
      "role_must_be_required": "The field \"{key}\" with the role {role} must be required.",
      "role_missing": "Link a field to the role {role}.",
      "period_role_without_period": "There is a field with the Period role, but the type does not ask for a date.",
      "cost_lines_missing": "Add at least one cost line.",
      "cost_line_key_invalid": "The key \"{key}\" of a cost line is not valid.",
      "cost_line_key_duplicate": "The key \"{key}\" is on two cost lines.",
      "cost_line_kind_invalid": "The cost line \"{key}\" has an unknown type.",
      "cost_line_label_missing": "The cost line \"{key}\" has no name in {locale}.",
      "cost_line_vat_invalid": "The cost line \"{key}\" has an unknown VAT setting.",
      "cost_line_vat_rate_unknown": "The cost line \"{key}\" has a VAT rate that is not in the list.",
      "cost_basis_unavailable": "The type reads costs incl. VAT, but the cost line \"{key}\" does not know its VAT.",
      "phase_request_missing": "Choose an approval chain for the request.",
      "phase_unknown": "The phase \"{phase}\" does not exist.",
      "rules_no_catch_all": "The rules for the {phase} phase do not end with a rule without a condition.",
      "rules_catch_all_not_last": "Rule {index} for the {phase} phase has no condition, so the rules after it are never reached.",
      "rule_chain_missing": "Rule {index} for the {phase} phase does not point to a chain.",
      "chain_not_found": "The chain for the {phase} phase no longer exists.",
      "chain_empty": "The chain for the {phase} phase has no steps.",
      "chain_unresolvable": "Nobody can decide in the chain for the {phase} phase: the chosen role or person does not exist or is empty.",
      "chain_all_of": "The chain for the {phase} phase has a step in which everyone must decide. An external training request only supports \"one of them\".",
      "agreement_not_available": "Rule {index} for the {phase} phase chooses an agreement. Issuing an agreement is not available yet; choose \"no agreement\" for now.",
      "rule_step_keys_invalid": "Rule {index} for the {phase} phase has an invalid or duplicate step key.",
      "mail_template_missing": "The email \"{slug}\" for \"{event}\" does not exist."
    }
  },
  "themes": {
    "heading": "Categories",
    "intro": "Manage the categories you pick from on an activity and that the catalogue filters on. A category can sit under a top-level category as a subcategory; you can fill in the name per language.",
    "new": "New category",
    "editTitle": "Edit category",
    "empty": "There are no categories yet. Add the first one to be able to pick it on an activity.",
    "fields": {
      "name": "Name ({language})",
      "parent": "Sits under",
      "noParent": "None (top-level category)",
      "parentHint": "Choose a top-level category to place this category under it.",
      "parentLocked": "This category has subcategories of its own, so it stays a top-level category."
    },
    "cols": {
      "name": "Category",
      "usage": "Activities",
      "actions": "Actions"
    },
    "moveUp": "Move {name} up",
    "moveDown": "Move {name} down",
    "merge": "Merge",
    "mergeTitle": "Merge category",
    "mergeBody": "The {count} activity(ies) of “{name}” move to the category you choose. “{name}” is removed afterwards.",
    "mergeInto": "Merge into",
    "mergeChoose": "Choose a category",
    "deleteBlockedInUse": "This category is in use. Merge it into another category.",
    "deleteBlockedChildren": "This category has subcategories.",
    "confirmDelete": "Delete category?",
    "confirmDeleteBody": "“{name}” will be deleted. This cannot be undone."
  },
  "media": {
    "heading": "Media library",
    "intro": "The images of this environment, for use on catalogue items. Each image shows how often it is used, whether alt text is still missing, and whether a newer version is waiting at its source. Click an image for everything you can do with it. PNG and JPG only; several at a time is fine.",
    "add": "Add images",
    "addError": "Adding failed. Please try again.",
    "removeError": "Removing failed. Please try again.",
    "loadError": "The library could not be loaded.",
    "usageError": "Could not load where this image is used.",
    "empty": "There are no images in the library yet.",
    "inUse": "In use",
    "notInUse": "Not in use",
    "altMissing": "No alt text",
    "editAlt": "Alt text",
    "saveAlt": "Save alt text",
    "altError": "The alt text could not be saved.",
    "altFor": "Alt text ({language})",
    "altHint": "Describe what the image shows, for people who cannot see it. Leave a language empty if you do not use it.",
    "remove": "Remove",
    "removeFor": "Remove {name}",
    "confirmRemove": "Are you sure? The image disappears from the library.",
    "pagination": "Pagination",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {page} of {total}",
    "defaultHeading": "Default image",
    "defaultNone": "No default set yet",
    "defaultElsewhere": "Set — on another page",
    "defaultClear": "Clear default",
    "defaultBadge": "Default",
    "defaultError": "The default image could not be set.",
    "setDefaultFor": "Set {name} as the default",
    "deliveredHeading": "Provided by BCS",
    "deliveredIntro": "These images come from BCS and are the same for everyone. You can remove them from your library and give them your own alt text; the file itself stays with BCS.",
    "removeDelivered": "Remove from my library",
    "removeDeliveredFor": "Remove {name} from my library",
    "confirmRemoveDelivered": "This image disappears from your library. The file itself stays, and BCS can make it available again.",
    "addFromUrl": "From an address",
    "addFromPexels": "Search Pexels",
    "fromUrlTitle": "Add an image from an address",
    "fromUrlField": "Address of the image",
    "fromUrlHint": "We download the image and keep it here. If it changes at the source later, one button fetches it again.",
    "fromUrlSubmit": "Fetch and add",
    "fromUrlError": "The image could not be fetched.",
    "creditField": "Credit (optional)",
    "creditHint": "The name to show with the image, if the source asks for it.",
    "creditBy": "Photo: {name}",
    "fetching": "Fetching…",
    "sourceChanged": "Source changed",
    "sourceCheck": "Check the source",
    "sourceChecking": "Checking…",
    "pexelsTitle": "Search Pexels",
    "pexelsField": "What are you looking for?",
    "pexelsSearch": "Search",
    "pexelsHint": "Pexels works best with English words. The photographer is stored with the image — Pexels requires that.",
    "pexelsImport": "Add to library",
    "pexelsPartial": "{count} images could not be fetched:",
    "pexelsImportCount": "Import ({count})",
    "pexelsEmpty": "No results for this word.",
    "pexelsError": "Searching Pexels did not work.",
    "pexelsImportError": "The image could not be added.",
    "pickerTitle": "Choose an image",
    "pickerSearch": "Search by file name",
    "pickerConfirm": "Use this one",
    "pickerAdd": "Not there?",
    "pickerNoMatch": "No image with that word in its name.",
    "pickOrUpload": "Choose or upload",
    "uploadFromComputer": "Upload from your computer",
    "uploadField": "Upload image",
    "uploadError": "The image could not be uploaded.",
    "packagePickerTitle": "Upload e-learning file",
    "packageField": "Zip file",
    "packageUse": "Use this file",
    "shareWithLibrary": "Also keep it in the media library",
    "shareWithLibraryHint": "Leave this off if the image belongs to this item only — then it disappears with it.",
    "detailTitle": "Image",
    "openDetail": "Open {name}",
    "dimensions": "Dimensions",
    "pixels": "{width} × {height} pixels",
    "fileSize": "File size",
    "fileType": "Type",
    "credit": "Credit",
    "source": "Source",
    "inUseCount": "Used {count}×",
    "setDefault": "Set as the default",
    "actionError": "The change did not go through. Please try again.",
    "dropHere": "Drag images here or click to choose",
    "dropHint": "PNG or JPG, several at a time",
    "uploading": "Uploading…",
    "uploadingPercent": "Uploading… {percent}%",
    "sourceUnchanged": "The source is unchanged.",
    "sourceChangedHint": "This is what the source holds now. Take it over and this becomes the image — everywhere it is used.",
    "sourcePreviewAlt": "The image as it currently stands at the source",
    "sourcePreviewGone": "The prepared preview is no longer there. Check the source again to see what it holds now.",
    "sourceUpdate": "Update",
    "sourceCheckAgain": "Check again",
    "usage": {
      "activity_image": "Image of a learning activity",
      "activity_source": "Source of a learning activity",
      "occurrence_image": "Image of an occurrence",
      "elearning_package": "E-learning package",
      "external_request_attachment": "Attachment on a request",
      "message_attachment": "Attachment on a message",
      "tenant_default": "Default image of this environment",
      "user_avatar": "Profile photo of a user",
      "certificate": "Issued certificate",
      "document_template": "Logo of a document template",
      "document_settings": "Environment logo on certificates"
    }
  },
  "studyLoad": {
    "heading": "Study load",
    "durationLabel": "Duration of the training",
    "durationDeviation": "Different duration",
    "durationChoose": "Choose a duration",
    "durationCustom": "Other…",
    "studyLoadLabel": "Total study load",
    "hours": "Hours",
    "minutes": "Minutes",
    "hoursShort": "h",
    "minutesShort": "min",
    "inherited": "Default of the activity: {value}",
    "useInherited": "Back to the default of the activity ({value})",
    "inheritedFromPlanning": "From the schedule: {value}",
    "useInheritedFromPlanning": "Back to the duration from the schedule ({value})",
    "belowDuration": "The total study load is shorter than the duration. Please check that this is right."
  },
  "catalogs": {
    "references": {
      "deleteTitle": "{name} is still in use",
      "deleteBody": "If you delete this catalogue, the following happens:",
      "deleteConfirm": "Delete anyway",
      "slugTitle": "Texts link to the current address",
      "slugBody": "If you change the address, these links to /catalog/{slug} will no longer lead anywhere:",
      "slugConfirm": "Change address anyway",
      "isStart": "Whoever opens /catalog lands here now. That becomes the next catalogue in the menu.",
      "inMenu": "It disappears from the menu.",
      "catalog": {
        "include": "Catalogue ‘{name}’ includes it. That catalogue becomes empty, with a warning.",
        "exclude": "Catalogue ‘{name}’ excludes it. That catalogue becomes empty, with a warning."
      },
      "activityLink": "The description of training ‘{title}’ links to it.",
      "catalogText": "The description of catalogue ‘{name}’ links to it.",
      "text": "The custom text ‘{key}’ ({locale}) links to it.",
      "mailTemplate": "Mail: {name} ({locales}) links to it.",
      "outside": "Links outside the system, such as bookmarks or an intranet page, are not visible to us.",
      "unknown": "We could not check where this catalogue is used. Please try again."
    },
    "new": "Add catalogue",
    "newTitle": "New catalogue",
    "untitled": "Untitled catalogue",
    "backToList": "Back to the list",
    "emptyAll": "There is no catalogue at all.",
    "emptyAllHint": "Without a catalogue, learners have nothing to browse — only direct links and assigned training.",
    "itemCount_one": "{count} course",
    "itemCount_other": "{count} courses",
    "notInNav": "not in the menu",
    "broken": "A reference no longer exists; this catalogue shows nothing.",
    "deleteAnyway": "Delete anyway",
    "name": "Name ({language})",
    "slug": "Address",
    "slugHelp": "The part after /catalog/ in the link. Lowercase letters, digits and hyphens. Change it and shared links to this page stop working.",
    "statusLabel": "Status",
    "inMainNav": "Show in the menu",
    "inMainNavHelp": "Off means: reachable by link, but not in the sidebar.",
    "showWhenEmpty": "Show when it holds nothing",
    "showWhenEmptyHelp": "By default a catalogue leaves the menu as soon as it holds nothing for that person. Empty is per person: what one sees, another need not.",
    "visibilityMode": "Who may open this page",
    "accessGroup": "Access group",
    "pickAccessGroup": "Pick a group…",
    "viewMode": "What the list shows",
    "defaultLayout": "Starting view",
    "imageRatio": "Image ratio",
    "imageRatioHelp": "Decides how images are cropped. The list view keeps the same ratio as the cards.",
    "status": {
      "concept": "Draft",
      "published": "Published",
      "inactive": "Inactive"
    },
    "visibility": {
      "everyone": "Everyone",
      "ruleset": "Only an access group"
    },
    "view": {
      "activities": "One entry per training",
      "occurrences": "Every scheduled run"
    },
    "layout": {
      "cards": "Cards",
      "list": "List"
    },
    "sections": {
      "identity": "Name and place",
      "identityHelp": "What the page is called and where it sits in the menu.",
      "content": "What goes in",
      "contentHelp": "Including brings trainings in, excluding keeps them out. A hand-picked exclusion beats everything; a hand-picked training survives a rule that would filter it out.",
      "access": "Who may open the page",
      "accessHelp": "This is about the page, not the trainings in it. Whoever may open a training by direct link may still do so without being able to open this catalogue.",
      "presentation": "Presentation",
      "presentationHelp": "How the page looks. Learners may switch between cards and list themselves."
    },
    "membership": {
      "field": "On what",
      "values": "Which values",
      "otherCatalog": "Which catalogue",
      "pickCatalog": "Pick a catalogue…",
      "allHint": "Everything this environment has.",
      "addCondition": "Add condition",
      "removeCondition": "Remove condition",
      "removeTerm": "Remove",
      "kind": {
        "all": "Everything",
        "rule": "Rule",
        "catalog": "Another catalogue"
      },
      "branch": {
        "include": "In here",
        "exclude": "Kept out of here"
      },
      "branchHint": {
        "include": "A training goes in if at least one of these says so.",
        "exclude": "And comes back out if one of these catches it — unless you added it by hand."
      },
      "add": {
        "rule": "Rule",
        "catalog": "Catalogue",
        "all": "Everything"
      }
    },
    "preview": {
      "title": "What is in it",
      "help": "Two modes. What is in it shows the selection regardless of who is looking and regardless of status — that is what you configure. As a learner sees it runs everything through every gate with your rights, and as a manager you see more than a learner does.",
      "holds": "What is in it",
      "asLearner": "As a learner sees it",
      "hint": {
        "holds": "The selection, regardless of status and of who is looking.",
        "learner": "Through every gate, with your rights. As a manager you see more than a learner."
      },
      "count_one": "{count} course",
      "count_other": "{count} courses",
      "empty": "Nothing yet. Add a rule or a training.",
      "broken": "A reference in the selection no longer exists, so this catalogue shows nothing.",
      "saveFirst": "Save the catalogue first; then you will see what is in it.",
      "term": "term {n}",
      "rung": {
        "1": "taken out by hand",
        "2": "added by hand",
        "3": "excluded by a rule",
        "4": "through a rule",
        "5": "no rule includes it"
      }
    },
    "fields": {
      "type": "Kind",
      "composition": "Composition",
      "tracking_mode": "Tracked",
      "learning_form_category": "Learning form",
      "language": "Language",
      "theme": "Category"
    },
    "onActivity": {
      "heading": "Which catalogs is this in?",
      "membershipOnly": "This is about the selection only. Whether a participant also sees the course depends on its status, its audience and whether the material is available.",
      "noCatalogs": "This environment has no catalogs yet.",
      "inside": "In ({count})",
      "insideNone": "In no catalog.",
      "outside": "Not in ({count})",
      "outsideNone": "In every catalog.",
      "brokenCatalog": "This catalog points at something that no longer exists."
    },
    "defaultSort": "Default sorting",
    "defaultSortHelp": "What the list starts with. If a visitor picks a different sorting, theirs wins — this setting is a starting point, not a constraint.",
    "shownFacets": "Which filters are shown",
    "shownFacetsHelp": "This decides which filters are visible, not what the catalog contains. A hidden filter still works through a shared link; what belongs in the catalog is set under its content.",
    "shownFacetsEmpty": "Tick everything for the default: all filters.",
    "facet": {
      "type": "Type",
      "composition": "Form",
      "tracking_mode": "Kind",
      "category": "Category (free text on the course)",
      "theme": "Category (managed)",
      "language": "Language"
    }
  },
  "cancellationPolicies": {
    "heading": "Cancellation terms",
    "intro": "Reusable sets for cancelling: a deadline before the start, and for each side who may cancel and what it costs. A new activity gets the default; an occurrence can choose another.",
    "new": "New terms",
    "editTitle": "Edit terms",
    "view": "View",
    "empty": "No cancellation terms yet. The first one you create becomes the default.",
    "makeDefault": "Make default",
    "defaultBadge": "Default",
    "usage_one": "Chosen for {count} activity or occurrence",
    "usage_other": "Chosen for {count} activities and occurrences",
    "confirmDelete": "Delete terms?",
    "confirmDeleteBody": "\"{name}\" will be deleted. They are not used anywhere.",
    "summary": "{deadline} · before: {before} · after: {after}",
    "deadlineSameDay": "deadline on the start day",
    "deadlineDays_one": "deadline {count} day before",
    "deadlineDays_other": "deadline {count} days before",
    "cost": {
      "none": "free of charge"
    },
    "costType": {
      "none": "Free of charge",
      "fixed": "Fixed amount"
    },
    "side": {
      "before": "Before the deadline",
      "after": "After the deadline",
      "beforeHelp": "What applies up to and including the day of the cancellation deadline.",
      "afterHelp": "What applies after the cancellation deadline, until the start. An administrator can always cancel, even where it is not allowed here."
    },
    "section": {
      "general": "General",
      "texts": "Text for the learner"
    },
    "textsHelp": "The learner reads this text with the activity, in their own language. A language without text falls back to the language of the environment.",
    "fields": {
      "name": "Name",
      "deadlineDays": "Cancellation deadline (days before the first day)",
      "deadlineDaysHelp": "The cancellation deadline of an occurrence is its first day minus this number of calendar days; 0 is the start day itself. The date can be set by hand per occurrence.",
      "isDefault": "Default for new activities",
      "mode": "Who cancels",
      "costType": "Costs",
      "amount": "Amount (€)",
      "textIn": "Text ({language})"
    }
  },
  "cancellationTerms": {
    "line": {
      "untilStart": {
        "selfFree": "Free cancellation until the start",
        "selfFixed": "Cancelling costs {amount}",
        "approvalFree": "Cancel until the start, with approval",
        "approvalFixed": "Cancel until the start for {amount}, with approval",
        "notAllowed": "You cannot cancel yourself"
      },
      "before": {
        "selfFree": "Free cancellation up to and including {date}",
        "selfFixed": "Cancelling up to and including {date} costs {amount}",
        "approvalFree": "Cancel up to and including {date}, with approval",
        "approvalFixed": "Cancel up to and including {date} for {amount}, with approval",
        "notAllowed": "No cancellation up to and including {date}"
      },
      "after": {
        "selfFree": "free of charge after that",
        "selfFixed": "{amount} after that",
        "approvalFree": "after that cancel, with approval",
        "approvalFixed": "after that cancel for {amount}, with approval",
        "notAllowed": "no cancellation after that"
      },
      "combined": "{before}, {after}"
    },
    "window": {
      "before": "You are cancelling before the cancellation date ({date}).",
      "after": "The cancellation date ({date}) has passed.",
      "costNow": "Cancelling now costs {amount}.",
      "free": "Cancelling is free of charge now.",
      "followsRequest": "A decision on your request is still to be made. These costs also apply if that happens later."
    }
  },
  "contentLanguages": {
    "intro": "The languages in which you can offer trainings, their material and sessions. This is separate from the languages of the system itself.",
    "legend": "Content languages",
    "legendHelp": "A training has its texts per content language, a session is given in one of these languages and the material can differ per language. The catalogue’s language filter shows these languages.",
    "pick": "Languages",
    "pickPlaceholder": "Search for a language…",
    "default": "Default content language",
    "defaultHelp": "You write a training in this language first; the other languages are translations. Anyone using the system in a language that is not a content language gets this one. If you choose a different default, the existing texts in the default language will from then on count as texts in the new one.",
    "interface": "Languages of the system, set by BCS: {languages}.",
    "required": "Choose at least one content language.",
    "saved": "The content languages have been saved.",
    "saveFailed": "Saving failed. Please try again.",
    "defaultCannotBeRemoved": "You cannot remove the default content language. Choose another default first and save it.",
    "removeConfirm": {
      "title": "Remove content language?",
      "body": "After saving, the language disappears from the text tabs and the catalogue.",
      "used": "{language}: {activities}, {occurrences} and {questionnaires}.",
      "unused": "{language}: nothing uses this language yet.",
      "activities_one": "{count} activity",
      "activities_other": "{count} activities",
      "occurrences_one": "{count} session",
      "occurrences_other": "{count} sessions",
      "questionnaires_one": "{count} questionnaire",
      "questionnaires_other": "{count} questionnaires",
      "kept": "The texts are kept: if you turn the language back on later, they are there again.",
      "countFailed": "The count could not be loaded. You can still continue; the texts are kept.",
      "confirm": "Remove and save"
    }
  },
  "documentSettings": {
    "heading": "Certificates",
    "intro": "How the certificate number starts. An activity only gets a certificate once you choose a template for it.",
    "saveFailed": "Saving failed.",
    "saved": "Saved.",
    "prefix": "Certificate number prefix",
    "prefixHelp": "The start of every certificate number, for example ACME in ACME-2026-000123. Empty means the short name of the environment. A new prefix only applies to new certificates.",
    "prefixExample": "A number looks like this: {number}",
    "showPlatformTemplates": "Show BCS templates",
    "showPlatformTemplatesHelp": "BCS provides example templates. If you hide them, they disappear from the lists; where one is already chosen, it keeps making certificates.",
    "platformTemplatesOff": "BCS has switched off the BCS templates for this environment: no new BCS copies will be added.",
    "toLibrary": "Manage templates"
  },
  "certificates": {
    "failed": {
      "title": "Certificates that could not be made",
      "intro": "Fix the data or the template, then click Try again. The completion itself stands; meanwhile the participant sees that the certificate is still being made.",
      "retry": "Try again",
      "retried": "The certificate is being made again.",
      "retryFailed": "Trying again failed.",
      "emptyTitle": "All done",
      "emptyText": "There are no certificates that could not be made.",
      "fix": {
        "user": "Go to the person",
        "template": "Go to the template",
        "activity": "Go to the training"
      }
    },
    "failure": {
      "renderer_unavailable": "Creating the PDF was not available.",
      "timed_out": "Creating the PDF took too long.",
      "warnings": "The template gave a warning while creating the PDF.",
      "compile_error": "The template could not be processed.",
      "required_token_empty": "A required value is missing, for example the participant's name.",
      "unknown_field": "The template uses a field that no longer exists, for example a removed level of the organisation.",
      "does_not_fit": "A text does not fit on the certificate, even at the smallest font size.",
      "output_invalid": "The created PDF was not valid.",
      "source_rejected": "The template contains something that is not allowed.",
      "workspace_unsafe": "The working folder for creating the PDF was not safe."
    }
  },
  "documentTemplates": {
    "title": "Document templates",
    "intro": "The certificate templates of this environment, including the BCS templates: the environment got its own copy of those. Every publish makes a new version; old versions stay available to view and restore.",
    "showArchived": "Show archived",
    "platformOff": "The BCS templates are off in this environment.",
    "toSettings": "Go to Settings",
    "copyFailed": "The copy couldn't be made.",
    "emptyTitle": "No templates yet",
    "emptyText": "Turn on the BCS templates under Settings, or ask the administrator for a template.",
    "bcs": "BCS",
    "archived": "Archived",
    "archivedInUse": "Archived, and still chosen: certificates are still made with it.",
    "view": "View",
    "adjust": "Adjust",
    "edit": "Edit",
    "archive": "Archive",
    "restore": "Restore",
    "archiveTitle": "Archive {name}?",
    "archiveInUse": "{usage}. It keeps making certificates there; it just can't be chosen anew.",
    "archiveUnused": "The template isn't chosen anywhere. After archiving it can't be chosen; you can restore it.",
    "archiveFailed": "Archiving failed.",
    "copyName": "Copy of {name}",
    "usage": {
      "none": "Not chosen anywhere",
      "activities_one": "{count} training",
      "activities_other": "{count} trainings",
      "occurrences_one": "{count} occurrence",
      "occurrences_other": "{count} occurrences",
      "line": "Chosen for {parts}",
      "paths_one": "{count} learning path",
      "paths_other": "{count} learning paths"
    },
    "back": "Back to the templates",
    "noPresetEditor": "This template has no ready-made layout to adjust here.",
    "platformReadOnly": "A BCS template. You can view it; to adjust it, make your own copy.",
    "archivedNotice": "This template is archived. Where it's already chosen, it still makes certificates.",
    "section": {
      "general": "General",
      "logo": "Logo",
      "colors": "Colours",
      "texts": "Texts"
    },
    "name": "Name",
    "logo": {
      "label": "Logo",
      "bcs": "BCS logo",
      "tenant": "The environment's logo",
      "none": "No logo",
      "noTenantLogo": "This environment has no logo in its branding yet.",
      "upload": "Own logo",
      "file": "File",
      "fileHint": "PNG or JPG.",
      "uploaded": "Uploaded logo",
      "uploadFailed": "The logo could not be uploaded."
    },
    "colors": {
      "ink": "Text colour",
      "accent": "Accent colour",
      "hint": "Empty = the template's colour. Text needs enough contrast with white."
    },
    "texts": {
      "hint": "Empty = the template's text (grey in the field).",
      "tabWithErrors_one": "{locale} · {count} error",
      "tabWithErrors_other": "{locale} · {count} errors"
    },
    "elements": {
      "heading": "Heading",
      "intro": "Introduction",
      "holder": "Participant's name",
      "between": "Line in between",
      "training": "Training",
      "date_line": "Date and number",
      "issuer": "Issuer"
    },
    "preview": {
      "title": "Preview",
      "long": "Long values",
      "loading": "Making the preview…",
      "updated": "The preview has been updated.",
      "invalid": "First fix the errors in the form.",
      "invalidListed": "The preview appears once the errors listed with the form are fixed.",
      "frameTitle": "Preview: {title}",
      "download": "Download preview (PDF)",
      "fileName": "preview",
      "busy": "Many previews are being made right now. Try again shortly.",
      "concept": "Preview of the draft",
      "version": "Preview of version {version}",
      "notPdf": "The preview did not come back as a PDF and is not shown."
    },
    "tags": {
      "title": "Insert tags"
    },
    "unpublished": "Not published",
    "concept": "Draft",
    "version": "Version {version}",
    "kind": {
      "label": "Kind",
      "general": "General",
      "classroom": "Classroom",
      "learning_path": "Learning path",
      "hint": "Fixed once created. Classroom can name the trainer, the location and the dates (only for a training with sessions); learning path the completed parts (only for a learning path).",
      "help": "Classroom can name the trainer, the location and the dates (only for a training with sessions); learning path the completed parts (only for a learning path)."
    },
    "orientation": {
      "landscape": "Landscape",
      "portrait": "Portrait"
    },
    "adjustTitle": "Adjust {name}",
    "adjustBody": "You make your own copy, on the current version. The BCS template itself does not change.",
    "adjustConfirm": "Make a copy",
    "state": {
      "unpublished": "Not published yet: this template cannot be chosen anywhere.",
      "concept": "A draft is waiting. Certificates use the published version until you publish.",
      "live": "Published. Publish a draft to make a new version."
    },
    "notice": {
      "saved": "Draft saved.",
      "published": "Published. New certificates use this version.",
      "discarded": "Draft discarded.",
      "renamed": "The name has been saved.",
      "restored": "Version {version} is in the draft. The live version only changes when you publish."
    },
    "failed": {
      "save": "Saving failed.",
      "publish": "Publishing failed.",
      "upload": "The logo could not be uploaded."
    },
    "publishBlocked": "This cannot be published yet:",
    "previewBlocked": "The preview cannot be made yet:",
    "saveConcept": "Save draft",
    "publish": "Publish",
    "publishTitle": "Publish {name}?",
    "publishBody": "{usage}. New certificates use this version from now on; certificates already issued do not change.",
    "discard": "Discard draft",
    "discardTitle": "Discard the draft?",
    "discardBody": "The page then shows the live version again. This cannot be undone.",
    "update": {
      "noneTitle": "No new version",
      "noneText": "There is no new version waiting for this template.",
      "templates_one": "{count} own template",
      "templates_other": "{count} own templates",
      "title": "New version of {name}",
      "intro": "BCS has published version {to}. Until you take it over, new certificates stay on the old version.",
      "unchanged": "Certificates already issued do not change, whatever you choose.",
      "failed": {
        "conflict": "A newer version has appeared in the meantime. The page now shows it.",
        "busy": "Many certificates are being checked right now. Try again shortly.",
        "other": "That did not work."
      },
      "old": "Now: version {version}",
      "new": "New: version {version}",
      "dismiss": "Not now",
      "accept": "Take over",
      "appliesTo": "Applies to {parts}.",
      "partial": "{moved} own templates taken over, {skipped} not: they fail the checks on the new version."
    },
    "logoUpdate": {
      "noneTitle": "No new logo",
      "noneText": "The logo on certificates is the logo in the branding.",
      "title": {
        "changed": "New environment logo",
        "removed": "Environment logo removed"
      },
      "intro": {
        "changed": "The logo in the branding has been replaced. Until you take it over, new certificates keep the old one.",
        "removed": "The logo in the branding has been removed. Certificates keep the old logo until you choose no logo; choose another logo in the template."
      },
      "appliesTo_one": "Applies to {count} template with the environment logo.",
      "appliesTo_other": "Applies to {count} templates with the environment logo.",
      "old": "Now",
      "new": "New",
      "accept": {
        "changed": "Take over",
        "removed": "No logo any more"
      }
    },
    "open": "Open",
    "copy": "Copy",
    "fromBcs": "From BCS",
    "rename": "Save name",
    "copyTitle": "Copy {name}",
    "copyBody": "A new template with the same content. It is not published yet; the kind is fixed once it is made.",
    "copyConfirm": "Make copy",
    "originLine": "Copy of {name}, provided by BCS.",
    "editorComing": "You will edit a template’s content in the new editor. Until then, you can view, restore, publish and copy versions here.",
    "history": {
      "title": "History",
      "empty": "No versions yet: this template has never been published.",
      "caption": "The versions of {name}",
      "version": "Version",
      "when": "Published",
      "who": "By",
      "actions": "Actions",
      "live": "Live",
      "bcs": "BCS (version {version})",
      "unknown": "Unknown",
      "view": "View",
      "restore": "Restore",
      "viewing": "You are viewing version {version}.",
      "restoreTitle": "Restore version {version}?",
      "restoreBody": "This version goes into the draft. The live version only changes when you publish the draft.",
      "restoreOverConcept": "This version replaces the current draft. The live version only changes when you publish."
    },
    "bcsUpdate": {
      "acceptNotice": "BCS has released version {to} of this template. You have not changed it, so you can take it over as it is.",
      "review": "Review and take over",
      "fetchNotice": "BCS has released version {to} of this template. You changed it yourself: Fetch puts the new version in the draft, and you decide what goes live.",
      "fetch": "Fetch",
      "fetchTitle": "Fetch version {to} from BCS?",
      "fetchOverConcept": "The new BCS version replaces the current draft. The live version only changes when you publish.",
      "fetched": "The new BCS version is in the draft. The live version only changes when you publish.",
      "dismissed": "The template stays as it is. You will see this again with the next BCS version.",
      "conceptFrom": "The draft contains version {version} from BCS.",
      "intro": "BCS has released version {to}. Until you take it over, new certificates stay as they are now.",
      "old": "Live now: version {version}",
      "new": "New: version {version} from BCS"
    },
    "types": {
      "certificate": "Certificates",
      "agreement": "Agreements"
    },
    "typeLabel": {
      "agreement": "Agreement"
    },
    "agreementsEmptyTitle": "No agreements yet",
    "agreementsEmptyText": "Start an agreement template by copying the BCS example.",
    "regenerate": {
      "count_one": "{count} certificate issued with this version",
      "count_other": "{count} certificates issued with this version",
      "button": "Regenerate",
      "title": "Regenerate the certificates of version {version}?",
      "body": "Each certificate keeps its number and gets a new version with the current template and data. The old version is kept.",
      "confirm": "Regenerate",
      "fromTo_one": "From version {from} to version {to}: {count} certificate.",
      "fromTo_other": "From version {from} to version {to}: {count} certificates.",
      "unchanged": "Nothing changes in the template: this is the live version. Only changed data (such as a name) is updated.",
      "sameFields": "The same fields; the layout or wording of the template may differ.",
      "fieldAdded": "Added: {field}",
      "fieldRemoved": "Removed: {field}",
      "reason": "Reason",
      "reasonTooShort": "At least {min} characters.",
      "previewFailed": "Could not load what will change.",
      "failed": "Regenerating did not start.",
      "throttled": "Too many attempts: try again in a minute.",
      "nothingQueued": "Nothing to regenerate: these certificates are already queued.",
      "queued_one": "{count} certificate is queued to be regenerated.",
      "queued_other": "{count} certificates are queued to be regenerated.",
      "progress": "Regenerating, {handled} of {total}: {counts}.",
      "done": "Done: {counts}.",
      "counts": {
        "regenerated_one": "{count} regenerated",
        "regenerated_other": "{count} regenerated",
        "unchanged_one": "{count} unchanged",
        "unchanged_other": "{count} unchanged",
        "failed_one": "{count} failed",
        "failed_other": "{count} failed",
        "skipped_one": "{count} skipped",
        "skipped_other": "{count} skipped"
      },
      "toFailed": "To failed certificates"
    }
  },
  "documentEditor": {
    "title": "Edit template",
    "back": "Back to the template",
    "loadError": "The template could not be loaded.",
    "name": "Name",
    "nameTooLong": "At most {max} characters.",
    "neverPublished": "Draft, not published yet",
    "liveVersion": "Live: version {version}",
    "unsavedShort": "unsaved changes",
    "conceptSaved": "draft saved",
    "saveConcept": "Save draft",
    "publish": "Publish",
    "saved": "The draft has been saved.",
    "published": "Published as version {version}.",
    "unsaved": "There are changes that have not been saved yet. Leave anyway?",
    "busy": "The server is busy. Please try again shortly.",
    "throttled_one": "Just a moment: there were many saves in a short time. The editor will try again in {count} second; you can keep working.",
    "throttled_other": "Just a moment: there were many saves in a short time. The editor will try again in {count} seconds; you can keep working.",
    "throttledFailed": "Saving is not possible right now: there were too many saves in a row. Your changes are still here; try again in a minute.",
    "failed": "That did not work. Please try again.",
    "errorsTitle_one": "There is {count} issue to fix",
    "errorsTitle_other": "There are {count} issues to fix",
    "publishConfirm": {
      "title": "Publish this draft?",
      "body": "The draft becomes the new version. New certificates use this version from now on; certificates already issued do not change."
    },
    "locale": {
      "nl": "Dutch",
      "en": "English",
      "de": "German",
      "fr": "French"
    },
    "page": {
      "landscape": "Page, A4 landscape",
      "portrait": "Page, A4 portrait"
    },
    "flow": {
      "label": "Flowing text ({language})",
      "copyOfDutch": "This language has no text of its own yet and shows the Dutch. As soon as you change something, this language gets its own text.",
      "rejected": "The flowing text in this language contains something the editor does not know, so it is not shown or edited. When you save, the server says what is wrong."
    },
    "flowStart": {
      "label": "Flowing text starts at (mm)",
      "valueText": "{mm} mm below the top margin",
      "hint": "Below the top margin, from 0 to {max}."
    },
    "fields": {
      "heading": "Fields",
      "hint": "Drag a field into the text, or click to insert it at the cursor.",
      "error": "The fields could not be loaded.",
      "empty": "There are no fields for this kind.",
      "kind": {
        "general": "General",
        "classroom": "Classroom",
        "learning_path": "Learning path"
      },
      "scope": {
        "org": "Organisation",
        "context": "Completion",
        "global": "General",
        "link": "Links"
      }
    },
    "grid": {
      "group": "Grid",
      "show": "Grid",
      "snap": "Snap to grid",
      "snapHint": "Dragging and resizing jump to the 5 mm lines, and edges and the centre to the centre lines. Alt drags freely."
    },
    "history": {
      "group": "History",
      "undo": "Undo",
      "redo": "Redo",
      "undoShortcut": "Undo (Ctrl+Z)",
      "redoShortcut": "Redo (Ctrl+Y)",
      "undone": "Undone: {action}",
      "redone": "Redone: {action}",
      "kind": {
        "move": "move",
        "resize": "size",
        "add": "add block",
        "remove": "remove block",
        "style": "formatting",
        "text": "text",
        "orientation": "orientation",
        "reading": "reading order",
        "flowStart": "start of flowing text",
        "background": "background",
        "title": "document title",
        "image": "image",
        "furniture": "header and footer",
        "numbering": "numbering"
      }
    },
    "toolbar": {
      "label": "Formatting",
      "blockType": "Text style",
      "paragraph": "Paragraph",
      "heading": "Heading {level}",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "bulletList": "Bulleted list",
      "orderedList": "Numbered list",
      "alignLeft": "Align left",
      "alignCenter": "Centre",
      "alignRight": "Align right",
      "alignment": "Alignment",
      "quick": "Quick formatting"
    },
    "table": {
      "insertTitle": "Insert table",
      "rows": "Rows",
      "cols": "Columns",
      "headerRow": "Header row",
      "insert": "Insert",
      "toolbar": "Table",
      "rowBefore": "Row above",
      "rowAfter": "Row below",
      "colBefore": "Column left",
      "colAfter": "Column right",
      "toggleHeader": "Header row on/off",
      "deleteRow": "Delete row",
      "deleteCol": "Delete column",
      "delete": "Delete table"
    },
    "blocks": {
      "kind": {
        "text": "Text block {n}",
        "image": "Image {n}",
        "rect": "Rectangle {n}",
        "line": "Line {n}"
      },
      "textLabel": "{block}, text ({language})",
      "movedTo": "{block}: {x} mm from the left, {y} mm from the top.",
      "frameHint": "The arrow keys move the block 1 mm, Shift+arrow 10 mm. Delete removes it. Tab goes into the text to edit it.",
      "image": {
        "bcs-logo": "BCS logo",
        "tenant-logo": "Environment logo",
        "upload": "Own image",
        "library": "From the media library",
        "platform": "From the supplied set"
      },
      "removed": "The block has been removed.",
      "addLabel": "Add",
      "add_text": "Text block",
      "add_image": "Image",
      "add_rect": "Rectangle",
      "add_line": "Line",
      "add_table": "Table",
      "describe": {
        "text": "A box of text you place freely on the page, such as the title or the name. You can drag fields into it.",
        "image": "A logo, signature or other image from the media library, placed freely on the page.",
        "rect": "A rectangle, for example as a frame around the page. Decoration only.",
        "line": "A line, for example to sign on or as a divider. Decoration only.",
        "table": "A table in the flowing text, at the cursor, for example for a row of signatures.",
        "pageBreak": "What comes after the cursor starts on a new page.",
        "ref": "A reference to a numbered heading; the number follows along."
      },
      "rejected": "This text contains something the editor does not know.",
      "add_pageBreak": "Page break",
      "add_ref": "Reference",
      "skipped_one": "{count} block cannot be shown (it was stored damaged) and has been left out. It will be removed when you save.",
      "skipped_other": "{count} blocks cannot be shown (they were stored damaged) and have been left out. They will be removed when you save."
    },
    "inspector": {
      "remove": "Remove",
      "position": "Position and size",
      "x": "From left (mm)",
      "y": "From top (mm)",
      "width": "Width (mm)",
      "height": "Height (mm)",
      "textStyle": "Text",
      "role": "Type",
      "size": "Size (pt)",
      "weight": "Weight",
      "regular": "Regular",
      "align": "Alignment",
      "color": "Colour",
      "colorFormat": "A colour as #RRGGBB.",
      "image": "Image",
      "source": "Source",
      "layer": "Layer",
      "layerOnlyDecorative": "Only a decorative image can go behind the text.",
      "front": "In front of the text",
      "back": "Behind the text",
      "decorative": "Decorative (a screen reader skips it)",
      "alt": "Alt text ({language})",
      "shape": "Shape",
      "direction": "Direction",
      "horizontal": "Horizontal",
      "vertical": "Vertical",
      "stroke": "Line width (mm)",
      "strokeColor": "Line colour",
      "fill": "Fill",
      "fillColor": "Fill colour",
      "problems": "For this block",
      "noneHeading": "No block selected",
      "none": "Choose a block on the page or in the reading order to see its position, size and style.",
      "pickImage": "Choose from the media library…",
      "valign": "Vertical",
      "valign_top": "Align top",
      "valign_middle": "Align middle",
      "valign_bottom": "Align bottom"
    },
    "reading": {
      "hint": "A screen reader reads the page in this order.",
      "flow": "Flowing text",
      "up": "Move {name} up",
      "down": "Move {name} down",
      "reset": "Default order",
      "toggle": "Reading order ({count})",
      "moved": "{name} is now at position {position} of {count}."
    },
    "checks": {
      "heading": "Checks",
      "none": "No problems found. The preview checks the rest.",
      "severity": {
        "error": "Error",
        "warning": "Note"
      },
      "outside_margin": "Lies outside the {margin} mm margin.",
      "text_too_small": "The text is smaller than {min} pt.",
      "text_small": "The text is smaller than {warn} pt and therefore hard to read.",
      "overlap": "Overlaps {other}.",
      "low_contrast": "The text colour has too little contrast on white ({ratio}:1, at least 4.5:1).",
      "heading_first": "The first heading must be heading 1, not heading {level}.",
      "heading_skip": "Heading {level} skips a level; expected heading {expected}.",
      "alt_missing": "There is no alt text in Dutch.",
      "background_readability": "Check in the preview that all text is easy to read on the background.",
      "server": "At the last save",
      "ref_missing": "A reference points to a heading that does not exist or is not numbered.",
      "image_low_resolution": "This image is too small for this size: {dpi} dpi on paper, at least {min}. Use an image of at least {min_width} × {min_height} pixels.",
      "many_pages": "The preview has {pages} pages; more than 20 is long for an agreement."
    },
    "background": {
      "label": "Background",
      "placeholder": "Background",
      "none": "No background.",
      "current": "Now: {source}.",
      "pick": "Choose from the media library…",
      "remove": "No background"
    },
    "preview": {
      "heading": "Preview",
      "long": "Long name",
      "loading": "The preview is being made…",
      "updated": "The preview has been updated.",
      "updatedLong": "The preview has been updated, with a long name.",
      "failedStatus": "The preview could not be made.",
      "invalid": "The preview is waiting for the issues in the list at the top.",
      "failed": "The preview could not be made.",
      "frameTitle": "Preview of {title} ({language})",
      "download": "Download preview (PDF)",
      "fileName": "preview",
      "notPdf": "The preview did not come back as a PDF and is not shown."
    },
    "pdfTitle": {
      "label": "Document title ({language})",
      "hint": "Shown in the PDF properties; a screen reader reads it out."
    },
    "edit": "Edit",
    "orientation": {
      "label": "Orientation",
      "landscape": "Landscape",
      "portrait": "Portrait",
      "moved": "Check the blocks; they have been moved.",
      "undo": "Undo (Ctrl+Z) puts it back. It only changes the draft."
    },
    "text": {
      "heading": "Text"
    },
    "pages": {
      "estimate": "{count} page(s). The page breaks are an estimate; the preview below is the real one.",
      "real": "The preview has {count}."
    },
    "furniture": {
      "heading": "Header and footer",
      "header": "Header",
      "footer": "Footer",
      "logo": "Logo",
      "logoNone": "No logo",
      "logoPosition": "Logo position",
      "logoHeight": "Maximum height (mm)",
      "logoHeightRange": "Between {min} and {max} mm.",
      "headerText": "Header text ({language})",
      "footerText": "Footer text ({language})",
      "firstPageDifferent": "Different first page (the header starts on page 2)",
      "pageNumbers": "Page x of y is always shown next to it.",
      "pageOf": "Page {page} of {pages}",
      "position": {
        "left": "Left",
        "center": "Centre",
        "right": "Right"
      }
    },
    "pageBreaks": {
      "legend": "Page",
      "breakBefore": "Start on a new page",
      "keepTogether": "Keep together",
      "node": "Page break",
      "nested": "Not possible inside a list or table; only on a block of the flowing text itself."
    },
    "numbering": {
      "heading": "Numbering",
      "style": "Style of numbered headings",
      "none": "No numbering",
      "artikel": "Article 1, Article 1.1",
      "decimal": "1., 1.1",
      "hint": "Choose which headings count with Numbered in the Text panel.",
      "article": "Article",
      "articleInText": "article",
      "numbered": "Numbered",
      "refTitle": "Refer to",
      "refNone": "There is no numbered heading yet. Choose a numbering and turn on Numbered for a heading."
    }
  }
}
